export default {
  diet: {
    title: "Diets",
    buttonNewDiet: "New diet",
    table: {
      title: "Diets list",
      columns: {
        status: "Status",
        description: "Diet",
        phosphorus: "Phosporus (mg)",
        nitrogen: "Nitrogen (mg)",
        tdn: "TDN (g)",
        cp: "Crude Protein (g)",
        calcium: "Calcium (mg)",
        cost: "Cost (R$/Kg)",
      },
    },
    drawerTitle: "Diet Register",
    drawerTitleEdit: "Diet edition",
    drawerSubTitle: "Complete the fields below to create a new diet",
    drawerSubTitleEdit: "Complete the fields below to edit a new diet",
    validationMessage: "Fill in all required fields (*) correctly",
    form: {
      name: "Diet ID",
      namePlaceHolder: "Diet name",
      pasture: "Forage",
      pasturePlaceHolder: "What is the dietary forage?",
      pastureNoSelection: "None",
      supplements: "Supplem/Concent.",
      supplementsPlaceHolder:
        "What are the supplem/concentr inserted in the diet??",
      cost: "Diet Cost ($/Kg)",
      costPlaceHolder: "What is the cost of the diet in $/kg?",
      phosphorus: "Phosphorus (mg)",
      phosphorusPlaceHolder: "How much Phosphorus?",
      nitrogen: "Nitrogen (mg)",
      nitrogenPlaceHolder: "How much Nitrogen?",
      calcium: "Calcium (mg)",
      calciumPlaceHolder: "How much Calcium?",
      tdn: "TDN (g)",
      tdnPlaceHolder: "How much TDN?",
      cp: "Crude Protein (g)",
      cpPlaceHolder: "How much Crude Protein?",
      status: "Diet status",
      error: {
        requiredPastureSupplement: {
          title: "Error",
          message:
            "Either Forage or at least one Supplement/Concent. must be selected.",
        },
      },
    },
    saveOptions: {
      only_save: "Save",
      save_and_create_new: "Save and add new diet",
    },
  },
  pasture: {
    title: "Forage",
    buttonNewPasture: "New Forage",
    table: {
      title: "Forage list",
      columns: {
        status: "Status",
        description: "Forage",
        phosphorus: "Phosphorus (mg)",
        nitrogen: "Nitrogen (mg)",
        tdn: "TDN (g)",
        cp: "CP (g)",
        calcium: "Calcium (mg)",
        cost: "Cost ($/kg)",
        entryHeight: "Entry height",
        exitHeight: "Exit height",
        growthSpeed: "Growth rate",
        yield: "Yield",
      },
    },
    drawerTitle: "Forage Roster",
    drawerTitleEdit: "Edit Forage",
    drawerSubTitle: "Complete the fields below to create a new forage",
    drawerSubTitleEdit: "Complete the fields below to edit the forage",
    validationMessage: "Fill in all required fields (*) correctly",
    form: {
      groupFarmVisibility: "Who will use the forage?",
      name: "Forage Id",
      namePlaceHolder: "Forage name",
      pastureType: "Scientific name",
      fertilized: "Fertilized",
      notFertilized: "Not fertilized",
      cost: "Cost",
      costPlaceHolder: "Unit: $",
      cp: "CP: Crude Protein",
      cpPlaceHolder: "Unit: g",
      fdn: "NDF: Neutral detergent fiber",
      fdnPlaceHolder: "Unit: %",
      tdn: "TDN: Total Digestible Nutrients",
      tdnPlaceHolder: "Unit: g",
      phosphorus: "Phosphorus",
      phosphorusPlaceHolder: "Unit: g/kg",
      nitrogen: "Nitrogen",
      nitrogenPlaceHolder: "Unit: mg/kg",
      calcium: "Calcium",
      calciumPlaceHolder: "Unit: g/kg",
      zinc: "Zinc",
      zincPlaceHolder: "Unit: mg/kg",
      sodium: "Sodium",
      sodiumPlaceHolder: "Unit: g/kg",
      formation: "Full growth",
      formationPlaceHolder: "Unit: days",
      rest: "Resting",
      restPlaceHolder: "Unit: days",
      entryHeight: "Optimal Grazing Height",
      entryHeightPlaceHolder: "Unit: cm",
      exitHeight: "Optimal Rest Height",
      exitHeightPlaceHolder: "Unit: cm",
      growthRate: "Growth rate",
      growthRatePlaceHolder: "Unit: kg/ha/day",
      leafDensityProduction: "Forage Dry Matter Production",
      leafDensityProductionPlaceHolder: "Unit: t/ha/cycle",
      growthSpeed: "Growth rate",
      growthSpeedPlaceHolder: "Unit: kg MS/㎡/day",
      yield: "Yield",
      yieldPlaceHolder: "Unit: kg DM/㎡",
      status: "Forage status",
      nutritionalData: "NUTRITIONAL DATA",
      capacity: "Capacity",
      maximumConsumption: "Max consumption",
      minimumConsumption: "Min consumption",
      radiogroup: {
        farm: "Only for this farm",
        group: "To all farms in the group",
      },
      fda: "ADF",
      lignin: "Lignin",
      ee: "Ether extract",
      maximumHeight: "Max Height",
      maximumHeightPlaceHolder: "Max Height",
    },
    modal: {
      confirmation: {
        title: "Changing the Forage Type",
        message:
          "AWhen you confirm the change of the forage type, the values for ideal entry height, ideal exit height and weather stations will be changed. Do you want to continue?",
        confirmButton: "Confirm",
        cancelButton: "Cancel",
      },
    },
    errorConsumptionMaximumLessThanMinimum:
      "Maximum consumption must be greater than minimum consumption",
    errorEntryHeightLessThanExitEntryHeight:
      "The optimal grazing height should be greater than the optimal resting height",
    errorNecessaryOneSeason:
      "It is necessary to have at least one weather station informed",
    errorFertilizedSeasonInfoIncomplete:
      "Report or keep pending data on fertilized forage in all climate seasons",
    errorUnfertilizedSeasonInfoIncomplete:
      "Report or keep pending data on non-fertilized forage in all climate seasons",
    errorPastureInfoForAllSeasonsIncomplete:
      "Report or keep pending data on fertilized/non-fertilized forage in all climate seasons",
    saveOptions: {
      only_save: "Save",
      save_and_create_new: "Save and add a new one",
    },
  },
  breed: {
    title: "Breeds",
    buttonNewBreed: "New breed",
    table: {
      title: "List of breeds",
      columns: {
        status: "Status",
        geneticGroup: "Genetic group",
        description: "Descrption",
        name: "Breed",
        asymptoticWeight: "Sigmoid weight(kg)",
        estimatedMaximumAge: "Sigmoid age",
        correctionFactor: "Correction Factor",
        maturationRate: "Maturation Rate",
      },
      menu: {
        parameters: "Parameters",
      },
    },
    drawerTitle: "Breed Register",
    drawerTitleEdit: "Edit Breed",
    drawerSubTitle: "Complete the fields below to create a new breed",
    drawerSubTitleEdit: "Complete the fields below to edit the breed",
    validationMessage: "Fill in all required fields (*) correctly",
    form: {
      name: "Breed Id",
      namePlaceHolder: "Breed name",
      description: "Description",
      descriptionPlaceHolder: "Breed description",
      geneticGroup: "Genetic group",
      geneticGroupPlaceHolder: "Select the genetic group",
      status: "Breed status",
    },
    saveOptions: {
      only_save: "Save",
      save_and_create_new: "Save and create a new one",
      save_and_add_parameters: "Save and configure parameters",
    },
    drawerParametersTitle: "Breed parameters",
    formParameters: {
      asymptoticWeight: "Sigmoid weight",
      asymptoticWeightPlaceHolder: "Set the weight",
      theoricalCurve: "Theoretical curve",
      estimatedMaximumAge: "Sigmoid age",
      estimatedMaximumAgePlaceHolder: "Sigmoid age",
      correctionFactor: "Correction Factor",
      correctionFactorPlaceHolder:
        "Correction Factor for calculating the growth curve for the breed",
      maturationRate: "Maturation Rate",
      maturationRatePlaceHolder:
        "Maturation Rate for calculating the growth curve for the breed",
      status: "Breed Parameter Status",
      extimatedCurveTitle: "ESTIMATED GROWTH CURVE",
      genetic: "GENETICS",
      diet: "DIET",
      gestationDivider: "Gestation period",
      minGestationTime: "Min",
      medGestationTime: "Avg",
      maxGestationTime: "Max",
    },
  },
  handlingOperation: {
    title: "Operations",
    buttonNewPasture: "New operation",
    table: {
      title: "Operations list",
      columns: {
        status: "Status",
        operation: "Operation",
        action: "Action",
      },
    },
    drawerTitle: "Operations Roster",
    drawerTitleEdit: "Edit Operation",
    drawerSubTitle: "Complete the fields below to create a new Operation",
    drawerSubTitleEdit: "Complete the fields below to edit the operation",
    validationMessage: "Fill in all required fields (*) correctly",
    form: {
      name: "Operation",
      namePlaceHolder: "Operation name",
      action: "Action",
      actionPlaceHolder: "Select procedure action",
      recurrence: "Recurrence",
      recurrenceAmount: "Qty.",
      quarantine: "Quarantine",
      quarantineAmount: "Enter the number of days",
      breed: "Breed",
      breedPlaceHolder: "Select breeds",
      gender: "Gender",
      genderPlaceHolder: "Select",
      age: "Age",
      weight: "Weight",
      dontExecuteOperation:
        "Do not perform the operation on animals that are in:",
      inQuarantine: "Quarantine",
      inPregnancy: "Pregnancy",
      operationCost: "Operation cost",
      noCost: "No cost",
      haveCost: "Cost(define the cost in the procedure)",
      status: "Operation status",
    },
    parameters: "PARAMETERS",
    limitations: "LIMITS",
    errors: {
      recurrenceMinAndMaxDayCanBeNull: {
        title: "Error",
        message:
          "The minimum and maximum number of days for the recurrence cannot be blank.",
      },
      recurrenceQtdCanBeNull: {
        title: "Error",
        message: "The number of times the recurrence occurs cannot be blank.",
      },
    },
    saveOptions: {
      only_save: "Save",
      save_and_create_new: "Save and add a new Operation",
    },
  },
  handling: {
    title: "Livestock Husbandry",
    tabs: {
      pending: "In Process",
      finalized: "Finished",
      dietStrategies: "Diet Strategies",
      vacinations: "Veterinary proced",
      handlingReproduction: "Reproduction",
      animalWeightHistory: "Weighings and Measurements",
      picketSupplementSupply: "Suuplied",
      troughFeedingAssessment: "Food Intake Assessment",
    },
    vacinations: {
      buttonNew: "New Injection",
      form: {
        titleEdit: "Edit Injection",
        titleCreateNew: "New Injection",
        dividerTitle: "Previous Injection",
        animalId: "Animal",
        lastDailyWeight: "Last weighing",
        handlingNumber: "Animal",
        veterinarySupplementId: "Product",
        veterinarySupplementApplicationType: "Administration type",
        veterinarySupplementApplicationValue: "Dosage",
        applicationQuantity: "Amount injected",
        applicationUnit: "Unit",
        applicationDay: "Injection date",
      },
      table: {
        title: "Veterinary",
        columns: {
          animalName: "Animal",
          veterinarySupplementName: "Name",
          type: "Type",
          applicationDate: "Date",
          applicationQuantity: "Quantity",
          applicationUnit: "Unit",
          last_weight: "Last Weight",
          last_weight_date: "Last Weight Date",
          last_comment: "Last Comment",
          last_comment_date: "Last Comment Date",
        },
      },
    },
  },
  payments: {
    title: "Payments",
    ui: {
      monthlyMovementTitle: "Track your monthly movement",
      invoiceDescriptionTitle: "Invoice description",
      valuePrefix: "Amount",
      viewBoleto: "View Boleto",
      sendByEmail: "Send by Email",
      secondCopy: "2nd Copy",
      paymentMethodTitle: "How would you prefer to pay?",
      newCreditCard: "New credit card",
      boleto: "Bank Slip",
      changeDueDateTitle: "Change due date",
      currentDueDatePrefix: "Your invoice currently expires on",
      dueDatePlaceholder: "Enter the due date",
      creditCardTitle: "Credit Card",
      cardHolderName: "Cardholder name",
      cardNumber: "Card Number",
      cardExpiryDate: "Expiration date",
      cardSecurityCode: "Security code",
      periodFrom: "From",
      bovexoServices: "Services related to BovExo",
      cardLastDigitsPrefix: "Ending:",
      noInvoicesAvailable: "No invoices available",
    },
    messages: {
      holderNameRequired: "Cardholder name is required.",
      invalidCPF: "Invalid CPF.",
      invalidCardNumber: "Invalid card number.",
      invalidExpirationDate: "Invalid expiration date.",
      invalidSecurityCode: "Invalid security code.",
      paymentMethodUpdated: "Payment method updated successfully",
      invalidCardData: "Invalid card data",
      paymentMethodError: "An error occurred while updating the payment method",
      dueDayUpdated: "Due date updated successfully",
      dueDayError: "An error occurred while updating the due day",
    },
  },
  parameters: {
    title: "Parameters",
    tabs: {
      general: "General",
      breed: "Breeds",
      diet: "Diets",
      supplement: "Suplem./Concent.",
      pasture: "Forage",
      alert: "Alerts",
      benchmark: "Benchmarks",
      marketAnalysis: "Price curve",
      cost: "Costs",
      activity: "Activities",
      boitelPrice: "Boitel - Daily Rates",
      integration: "Integrations",
      financial: "Financial/Costs",
      reproduction: "Reproduction",
      reproductionParameter: "Parameters",
      semen: "Semen",
      inseminators: "Technician",
      supplie: "Inputs",
      animal: "Animals",
      deathReasons: "Cause Mortis",
      unit: "Units",
      veterinary: "Veterinary",
      commercialization: "Comercialization",
      quota: "Quotas",
      multipleBull: "Multiple Bull",
      reproductiveProtocol: "Protocols",
      feedFactory: "Feed Factory",
      handlingParameters: "Husbandry",
      farmDayScaleTreatmentParameter: "Feeding schedule",
      farmReadFeederTreatmentParameter: "Food Intake Assessment",
      wagonAutomation: "Mixer",
      ageRange: "Age Range",
      handlingAlerts: "Handling Alerts",
      measurement: "Measurements",
      stock: "Stock",
      others: "Others",
    },
  },
  boitelPrice: {
    title: "Boitel - Daily Rate",
    buttonNew: "New",
    table: {
      title: "Boitel - Daily Rate",
      columns: {
        name: "Name",
        farmName: "Farm name",
        validity: "Valid thru",
        status: "Status",
      },
    },
  },
  integrationPartners: {
    table: {
      title: "Integrations",
      columns: {
        status: "Status",
        system: "System",
        authType: "Authentication type",
      },
    },
    authType: {
      Token: "Token",
      UserAndPassword: "User and password",
      UserAndPasswordAndCompany: "User and password and company",
      ApiKey: "API Key",
    },
  },
  imports: {
    title: "Imported files",
    tabs: {
      animal: "Animals",
      weight: "Weighings and Measurements",
      supplement: "Supplements",
      financialTransactions: "Financial entries",
      animalCoverages: "Coverages and DG's",
      suppliersClients: "Suppliers/Clients",
      animalBirths: "Births and Losses",
      vaccinations: "Vaccinations",
      picketSupplementSupplyFeedReader: "Supply/Feed Reading",
    },
    status: {
      queue: "Waiting",
      processing: "In process",
      processed: "Finished",
      deleting: "Erasing",
      error: "Error",
    },
    animal: {
      buttonImport: "Import",
      table: {
        title: "List of Animal Imports",
        columns: {
          status: "Status",
          fileName: "File",
          date: "Date",
          total: "Total",
          numberImported: "Imported",
          numberAlerted: "Alerts",
          numberError: "Errors",
          numberDuplicated: "Duplicate",
          numberUpdated: "Updated",
          message: "Message",
        },
      },
      details: {
        breadCumbsImportLog: "Importings",
        breadCumbsImportLogDetails: "Data Import Details",
        collapseAnimals: "Animals",
        fileNameTitle: "File",
        statusTitle: "Status",
        dateTitle: "Date",
        table: {
          columns: {
            rowNumber: "Excel row",
            handlingNumber: "Animal Id",
            message: "Reason",
            alert: "Alerts",
          },
        },
      },
    },
    weight: {
      buttonImport: "Import",
      table: {
        title: "List of Weighing and Measurement Imports",
        columns: {
          status: "Status",
          fileName: "File",
          date: "Date",
          total: "Total",
          numberImported: "Imported",
          numberError: "Errors",
          numberDuplicated: "Duplicate",
          numberUpdated: "Updated",
          message: "Message",
        },
      },
      details: {
        breadCumbsImportLog: "Importings",
        breadCumbsImportLogDetails: "Data Import Details",
        collapseAnimals: "Weighings",
        fileNameTitle: "File",
        statusTitle: "Status",
        dateTitle: "Date",
        table: {
          columns: {
            rowNumber: "Excel row",
            weight: "Weight",
            handlingNumber: "Animal Id",
            aol: "AOL",
            aol100Kg: "AOL/100Kg",
            ratio: "RATIO",
            marmoreio: "MARBLING",
            egs: "BFT",
            message: "Reason",
          },
        },
      },
    },
    supplement: {
      buttonImport: "Import",
      table: {
        title: "List of Supplement Imports",
        columns: {
          status: "Status",
          fileName: "File",
          date: "Date",
          total: "Total",
          numberImported: "Imported",
          numberError: "Errors",
          numberDuplicated: "Duplicate",
          numberUpdated: "Updated",
          message: "Message",
        },
      },
      details: {
        breadCumbsImportLog: "Imports",
        breadCumbsImportLogDetails: "Data Import Details",
        collapseAnimals: "Supplements",
        fileNameTitle: "File",
        statusTitle: "Status",
        dateTitle: "Date",
        table: {
          columns: {
            rowNumber: "Excel row",
            name: "Supplement Id",
            message: "Reason",
          },
        },
      },
    },
    picketSupplementSupplyFeedReader: {
      buttonImport: "Import",
      table: {
        title: "List of Supply and Feed Reading Imports",
        columns: {
          status: "Status",
          fileName: "File",
          date: "Date",
          total: "Total",
          numberImported: "Imported",
          numberError: "Errors",
          numberDuplicated: "Duplicate",
          numberUpdated: "Updated",
          message: "Message",
        },
      },
      details: {
        breadCumbsImportLog: "Importings",
        breadCumbsImportLogDetails: "Data Import Details",
        collapseImported: "Imported",
        collapseNotImported: "Not Imported",
        records: "records",
        fileNameTitle: "File",
        statusTitle: "Status",
        dateTitle: "Date",
        types: {
          supply: "Supply",
          feedReader: "Feed Reading",
          supplyAndFeedReader: "Supply and Feed Reading",
        },
        table: {
          columns: {
            rowNumber: "Excel row",
            picket: "Picket/Pen",
            date: "Date",
            type: "Type",
            message: "Reason",
            alert: "Alerts",
          },
        },
      },
    },
    suppliersClients: {
      buttonImport: "Import",
      table: {
        title: "List of Suppliers/Clients Imports",
        columns: {
          status: "Status",
          fileName: "File",
          date: "Date",
          total: "Total",
          numberImported: "Imported",
          numberError: "Errors",
          numberDuplicated: "Duplicate",
          numberUpdated: "Updated",
          message: "Message",
        },
      },
      details: {
        breadCumbsImportLog: "Importings",
        breadCumbsImportLogDetails: "Data Import Details",
        collapseAnimals: "Suppliers/Clients",
        fileNameTitle: "File",
        statusTitle: "Status",
        dateTitle: "Date",
        table: {
          columns: {
            rowNumber: "Excel row",
            name: "Supplier/Client Name",
            message: "Reason",
          },
        },
      },
    },
    financialTransactions: {
      buttonImport: "Import",
      table: {
        title: "List of Financial Transaction Imports",
        columns: {
          status: "Status",
          fileName: "File",
          date: "Date",
          total: "Total",
          numberImported: "Imported",
          numberError: "Errors",
          numberDuplicated: "Duplicate",
          numberUpdated: "Updated",
          message: "Message",
        },
      },
      details: {
        breadCumbsImportLog: "Imports",
        breadCumbsImportLogDetails: "Import Details",
        collapseAnimals: "Financial posting",
        fileNameTitle: "File",
        statusTitle: "Status",
        dateTitle: "Date",
        table: {
          columns: {
            rowNumber: "Excel row",
            name: "Financial Posting Id",
            message: "Reason",
          },
        },
      },
    },
    animalCoverages: {
      buttonImport: "Import",
      table: {
        title: "Coverage Import List and DG's",
        columns: {
          status: "Status",
          fileName: "File",
          date: "Date",
          total: "Total",
          numberImported: "Imported",
          numberError: "Errors",
          numberDuplicated: "Duplicated",
          numberUpdated: "Updated",
          message: "Message",
        },
      },
      details: {
        breadCumbsImportLog: "Imports",
        breadCumbsImportLogDetails: "Import Details",
        collapseAnimals: "Coverages and DG's",
        fileNameTitle: "File",
        statusTitle: "Status",
        dateTitle: "Date",
        table: {
          columns: {
            rowNumber: "Excel Row",
            name: "Coverage Identification",
            message: "Reason",
          },
        },
      },
    },
    animalBirths: {
      buttonImport: "Import",
      table: {
        title: "List of Births and Losses Imports",
        columns: {
          status: "Status",
          fileName: "File",
          date: "Date",
          total: "Total",
          numberImported: "Imported",
          numberError: "Errors",
          numberDuplicated: "Duplicate",
          numberUpdated: "Updated",
          message: "Message",
        },
      },
      details: {
        breadCumbsImportLog: "Imports",
        breadCumbsImportLogDetails: "Import Details",
        collapseAnimals: "Births and Losses",
        fileNameTitle: "File",
        statusTitle: "Status",
        dateTitle: "Date",
        table: {
          columns: {
            rowNumber: "Excel Row",
            handlingNumber: "Animal Id",
            message: "Reason",
            alert: "Alerts",
          },
        },
      },
    },
    vaccinations: {
      buttonImport: "Import",
      table: {
        title: "List of Vaccination Imports",
        columns: {
          status: "Status",
          fileName: "File",
          date: "Date",
          total: "Total",
          numberImported: "Imported",
          numberError: "Errors",
          numberDuplicated: "Duplicate",
          message: "Message",
        },
      },
      details: {
        breadCumbsImportLog: "Imports",
        breadCumbsImportLogDetails: "Import Details",
        imported: "Imported",
        notImported: "Not Imported",
        vaccinations: "vaccinations",
        fileNameTitle: "File",
        statusTitle: "Status",
        dateTitle: "Date",
        table: {
          columns: {
            rowNumber: "Excel Row",
            animalName: "Animal",
            veterinarySupplementName: "Vaccine/Medicine",
            applicationDate: "Application Date",
            applicationQuantity: "Quantity",
            message: "Reason",
            alert: "Alerts",
          },
        },
      },
    },
  },
  benchmark: {
    title: "Benchmarks",
    buttonNewBenchmark: "New benchmark",
    table: {
      title: "Benchmarks List",
      columns: {
        status: "Status",
        description: "Benchmark",
      },
    },
    drawerTitle: "Benchmark Roster",
    drawerTitleEdit: "Edit Benchmark",
    drawerSubTitle: "Complete the fields below to register a new benchmark",
    drawerSubTitleEdit: "Complete the fields below to edit a new benchmark",
    validationMessage: "Fill in all required fields (*) correctly",
    form: {
      name: "Name",
      namePlaceHolder: "Identification",
      status: "Benchmark status",
      groupFarmVisibility: "Who will view the benchmark?",
      radiogroup: {
        farm: "This farm only",
        group: "All farms in the Group",
      },
      harvestDivider: "Harvesting year",
    },
    errorAtLeastOneKPIValue:
      "Enter at least one value for any Indicators(KPIs)",
    saveOptions: {
      only_save: "Save",
      save_and_create_new: "Save benchmark and add a new one",
    },
  },
  marketAnalysis: {
    title: "Price Curve",
    buttonNewMarketAnalysis: "New Price Curve",
    table: {
      title: "Price Curves List",
      columns: {
        status: "Status",
        type: "Type",
        description: "Name",
        baseline: "Default",
      },
    },
    type: {
      bovexo: "BovExo",
      progressive: "Progressive",
      linear: "Linear",
      free: "Free",
    },
  },
  feedFactoryParameters: {
    errorLoad: "Error loading the Feed Factory parameters.",
    errorSave: "Error saving the Feed Factory parameters.",
    successSave: "Feed Factory parameters saved successfully.",
    form: {
      useFullMixerCapacity: "Use full mixer capacity",
      defaultWagon: "Default mixer",
      standardCostPerBatch: "Fixed cost per batch",
      perBatch: "/batch",
    },
  },
  feedFactory: {
    tabs: {
      rawMaterials: "Raw Materials",
      supplements: "Recipes",
      productionOrders: "Prod. Orders",
      production: "Production",
      feedingAutomation: "Feeding Automation",
    },
    buttonNewRawMaterial: "New Raw Material",
  },
  feedingAutomation: {
    emptyText:
      "No manufacture received from the feeding automation in the selected period.",
    filters: { period: "Period" },
    situation: {
      open: "Open",
      finished: "Finished",
      cancelled: "Cancelled",
    },
    launchType: { automatic: "Automatic", manual: "Manual" },
    stockStatus: {
      Pending: "Waiting",
      Processing: "Processing",
      Applied: "In stock",
      AppliedWithoutBalance: "Negative balance",
      Blocked: "Pending",
      Reversed: "Reversed",
    },
    stockStatusHelp: {
      Pending:
        "The ingredient exit and the ration entry have not been created yet.",
      Applied:
        "The ingredients have left the stock and the ration has entered it.",
      AppliedWithoutBalance:
        "The consumption was recorded, but the stock did not hold all of the ingredient.",
      Blocked: "The stock of this manufacture could not be moved.",
      Reversed:
        "The manufacture was cancelled and the movements were reversed.",
    },
    stockReason: {
      MANUFACTURE_WITHOUT_RECIPE:
        "The manufacture arrived without a recipe. Check the phase planning sent by the partner.",
      RECIPE_NOT_FOUND:
        "The recipe of this manufacture was not found on this farm.",
      RECIPE_WITHOUT_STOCK_ITEM:
        "The recipe {{name}} has no stock item to receive the production. Create the item when editing the recipe.",
      INGREDIENT_NOT_FOUND:
        "The ingredient {{name}} was not found on this farm.",
      INGREDIENT_WITHOUT_STOCK_ITEM:
        "The ingredient {{name}} has no stock item. Create the item when editing the recipe.",
      INGREDIENT_STOCK_ITEM_NOT_FOUND:
        "The stock item of the ingredient {{name}} was not found on this farm.",
      STOCK_ITEM_WITHOUT_UNIT:
        "The stock item of {{name}} has no measurement unit.",
      INGREDIENT_WITHOUT_COST:
        "There is no cost to move the ingredient {{name}}. Register an entry in its stock.",
      MANUFACTURE_WITHOUT_QUANTITY:
        "The manufacture arrived without a manufactured quantity.",
      MANUFACTURE_WITHOUT_INGREDIENT:
        "The manufacture arrived without a consumed ingredient.",
      MANUFACTURE_WITHOUT_DATE: "The manufacture arrived without a date.",
      MANUFACTURE_ALREADY_IN_STOCK:
        "This manufacture already has stock movements.",
      INSUFFICIENT_BALANCE:
        "The consumption of the manufacture was recorded as usual, but the stock of {{name}} did not have enough balance and went negative. Register the missing entry so the balance adds up again.",
      UNEXPECTED_ERROR:
        "Unexpected error while moving the stock of this manufacture.",
    },
    flags: {
      leftover: "Leftover",
      substituted: "Substituted",
      changed: "Changed",
      realized: "Realized",
    },
    columns: {
      day: "Day",
      manufactures: "Manufactures",
      manufactureDatetime: "Date and time",
      time: "Time",
      treatNumber: "Feeding",
      supplementName: "Recipe",
      wagonName: "Mixer",
      situation: "Situation",
      stockStatus: "Stock",
      quantityPlanned: "Planned (kg)",
      quantityManufactured: "Manufactured (kg)",
      quantityManufacturedDryMatter: "Manufactured DM (kg)",
      deviationPercent: "Deviation",
    },
    details: {
      title: "Manufacture · Feeding",
      manufactureDatetime: "Date and time:",
      supplementName: "Recipe:",
      wagonName: "Mixer:",
      quantityPlanned: "Planned:",
      quantityManufactured: "Manufactured:",
      quantityManufacturedDryMatter: "Manufactured DM:",
      deviationPercent: "Deviation:",
      launchType: "Launch:",
      externalImportCode: "External code:",
      stockStatus: "Stock:",
      observation: "Note:",
      noIngredients: "No ingredient informed in this manufacture.",
      columns: {
        ingredient: "Ingredient",
        quantityPlanned: "Planned (kg)",
        quantityRealized: "Realized (kg)",
        deviationPercent: "Deviation",
        flags: "Marks",
      },
    },
    messages: {
      errorLoad: "Error loading the feeding automation manufactures.",
    },
  },
  production: {
    buttonPrint: "Print sheet",
    loadingBatches: "Loading the batches...",
    noBatchesYet: "No batch executed yet.",
    missingStockAlert:
      "These orders were calculated with missing inputs: {{codes}}. Check the stock before producing.",
    columns: {
      batches: "Batches",
      plannedDryMatter: "Planned (kg DM)",
      producedDryMatter: "Produced (kg DM)",
      realizedTotalCost: "Realized cost",
    },
    batchColumns: {
      number: "Batch",
      date: "Date",
      plannedOriginalMatter: "Planned (OM)",
      produced: "Produced (OM)",
      producedDryMatter: "Produced (DM)",
      deviation: "Deviation (OM)",
    },
    ingredientColumns: {
      name: "Input",
      planned: "Planned (kg OM)",
      realized: "Used (kg OM)",
      deviation: "Deviation (OM)",
    },
    noIngredients: "No ingredient registered in this batch.",
    menu: {
      executeBatch: "Execute batch",
      closePartial: "Close partially",
      print: "Print sheet",
    },
    details: {
      title: "P.O.",
      date: "Date:",
      targetDryMatter: "Target DM:",
      batches: "Batches:",
      totalCost: "Total cost:",
      costPerKg: "Cost/kgDM:",
      realizedCost: "Realized cost:",
      batchLabel: "Batch",
      executed: "Executed",
      planned: "Planned",
      columns: {
        sequence: "Seq.",
        batchNumber: "Batch",
        mixingTime: "Time",
        ingredient: "Input",
        plannedOriginalMatter: "OM Plan.",
        realizedOriginalMatter: "OM Real",
      },
    },
    batch: {
      title: "Execute",
      batchLabel: "Batch",
      order: "Order",
      recipe: "Recipe",
      plannedPerBatch: "Planned per batch",
      manufactureDate: "Production date",
      observation: "Note",
      ingredients: "Inputs",
      totalUsed: "Total used:",
      execute: "Execute",
      columns: {
        ingredient: "Input",
        batch: "Batch",
        planned: "Planned (kg)",
        realized: "Used (kg)",
        deviation: "Deviation",
      },
    },
    messages: {
      errorLoad: "Error loading the production orders.",
      successExecute: "Batch executed successfully.",
      errorExecute: "Error executing the batch.",
      confirmClosePartial: "Do you confirm closing this order partially?",
      confirmClosePartialDetail: "The pending batches will not be produced.",
      successClosePartial: "Order closed partially.",
      errorClosePartial: "Error closing the order partially.",
      nothingToPrint:
        "Select at least one order in the list to print the sheet.",
      errorPrint: "Error generating the printing sheet.",
    },
  },
  productionOrder: {
    buttonNew: "New Order",
    table: {
      columns: {
        code: "Code",
        supplementName: "Recipe",
        wagonName: "Mixer",
        targetDryMatterKg: "Target (kg DM)",
        plannedDryMatterKg: "Planned (kg DM)",
        numberOfBatches: "Batches",
        totalCost: "Total cost",
        costPerKgDryMatter: "Cost/kg DM",
        productionDate: "Production date",
        status: "Status",
      },
    },
    status: {
      Calculated: "Calculated",
      Scheduled: "Scheduled",
      InProgress: "In progress",
      ClosedTotal: "Fully closed",
      ClosedPartial: "Partially closed",
      Cancelled: "Cancelled",
    },
    menu: {
      schedule: "Schedule",
      cancel: "Cancel order",
    },
    form: {
      titleCreateNew: "New Production Order",
      titleEdit: "Edit Production Order",
      titleDetails: "Production Order",
      supplement: "Recipe",
      wagon: "Mixer",
      productionDate: "Production date",
      targetDryMatterKg: "Target (kg of DM)",
      useFullMixerCapacity: "Use full mixer capacity",
      observations: "Notes",
      buttonCalculate: "Calculate batches",
      resultTitle: "Calculation result",
      numberOfBatches: "Number of batches",
      dryMatterPerBatchKg: "Mixer capacity (DM)",
      originalMatterPerBatchKg: "Mixer capacity (OM)",
      plannedDryMatterKg: "Planned DM",
      plannedOriginalMatterKg: "Total OM",
      inputCost: "Input cost",
      manufacturingCost: "Manufacturing cost",
      totalCost: "Total cost",
      costPerKgDryMatter: "Cost per kg of DM",
      itemsTitle: "Ingredients",
      items: {
        supplementName: "Input",
        dryMatterPercentage: "DM content (%)",
        plannedDryMatterKg: "kg of DM",
        plannedOriginalMatterKg: "kg of OM",
        batch: "Batch",
        availableQuantity: "Balance",
        unitCost: "Unit cost",
        totalCost: "Total cost",
      },
      noBatch: "No batch",
      expiresAt: "expires on",
      mustCalculate: "Calculate the batches before saving.",
    },
    warnings: {
      title: "Warnings",
      targetAdjusted:
        "The target was adjusted from {{informed}} to {{adjusted}} kg of DM to fill every batch of the mixer.",
      missingStock:
        "Not enough {{name}}: the order needs {{required}} kg and there are {{available}} kg in stock. The order will be created anyway.",
      partialBatch:
        "Each batch gets {{batch}} kg of DM, {{missing}} kg below the mixer capacity. To produce with every batch full, use {{suggested}} kg of DM.",
      missingCost:
        "{{name}} has no registered cost and no stock entry. Its cost was taken as zero, so the total cost of the order is underestimated.",
      expiredBatch: "Batch {{batch}} of {{name}} expired on {{expiration}}.",
      acknowledge: "I acknowledge",
      acknowledged: "Acknowledged",
      pending:
        "Acknowledge every warning to save the order. Pending: {{count}}.",
    },
    errors: {
      NEGATIVE_COST:
        "The cost of {{name}} is negative and cannot be moved into the stock. Register an entry with the correct cost before executing the batch.",
      RECIPE_NOT_FOUND: "Recipe not found on this farm.",
      SUPPLEMENT_NOT_FORMULATED:
        "The selected item is not a formulated recipe.",
      RECIPE_INACTIVE: "The recipe {{name}} is inactive.",
      RECIPE_WITHOUT_INGREDIENTS: "The recipe {{name}} has no ingredients.",
      RECIPE_WITHOUT_DRY_MATTER:
        "The recipe {{name}} has no dry matter to produce.",
      WAGON_NOT_FOUND: "Mixer not found on this farm.",
      WAGON_INACTIVE: "The mixer {{name}} is inactive.",
      WAGON_WITHOUT_CAPACITY:
        "The mixer {{name}} has no capacity. Set its capacity under Handling Parameters.",
      FEED_FACTORY_PARAMETERS_NOT_CONFIGURED:
        "The Feed Factory parameters are not filled in. Set the standard cost per batch under Parameters.",
      INGREDIENT_NOT_FOUND: "An ingredient of the recipe was not found.",
      INGREDIENT_WITHOUT_STOCK_ITEM:
        "The ingredient {{name}} has no stock item. Link a stock item to it on the Recipes tab or under Stock.",
      INGREDIENT_STOCK_ITEM_NOT_FOUND:
        "The stock item of the ingredient {{name}} was not found on this farm.",
      INGREDIENT_WITHOUT_DRY_MATTER_PERCENTAGE:
        "The ingredient {{name}} has no dry matter content.",
      SUPPLEMENT_REQUIRED: "Select the recipe.",
      WAGON_REQUIRED: "Select the mixer.",
      TARGET_DRY_MATTER_REQUIRED:
        "Enter the target in kg of dry matter, greater than zero.",
      PRODUCTION_DATE_REQUIRED: "Enter the production date.",
      REQUEST_REQUIRED: "The order data could not be read.",
      ONLY_CALCULATED_CAN_BE_UPDATED:
        "Only an order with the Calculated status can be edited.",
      ONLY_CALCULATED_CAN_BE_DELETED:
        "Only an order with the Calculated status can be deleted.",
      ONLY_CALCULATED_CAN_BE_SCHEDULED:
        "Only an order with the Calculated status can be scheduled.",
      ONLY_CALCULATED_OR_SCHEDULED_CAN_BE_CANCELLED:
        "Only an order with the Calculated or Scheduled status can be cancelled.",
    },
    readiness: {
      title: "This recipe cannot generate a production order yet",
      withoutStockItem:
        "Without a stock item: {{names}}. Link a stock item to each one under Stock.",
      withoutDryMatter:
        "Without dry matter content: {{names}}. Fill in the DM content on the supplement.",
    },
    messages: {
      errorLoad: "Error loading the production orders.",
      errorCalculate: "Error calculating the batches.",
      successSave: "Production order saved successfully.",
      errorSave: "Error saving the production order.",
      successSchedule: "Production order scheduled successfully.",
      errorSchedule: "Error scheduling the production order.",
      successCancel: "Production order cancelled successfully.",
      errorCancel: "Error cancelling the production order.",
      successDelete: "Production order deleted successfully.",
      errorDelete: "Error deleting the production order.",
      confirmDelete: "Do you confirm the deletion of this production order?",
      confirmSchedule:
        "Do you confirm the scheduling of this production order?",
      confirmCancel:
        "Do you confirm the cancellation of this production order?",
      noRecipes:
        "No recipe available. Create a formulation on the Recipes tab.",
    },
  },
  supplement: {
    title: "Supplem./Concent.",
    buttonNewSupplement: "New Supplem./Concent.",
    buttonNewSupplementFormulated: "New Formulation",
    table: {
      title: "List of Supplem./Concent.",
      columns: {
        status: "Status",
        description: "Supplem./Concent.",
        industrialName: "Brand name",
        supplierName: "Manufacturer",
        createdAt: "Date created",
        userName: "Created by",
        version: "Version",
        cp: "CP: Crude Protein",
        tdn: "TDN: Total Digestible Nutrients",
        npn: "NNP - Nonprotein nitrogen compounds (Max)",
        dryMatterPercentage: "DM: Dry Matter",
        phosphorus: "Phosphorus",
        nitrogen: "Nitrogen",
        calcium: "Calcium",
        zinc: "Zinc",
        sodium: "Sodium",
        additiveEffect: "Additive effect",
        fda: "ADF",
        lignin: "Lignin",
        ee: "Ether Extract ",
      },
    },
    drawerTitle: "Supplem./Concent. Roster",
    drawerTitleEdit: "Edit Supplem./Concent.",
    drawerSupplementFormulatedTitle: "Supplement Formulation",
    drawerSupplementFormulatedTitleEdit: "Edit Supplement",
    drawerSubTitle:
      "Complete the fields below to register a new Supplem./Concent.",
    drawerSubTitleEdit:
      "Complete the fields below to edit a new Supplem./Concent.",
    drawerSupplementFormulatedSubTitle:
      "Complete the fields below to register a new Supplement/Concentration formulation.",
    drawerSupplementFormulatedSubTitleEdit:
      "Complete the fields below to edit the Supplement/Concentration formulation.",
    validationMessage: "Fill in all required fields (*) correctly",
    form: {
      stockItemsDivider: "STOCK ITEMS",
      restrictionsDivider: "RESTRICTIONS",
      supplementType: "Ration or Supplem.?",
      supplementTypeHelp:
        "Ration/Mixture: Ready-made diet, produced on the farm itself. Supplements: Product purchased and supplied in pure form.",
      supplementClassification:
        "What is the classification of the Supplem./Ration?",
      supplementClassificationHelp: {
        title_0: "Mineral Supplem.",
        description_0:
          "when it contains macro and/or micro mineral elements in its composition, and may present, in the final product, a value of less than forty-two percent of protein equivalent.",
        title_1: "Protein-Mineral Supplem.",
        description_1:
          "when it has in its composition, macro and/or micro mineral element, at least 20% crude protein (CP) and provides, at least, 30 grams of crude protein (CP) per 100 kg of BW.",
        title_2: "Energy-Protein-Mineral Supplement",
        description_2:
          "when it has in its composition, macro and/or micro mineral element, at least 20% crude protein, provide at least 30 grams of crude protein and 100 grams of total digestible nutrients (TDN) per 100 kg of BW.",
        source: "*According to Brazilian MAPA - IN12 2004/11/30.",
      },
      name: "Generic name",
      namePlaceHolder: "Identification",
      importCode: "Importing code",
      mixingTime: "Mixing Time",
      mixingTimeHelp:
        "Total mixing time, in minutes: the sum of the times informed on the recipe ingredients.",
      stabilityRange: "Stability Range",
      stabilityRangeHelp:
        "Enter the Raw Material Stability Range to start the count to move on to the next ingredient in the mixer.",
      stabilityTime: "Stability Time",
      stabilityTimeHelp:
        "Enter the Raw Material Stability Time after addition, in minutes.",
      inclusionOrder: "Mixing Sequence",
      itemMixingTime: "Mixing time (min)",
      createStockItem: "Create stock item",
      createStockItemHelp:
        "Create a stock item when the recipe product is stored. A recipe fed directly at the trough does not need a new stock item.",
      stockItem: "Stock item",
      stockItemEditHelp:
        "The stock item linked to the recipe is not edited here. To change it, use the Stock menu.",
      stockItemGroupRecipeHelp:
        "This recipe is shared by every farm in the group. Stock items belong to a farm, so neither the recipe's stock item nor the ingredients' stock items can be created or linked from here.",
      rationStockItemTitle: "Ration stock item",
      rationStockItemHelp:
        "Final product of this recipe. Required when the ration is stored before going to the feed bunk.",
      ingredientsStockItemsTitle: "Ingredients stock items",
      ingredientsStockItemsHelp:
        "Raw materials of the recipe, consumed from stock on each batch.",
      stockItemInternalId: "Identification",
      stockItemAbbreviation: "Abbreviation",
      stockItemUnit: "Measurement unit",
      ingredient: "Ingredient",
      stockItemGroupItem: "Group",
      stockItemItemGroup: "Subgroup",
      baseAmount: "For every",
      observations: "Notes",
      observationsPlaceHolder: "Recipe notes",
      industrialName: "Brand name",
      industrialNamePlaceHolder: "Brand name",
      supplierName: "Manufacturer",
      supplierNamePlaceHolder: "Manufacturer name",
      status: "Supplem./Concent. Status",
      nutritionalDataDivider: "Nutriotional Data",
      capacityDivider: "Amount per offering type",
      sustenanceCapacity: "Qty per offering type",
      information: 'All information is related to "Animal/day"',
      sustenanceCapacityDrawerTitle:
        "Quantities by Supplem./Concent Offering Type.",
      minimumAmount: "Min Amt.",
      maximumAmount: "Max Amt.",
      minimum: "Min",
      maximum: "Max",
      ratio: "Proportion",
      cost: "Daily cost",
      costPlaceHolder: "Unit: $",
      cp: "CP: Crude Protein",
      cpPlaceHolder: "Unit: g/kg",
      tdn: "TDN: Total Digestible Nutrients",
      tdnPlaceHolder: "Unit: g/kg",
      npn: "NNP - Nonprotein nitrogen compounds (Max)",
      npnPlaceHolder: "Unit: g/kg",
      dryMatterPercentage: "DM: Dry Matter",
      phosphorus: "Phosphorus",
      phosphorusPlaceHolder: "Unit: g/kg",
      nitrogen: "Nitrogen",
      nitrogenPlaceHolder: "Unit: mg/kg",
      calcium: "Calcium",
      calciumPlaceHolder: "Unit: g/kg",
      zinc: "Zinc",
      zincPlaceHolder: "Unit: mg/kg",
      sodium: "Sodium",
      sodiumPlaceHolder: "Unit: g/kg",
      voluntaryConsumption: "Voluntary feed",
      minimumVoluntaryConsumptionPlaceHolder: "Inform",
      maximumVoluntaryConsumptionPlaceHolder: "Inform",
      pure: "Offering of pure",
      mix: "Offering of mixed",
      recommendedTrough: "Trough size recommended",
      recommendedTroughPlaceHolder: "Inform",
      groupFarmVisibility: "Who will use the Supplement/Concent.?",
      radiogroup: {
        farm: "This farm only",
        group: "All farms in the group",
      },
      additiveEffect: "Additive effect",
      additiveEffectPlaceHolder: "Unit: g/dia",
      additiveEffectHelp:
        "Some mineral supplements have additives in their formulation that enhance the animals' weight gain, and the supplier may indicate an incremental gain (g/day), adding to the calculated predicted gain (Pasture + Supplement) or indicate a % increase in the total Crude Protein (CP) to be considered in the calculation.",
      fda: "ADF",
      fdaPlaceHolder: "Unit: g/kg",
      lignin: "Lignin",
      ligninPlaceHolder: "Unit: g/kg",
      ee: "Ethereal Extract",
      eePlaceHolder: "Unit: %/MS",
    },
    formFarmRestrictions: {
      title: "Restrictions",
      reproductiveStatusList: "Reproductive Statuses",
      minSupplementOfferedPerDay: "Minimum Offer (/day)",
      maxSupplementOfferedPerDay: "Maximum Offer (/day)",
      maxDays: "Maximum Days",
      age: "Age (months)",
      liveWeight: "Live Weight (kg)",
      minimum: "Min.",
      maximum: "Max.",
      male: "Males",
      female: "Females",
      calf: "Calves",
      heifer: "Heifers",
      reproductiveStatusOptions: {
        castrated_male: "Castrated Males",
        pregnant_female: "Pregnant Females",
        anestrous_female: "Anestrous Females",
        lactating_female: "Lactating Females",
        lactating_calf: "Lactating Calves/Heifers",
        supplemented_animals: "Supplemented Animals",
        breeding_males: "Breeding Males",
        dairy_cows: "Dairy Cows",
        animals_on_pasture: "Grazing Animals",
      },
    },
    confirmClearNutritionalData:
      "You are deselecting the Original Ingredient/Supplement. Do you want to clear the related data?",
    errorVoluntaryConsumptionMaximumLessThanMinimum:
      "The supplier’s recommended maximum consumption must be greater than or equal to the minimum consumption.",
    errorPureMaximumLessThanMinimum:
      "The maximum Pure Offer must be greater than or equal to the minimum Pure Offer.",
    errorPureMaximumTroughLessThanMinimumTrough:
      "The recommended maximum Trough value for Pure Offer must be greater than or equal to the minimum value.",
    errorMixMaximumLessThanMinimum:
      "The maximum Mix Offer must be greater than or equal to the minimum Mix Offer.",
    errorMixMaximumTroughLessThanMinimumTrough:
      "The recommended maximum Trough value for Mix Offer must be greater than or equal to the minimum value.",
    errorNecessarySustenanceCapacity:
      "You must enter the quantity data for each delivery method.",
    errorWrongNpnInput:
      "Warning! Only products with up to 42.0% NPN - Protein Equivalent are classified as Mineral Supplements. Please check the classification of this Supplement.",
    errorNecessaryFormulatedItems:
      "At least one raw material must be specified.",
    errorFormulatedItemWithoutRawMaterial: "You must specify the raw material.",
    errorFormulatedItemWithoutAmount:
      "You must specify the quantity of the raw material.",
    errorFormulatedItemTotalAmount:
      "The sum of the raw materials in % must be exactly 100%. Current sum:",
    ingredientWithoutName: "ingredient without a name",
    errorIngredientStockItemWithoutGroup:
      "Set the Group and the Subgroup of the stock item of these ingredients: {{names}}.",
    ingredientStockItemsBlockTitle: "Some ingredients have no stock item yet",
    ingredientStockItemsBlockHelp:
      "On save, the stock item of these ingredients will be created: {{names}}. Set the Group and the Subgroup of each one.",
    ingredientStockItemsWillBeCreated:
      "{{count}} stock items will be created for the ingredients:",
    ingredientsWillUseFarmCopy:
      "These ingredients will start using this farm's own record:",
    errorStockItemNotSelected: "You must select a stock item for the recipe",
    errorStockItemWithoutInternalId:
      "You must specify the stock item identification",
    errorStockItemWithoutUnit:
      "You must specify the stock item measurement unit",
    errorStockItemWithoutGroup:
      "You must specify the stock item group and subgroup",
    errorFormulatedItemWithItself:
      "The recipe cannot be a raw material of itself",
    errorFormulatedItemWithoutAddedAmount:
      "You must specify the added raw material quantity in kg of dry matter",
    errorFormulatedItemWithoutBaseAmount:
      "You must specify for how many kg of dry matter of the mix the raw material is added",
    errorFormulatedItemWithoutPercentItems:
      "The recipe needs at least one raw material in % to form the mix",
    errorFormulatedItemAddedInclusionOrder:
      "A raw material added by kg for every X kg must have a mixing sequence after the raw materials in %",
    errorFormulatedItemWithoutOriginalMatterAmount:
      "You must specify the original matter quantity.",
    errorFormulatedItemWithDuplicate:
      "Each raw material must be specified only once.",
    errorVoluntaryConsumptionType:
      "Voluntary consumption type must be equal to the Offer field in the constraints",
    successInactivate: "The supplement was successfully inactivated",
    errorInactivate: "The supplement was not inactivated. Contact support.",
    successActivate: "The supplement was successfully activated",
    errorActivate: "The supplement was not activated. Contact support.",
    successSaveFormulated: "Formulation saved successfully",
    errorSaveFormulated: "Error saving formulation",
    errorSaveFormulatedNutrientsMismatch:
      "The nutritional values of the formulation do not match its raw materials. A raw material may have been changed: close, reopen the formulation and save again.",
    saveOptions: {
      only_save: "Save",
      save_and_create_new: "Save and add a new Supplem./Concent.",
    },
    details: {
      tabs: {
        supplementData: "Supplement",
        supplementHistory: "Historic data",
      },
      supplementType: "Type",
      supplementClassification: "Classification",
      name: "Generic name",
      industrialName: "Brand name",
      supplierName: "Manufacturer",
      ratio: "Proportion",
      cost: "Cost",
      nutritionalDataDivider: "Nutritional Data",
      tdn: "TDN: Total Digestible Nutrients",
      cp: "CP: Crude Protein",
      dryMatterPercentage: "MS: Matéria Seca",
      calcium: "Calcium",
      phosphorus: "Phosphorus",
      nitrogen: "Nitrogen",
      zinc: "Zinc",
      sodium: "Sodium",
      voluntaryConsumption: "Voluntary feed",
      pure: "Amt. of Pure Product",
      mix: "Amt. of Mixed",
      recommendedTrough: "Recom. Trough",
      minimum: "Min.",
      maximum: "Max.",
      information: 'All information is related to "Animal/day"',
      capacityDivider: "QUANTITIES BY OFFER MODE",
      sustenanceCapacity: "QUANTITIES BY OFFER MODE",
      sustenanceCapacityDrawerTitle:
        "Quantities by Supplement/Concent Offering Mode.",
      npn: "NNP - Nonprotein nitrogen compounds (Max)",
      additiveEffect: "Additive effect",
      fda: "ADF",
      lignin: "Lignin",
      ee: "Ethereal Extract",
    },
  },
  lot: {
    validationMessage: "Fill in all required fields (*) correctly",
    tabs: {
      production: "Production",
      movementHistory: "Movements Log",
      receipt: "Received",
    },
    production: {
      title: "Production BATCHs",
      buttonNewLot: "New Production BATCH",
      details: {
        breadCumbsProductionLot: "Production BATCHs",
        breadCumbsLotDetails: "BATCH Details ",
        createdAt: "Created:",
        options: "Options",
        labelSystem: "ACTIVITY",
        labelDietStrategy: "Diet Strategy",
        baseline: "Baseline",
        optionalStrategies: "Optional Strategies",
        optional: "Optionals",
        labelAnimals: "ANIMALS",
        labelAsymptoticWeight: "SIGMOID WEIGHT",
        labelMarketValuation: "MARKET VALUE",
        labelProductionCost: "Production Cost",
        makeValuation: "Run Assessment",
        labelWeights: "WEIGHINGS",
        labelAverageWeight: "AVG WEIGHT:",
        labelAverageWeightGain: "ADG:",
        labelPicket: "PADDOCK / PEN:",
        labelProductionArea: "USEFUL AREA:",
        labelTotalArea: "TOTAL AREA:",
        labelSupportCapacity: "Carrying Cap.:",
        titleAnimals: "Animals",
        titleWeigth: "Weight",
        viewBy: "View by:",
        tooltipEstimatedCurve:
          'Theoretical curve obtained from BREED. Click on "Estimate for BATCH"to set the BATCH values',
        rankBy: "Rank by:",
        supplementSupply: {
          title: "Supplement Supply",
          refreshData: "Refresh data",
          hidePanels: "Hide panels",
          showPanels: "Show panels",
          dashboards: {
            perDiet: "By Diet",
            totalCost: "Total Allocated Cost",
            averageConsumeMO: "Average MO Intake",
            averageConsumeMS: "Average DM Intake",
            animalCostPerDay: "Allocated Cost",
            totalAnimalCost: "Total Cost",
            suffixCabDay: "Head/day",
            suffixCab: "Head",
            columns: {
              diet: "Diet",
              days: "Days",
              amountSupplied: "Amount Supplied (kg)",
              cost: "Cost",
            },
          },
          table: {
            columns: {
              date: "Date",
              treatNumber: "Treat #",
              picketName: "Paddock/Pen",
              supplementName: "Diet",
              amountAnimals: "Head Qty",
              totalSupplyCost: "Cost",
              treatQuantitySupplied: "Amount Supplied (kg) MO",
              totalSupplementSuppliedInKilosPerAnimal: "MO Intake/Head",
              dryMatterPercentage: "%DM",
              totalSupplementSuppliedInDryMatter: "Amount Supplied (kg) DM",
              totalSupplementSuppliedInDryMatterPerAnimal: "DM Intake/Head",
            },
          },
        },
      },
      table: {
        columns: {
          lotNumber: "BATCH number",
          lotName: "BATCH",
          salesScenario: "Sales Scenario",
          dietStrategyName: "Diet Strategy",
          profitCenter: "Acitivty",
          createdAtAndEndAt: "Opening/Closing",
          status: "Status",
          amount: "Amt.",
          gdp: "WDA",
          gmd: "ADG",
          diet: "Diet",
          averageWeight: "Avg. Weight",
          target: "Target",
          picketName: "Paddock/Pen",
        },
      },
      drawer: {
        title: "Create Production BATCH",
        titleEdit: "Edit Production BATCH",
        subtitle: "Complete the fields below to create a BATCH",
        subtitleEdit: "Complete the fields below to edit a BATCH",
        form: {
          status: "Status",
          name: "Lot Name*",
          namePlaceHolder: "Lot Name",
          identification: "Import Code",
          identificationPlaceHolder: "Import Code",
          profitCenter: "Activity*",
          profitCenterPlaceHolder: "Select Activity",
          asymptoticWeight: "Asymptotic Weight",
          carcassHarnessing: "Carcass Yield",
          informPlaceHolder: "Enter",
          picket: "Paddock / Pen",
          picketMessage:
            "Select the paddock / pen if you want to allocate this lot",
          picketPlaceHolder: "Select the paddock / pen",
          projectionWeightType: "Weight projection type",
          projectionWeightTypeDietStrategy: "Diet strategy",
          projectionWeightTypeFarmProjection: "Weight gain projection",
          weightGainProjection: "Weight gain projection",
          weightGainProjectionPlaceholder: "Select a projection",
          startWeightGainProjectionDate: "Weight gain projection start date",
          dietStrategyBaseLine: "Diet Strategy",
          dietStrategyBaseLineMessage:
            "Select the strategy that will be used for feeding the animals added to this lot",
          dietStrategies: "Diet Strategy - Optional",
          dietStrategiesPlaceHolder: "Select one or more diet strategies",
          dietStrategiesTooltip:
            "The selected optional diet strategies will be used later in the purchase and sale scenario simulations",
          checkboxSaveAndAddNewAnimals: "Save and add animals",
          picketId: "Paddock",
          picketLotEntry: "Lot Entry Date",
          breedId: "Breed",
          referenceAcquisitionDate: "Acquisition Date",
          referenceBirthdayDate: "Animal Birth Date",
          dismembermentDate: "Dismemberment Date",
          referenceAcquisitionWeight: "Average Weight per Animal",
        },
        warningPendingTitle: "Pending Lot",
        warningPendingDescription: "The lot is pending approval",
        gmdCurve: {
          buttonOpen: "ADG Curve",
          title: "ADG Growth Curve",
          subtitle: "Define the average daily gain type for this batch",
          dividerTitle: "ADG CURVE",
          dividerChart: "CURVE CHART",
          form: {
            startGainWeightDate: "Weight gain start date",
            startGainWeightDatePlaceholder: "Select date",
            informType: "Information type",
            informTypePeriod: "By period",
            informTypeFixed: "Fixed",
            timeUnitReference: "Time unit",
            timeUnitReferenceDay: "Day",
            timeUnitReferenceWeek: "Week",
            fixedGmdWeight: "Fixed ADG (kg/day)",
            fixedGmdWeightPlaceholder: "0.000",
            period: "Period",
            periodPlaceholderDay: "Day number",
            periodPlaceholderWeek: "Week number",
            gmdWeight: "ADG (kg/day)",
            gmdWeightPlaceholder: "0.000",
            buttonAddPeriod: "Add period",
            buttonDeletePeriod: "Remove",
            buttonConfirm: "Confirm",
          },
          table: {
            columnPeriod: "Period",
            columnGmdWeight: "ADG (kg/day)",
            columnActions: "Actions",
          },
          chart: {
            titleX: "Period",
            titleY: "ADG (kg/day)",
            seriesName: "ADG Curve",
          },
          validation: {
            periodMustBeIncreasing:
              "Period must be greater than the previous period",
            gmdWeightMustBePositive: "ADG must be greater than zero",
            atLeastOnePeriod: "Add at least one period",
          },
        },
      },
      saveOptions: {
        only_save: "Save",
        save_and_create_new: "Save and add a new BATCH",
      },
      addAnimalsPage: {
        listLotProduction: "List: Production BATCHs",
        title: "Add animal to BATCH",
        descriptionMessage:
          "Select the animals in the gray column and move them to the orange column by clicking the button",
        selectPlaceHolder:
          "Select the breed of animals that should make up the BATCH",
        listAnimals: "List of animals",
        productionLot: "Production BATCH",
        modal: {
          message: "Click confirm to add the animals to the BATCH",
          lot: "BATCH",
          profitCenter: "Activity",
          amount: "Amount",
        },
        error: {
          noAnimalsTitle: "Error",
          noAnimalsMessage: "You must select at least one animal",
        },
      },
      dismemberLotPage: {
        listLotProduction: "List: Production BATCHs",
        title: "Split BATCH",
        descriptionMessage:
          "Select the animals in the table and click the 'Split' button to relocate the animals",
        profitCenter: "Activity",
        productionSubSystem: "Production subsystem",
        animalsTotal: "Total Animals",
        animalsSelected: "Selected animals",
        dismemberButton: "Split",
        destinationLots: "Destination BATCHs",
        drawer: {
          title: "Split BATCH",
          description:
            "Select below whether the subdivision will be into a new BATCH or an existing BATCH.",
          newButton: "New",
          existingButton: "Existing",
          alertMessage:
            "The activity of the informed BATCH differs from the current BATCH",
          searchInputPlaceHolder: "Search by BATCH ID",
        },
      },
      tabs: {
        calf: "Calf",
        rearingFattening: "Rearing/Fattening",
      },
    },
    receipt: {
      title: "Receiving BATCHs",
      buttonNewLot: "New",
      collapse: {
        animals: "Animals",
        receiptIn: "Received on",
      },
      table: {
        columns: {
          breed: "Breed",
          gender: "Gender",
          birthday: "Age (months)",
          weight: "Estimated Weight",
          amount: "Qtd. animais",
          confirmedAmount: "No  of animals received",
          purchaseCost: "Acquisition cost",
          numbers: "Numbering",
        },
        boitelColumns: {
          identification: "Identification",
          amount: "No  of animals",
          breed: "Breed",
          entryDate: "Entry Date",
          weightRange: "Weight range",
          confirmedAmount: "No  of animals received",
          identifiedAmount: "No  of animals identified",
          status: "Status",
        },
        status: {
          confirmed: "Confirmed",
          pending: "Pending",
        },
      },
      finalize: {
        title: "Creating receiving BATCHs",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        buttonFinalize: "FINALIZE RECEIPT",
        buttonFinalizeCancel: "CANCEL RECEIPT",
        supplier: "Supplier",
        dateReceiving: "RECEIPT DATE",
        animalsReceived: "No  of animals received",
        grid: {
          title: "Receiving BATCH",
          animalsInserted: "animals added",
          buttonAddAnimals: "Add animals",
          columns: {
            breed: "Breed",
            gender: "Gender",
            birthday: "Age (months)",
            weight: "Estimated Weight",
            amount: "Amt.",
            purchaseCost: "Acquisition cost",
            numbers: "Numbering",
          },
          deleteBox: {
            description: "Upon confirmation the BATCH will be deleted",
            buttonConfirm: "Confirm",
            buttonCancel: "Cancel",
          },
        },
        newLotAnimalsReceipt: {
          title: "New animals",
          description: "Fill in the animal reception data",
          saveOptions: {
            only_save: "Save",
            save_and_create_new: "Save and create new receipt",
            save_and_handle: "Save and start husbandry",
          },
        },
        newLotItem: {
          title: "Animals grouping",
          description:
            "Group the animals being received according to their characteristics by completing the information below.",
          tabGeneralTitle: "General",
          tabNumbersTitle: "Numbering",
          breed: "Breed",
          gender: "Gender",
          birthday: "DOB",
          birthdayPlaceHolder: "Select",
          estimatedWeight: "Estimated Weight",
          estimatedWeightPlaceHolder: "Enter the weight (kg)",
          amount: "Amount",
          amoutPlaceHolder: "Enter the amount",
          purchaseCost: "Acquisition cost",
          purchaseCostPlaceHolder: "Enter the acquision cost",
          usePrefixedIdentification: "Use prefixed identification",
          animalCost: "Animal cost",
          animalCostPlaceHolder: "Enter the animal cost",
          shippingCost: "Shipping",
          shippingCostPlaceHolder: "Enter the shipping value",
          commissionAuctionCost: "Auction Commission",
          commissionAuctionCostPlaceHolder: "Enter the commission value",
          fees: "Other Fees",
          feesPlaceHolder: "Enter the other fees value",
          totalAnimalCost: "Total Animal Cost",
          totalAnimalCostPlaceHolder: "Total cost calculated automatically",
          initialIdentificationSequence: "Initial identification sequence",
          initialIdentificationSequencePlaceHolder:
            "Enter the initial sequence",
          initialIdentificationSequenceExample:
            "Example: If you enter 'ABC123', animals will be identified as ABC124, ABC125, ABC126...",
          rangeDescription:
            "Add the number of animals that have the characteristics",
          range: "Ranges",
          numbersInserted: "Entered numbers",
          animalFarmFunction: "Purpose",
          animalReproductionCategory: "Category",
          saveOptions: {
            only_save: "Save",
            create_new: "Save and create new animals receiving",
          },
        },
        errors: {
          noAnimalsAdd: {
            title: "No animals added",
            description:
              "It is necessary to add the informed quantity of animals",
          },
          amountAnimalsInLotItenBiggerThanAmountAnimalsReceveid: {
            title: "Number of animals large than",
            description:
              "The number of animals entered is greater than that stated in the receiving BATCH",
          },
          amountAnimalsInLotItenLessThanAmountAnimalsReceveid: {
            title: "Number of animals less than",
            description:
              "The number of animals entered is less than that stated in the receiving batch",
          },
          amountAnimalsInLotItenBiggerThanAmountReported: {
            title: "Invalid number of animals",
            description:
              "The number of animals entered is greater than that stated in the BATCH quantity",
          },
        },
      },
      supplier: {
        title: "Animal Entry - Purchase",
        buttonNext: "Next",
        buttonBack: "Back",
        titleBox: "Receipt Registration",
        messageError: "Fill in all required fields (*)",
        supplierTitle: "Supplier",
        supplierComboBoxPlaceHolder: "Select",
        lotName: "BATCH name",
        lotNameInputPlaceHolder: "Receiving BATCH name",
        dateTitle: "Entry Date",
        datePlaceHolder: "Select",
        shouldCreateLotEntry: "Post and create animals?",
        buttonToday: "TODAY",
        qtyAnimalsTitle: "Amount of animals",
        qtyAnimalsInputPlaceHolder: "Amount of animals",
        receiptNameTitle: "Receipt number",
        supplierInformationsTitle: "Supplier data",
        documentTitle: "EIN",
        responsibleTitle: "Responsible",
        emailTitle: "E-mail",
        contactTitle: "Contact",
        addressTitle: "Address",
      },
      messages: {
        successDeleteMessage: "Receipt batch successfully deleted",
        errorDeleteMessage: "Error deleting receipt batch. Contact support.",
      },
    },
  },
  picket: {
    status: {
      break: "Resting",
      pasturage: "Grazing",
      renovation: "Renovation",
      maintenance: "Maintenance",
      leased: "Leased",
      deleted: "Deleted",
      active: "Active",
      inactive: "Inactive",
    },
    dashboards: {},
    propertyType: {
      own: "Owned",
      foreign: "Rented",
    },
    tabs: {
      picket: "Paddock/Pen",
      retreat: "Range Unit/Row",
      map: "Map",
    },
    title: "List of Paddocks/Pens",
    buttonNewPicket: "New Paddock/Pen",
    table: {
      columns: {
        picketName: "Paddock/Pen",
        totalAndProductionArea: "Total/Useful Area",
        propertyType: "Type",
        profitCenterName: "Activity",
        lotName: "BATCH",
        status: "Status",
        inAndOutLot: "BATCH entry",
        supportCapacity: "Carrying cap.",
        averageWeight: "Avg. Weight",
        gmd: "ADG",
        amountAnimals: "Amt.",
      },
    },
    pastureTable: {
      title: "Pasture status",
      titleTooltip:
        "The Pasture Status Chart provides different views so that you can monitor and plan the movement of animals between paddocks, in order to optimize pasture use. - DM Stock: Shows the DM availability (%) of the forage used, according to the weather season and consumption of the animals present in the paddock. The recalculation routine is performed daily to update the estimated availability for the next 30 days. - Supply Rate: Shows the Supply and Consumption ratio of Dry Matter (DM) of the forage available in the paddock, showing the number of days that the Batch of animals can remain in the paddock, according to the available DM stock and expected consumption of the animals.",
      columns: {
        picketName: "Paddock",
        status: "Status",
        days: "Accum. Days",
        lotation: "Stocking rate",
      },
      tableType: {
        dryStockOption: "Available DM",
        OfferRateOption: "DM ratio",
      },
    },
    drawerTitle: "Paddock/Pen Registration",
    drawerTitleEdit: "Edit Paddock",
    drawerTitleEditIntensiveSubSystem: "Edit Pen",
    drawerSubTitle: "Complete the fields below to create a new paddock/pen",
    drawerSubTitleEdit: "Complete the fields below to edit a new paddock/pen",
    drawerAllocateLotTitle: "BATCH allocation in the paddock/pen",
    drawerAllocateLotSubTitle: "BATCH allocation in the paddock/pen",
    validationMessage: "Fill in all required fields (*) correctly",
    searchInputPlaceHolder: "Search for the BATCH ID and press (ENTER).",
    alertLotWithProfitCenterDifferent:
      "The Activity of the selected BATCH will be attributed to the Paddock/Pen!",
    detail: {
      name: "Identification",
      productionSubSystem: "Subsystem",
      supplierId: "Supplier",
      supplierDivider: "Supplier",
      sustenanceCapacityDivider: "Carrying Cap.",
      pastureDivider: "FORAGE",
      infrastructureDivider: "INFRASTRUCTURE",
      pasture: "FORAGE",
      pastureDailyCost: "Daily Cost",
      pastureAnimalCapacity: "Stocking density",
      pastureArea: "Useful Area",
      pastureLeafDensity: "Forage density",
      pastureFertilized: "Fertilized",
      pastureCurrentHeight: "Current grass height",
      pastureCurrentHeightDate: "Current grass height date",
      pastureGrowthSpeed: "Growth rate",
      troughSpacePerAnimal: "Trough space per animal",
      totalTroughSpace: "Total Trough size",
      drinkingFountain: "Total water tank size",
      lotId: "BATCH",
      leaseCost: "Leasing cost",
      profitCenterId: "Activity",
      profitCenterType: "Type",
      pastureId: "Forage type",
      moreInformationButton: "More Information",
    },
    form: {
      name: "Paddock/Pen Id",
      namePlaceHolder: "Paddock/Pen Id",
      importCode: "Importing code",
      automacaoTratosDivider: "Feed Automation Integration",
      initialTag: "Initial Tag",
      finalTag: "Final Tag",
      integrationCode: "Integration Code",
      propertyType: "Is the paddock/pen internal or outsourced?",
      productionSubSystem: "Production subsystem",
      productionSubSystemPlaceHolder: "Select System",
      supplierId: "Supplier",
      supplierIdPlaceHolder: "Select supplyer",
      sustenanceCapacity: "Carrying Cap.",
      alocateLotTitle: "ALLOCATE PRODUCTION BATCH",
      infrastructureDivider: "INFRASTRUCTURE",
      lotId: "BATCH",
      lotIdPlaceHolder: "Select a BATCH",
      lotStartDate: "Current BATCH entry date",
      oldLotEndDate: "Previous BATCH exit date ",
      leaseMonthlyCost: "Leasing cost",
      profitCenterId: "Activity used",
      profitCenterIdPlaceHolder: "Select Activity",
      status: "Paddock status",
      sustenanceCapacityDrawerTitle: "Paddock carrying capacity",
      sustenanceCapacityDrawerTitleIntensiveSubSystem: "Pen carrying capacity",
      drinkingFountain: "Water tank size",
      troughSpacePerAnimal: "Trough size per head",
      totalTroughSpace: "Trough size",
      pastureDivider: "FORAGE",
      pastureId: "FORAGE",
      pastureIdPlaceHolder: "Selecione o tipo de forrageira",
      pastureAnimalCapacity: "Stocking density",
      pastureArea: "Useful Area",
      pastureLeafDensity: "Forage DM Density",
      pastureFertilized: "Fertilized",
      pastureDailyCost: "Daily cost ",
      pastureDailyCostTooltip:
        "When entering a value in this field, it will be used in the Diet Strategy, regardless of the Climate Season. If no value is entered, the Cost registered in Pasture for each Climate Season will be used.",
      pastureCurrentHeight: "Current Pasture Height",
      pastureCurrentHeightDate: "Current Pasture Height Date",
      pastureGrowthSpeed: "Growth rate",
      observation: "Remarks",
      error: {
        requiredPastureId: {
          title: "Invalid Data",
          message:
            "Select the type of forage when the production subsystem is Extensive or Semi-Intensive",
        },
        requiredSupplierId: {
          title: "Invalid Data",
          message: "Select the supplier when the paddock type is Third Party",
        },
        supplementConsumptionMeasureTypeInvalid: {
          title: "Invalid Data",
          message: "Invalid measurement type for selected Consumption Type",
        },
        productionSubSystemDifferentFromPicketProductionSubSystem: {
          title: "Invalid Data",
          message:
            "Cannot allocate this lot because the production subsystem is different from the paddock/pen",
        },
        sustenanceCapacityNotInformed: {
          title: "Invalid Data",
          message: "Carrying Capacity data must be reported",
        },
      },
    },
    saveOptions: {
      only_save: "Save",
      save_and_create_new: "Create paddock/pen and add a new one",
      save_and_add_lot: "Save and add Batch to the paddock/pen",
    },
    drawerMaintenance: {
      title: "Set Paddock/Pen under maintenance",
      subtitle:
        "Indicate in the field below the time that the paddock/pen will be under maintenance",
      labelAmountDays: "Amount of days",
      finishIn: "Finishing on:",
      infoMessage: "You will be notified when the period ends.",
    },
    drawerRenovation: {
      title: "Set Paddock/Pen under maintenance",
      subtitle:
        "Indicate in the field below the time that the paddock/pen will be under maintenance",
      labelAmountDays: "Amount of days",
      finishIn: "Finishing on:",
      infoMessage: "VYou will be notified when the period ends.",
    },
    drawerBreakTitle: "Are you sure you want to set this paddock/pen on Rest?",
    drawerInactivate: "Are you sure you want to deactivate this paddock/pen?",
    drawerReactivate: "Are you sure you want to reactivate this paddock/pen?",
    drawerDelete: "Are you sure you want to delete this paddock/pen?",
  },
  retreat: {
    title: "List of Range units",
    buttonNew: "New Range",
    table: {
      columns: {
        status: "Status",
        retreatName: "Range",
        area: "Area",
      },
      expandedColumns: {
        picketName: "Paddock/Pen",
        area: "Area",
        activity: "Activity",
        status: "Status",
        lot: "BATCH",
      },
    },
  },
  profitCenter: {
    title: "Activities",
    saveOptions: {
      only_save: "Save",
      save_and_create_new: "Create Activity and add a new one.",
    },
    table: {
      title: "List of Activities",
      columns: {
        name: "Name",
        status: "Status",
        type: "Type",
        productionSubSystem: "Production subsystem",
      },
    },
    drawerTitle: "Activities Roster",
    drawerTitleEdit: "Edit Activity",
    drawerSubTitle: "Complete the fields below to create a new Activity",
    drawerSubTitleEdit: "Complete the fields below to edit a new activity",
    validationMessage: "Fill in all required fields (*) correctly",
    modalCheckbox: "Save and add Batch to Paddock/Pen",
    form: {
      name: "Activity Id",
      namePlaceHolder: "Activity name",
      externalIntegrationCode: "External Code",
      productionSubSystem: "Production subsystem",
      productionSubSystemPlaceHolder: "What is the production subsystem?",
      type: "Type",
      typePlaceHolder: "What is the type of Activity??",
      status: "Activity status",
    },
  },
  farm: {
    title: "Farms",
    table: {
      title: "Farms list",
      columns: {
        name: "Name",
        status: "Status",
      },
    },
    drawerTitle: "Farms Roster",
    drawerTitleEdit: "Edit Farm",
    drawerSubTitle: "Complete the fields below to create a new farm",
    drawerSubTitleEdit: "Complete the fields below to edit a farm",
    validationMessage: "Fill in all required fields (*) correctly",
    form: {
      logo: "Upload your farm's logo",
      confinement: "Confinement?",
      boitel: "Is it Boitel?",
      boitelVisibleToAllSystem:
        "Check the box if you want to appear in the Boitel - Daily list for all BovExo users.",
      checkVisibleForAllSystem:
        "By checking this box, you agree to add this farm to the list of suppliers and customers of this group and allow this farm to be searchable by all Bovexo users.",
      farmSisbov: "ERAS Farm (SISBOV)?",
      farmSisbovInfoTooltip:
        "By marking that the farm is ERAS (Approved Rural Establishments SISBOV), fields and controls related to traceability will be enabled.",
      name: "Farm trade name",
      namePlaceHolder: "Farm trade name",
      externalIntegrationCode: "External Code",
      externalIntegrationCodePlaceHolder: "External Code",
      group: "Group",
      groupPlaceHolder: "Select the group",
      companyName: "Corporate name",
      companyNamePlaceHolder: "Farm's corporate name",
      document: "CNPJ",
      documentPlaceHolder: "CNPJ",
      zipCode: "Postal Code",
      zipCodePlaceHolder: "Postal Code",
      address: "Address",
      addressPlaceHolder: "Road, Highway, street...",
      city: "City",
      cityPlaceHolder: "City",
      state: "State",
      statePlaceHolder: "State",
      status: "Farm status",
      country: "Country",
      countryPlaceHolder: "Country",
      totalArea: "Total area",
      rentAreaOutSourced: "Area leased to third parties",
      livestockArea: "Grazing area",
      nonProductiveArea: "Non-productive reserve area",
      cultivationArea: "Cultivation area",
      improvementsArea: "Improvement area",
      complementAddress: "Address complement",
      complementAddressPlaceHolder: "Address complement",
      farmOwner: "Owners",
      weatherStation: "Weather Station",
      weatherStationPlaceHolder: "Weather Station",
    },
    saveOptions: {
      only_save: "Save",
      save_and_create_new: "Save Farm and add a new one",
    },
    messages: {
      successSubmit: "Farm successfully created/updated.",
      errorSubmit: "Farm was not created/updated. Please contact support.",
      errorFarmDocumentAlreadyExists:
        "Farm document already exists in our database.",
      errorFarmOwnerDocumentAlreadyExists:
        "Owner document already exists in our database.",
    },
  },
  farmOwner: {
    title: "Farm Owners",
    buttonNew: "New",
    table: {
      columns: {
        code: "Code",
        name: "Name",
        document: "IRS/EIN",
        participation: "% Partic.",
        mainOwner: "Principal ?",
      },
    },
    form: {
      code: "Code",
      name: "Name",
      document: "IRS/EIN",
      participation: "% Partic.",
      mainOwner: "Principal ?",
    },
  },
  supplier: {
    title: "Suppliers",
    modalTitle: "Select a supplier",
    types: {
      supplement: "Supplem./Concent.",
      technology: "Technology",
      cattleFarmer: "Livestock",
      others: "Others",
      veterinarySupplement: "Veterinary Inputs",
    },
    table: {
      title: "Suppliers Roster",
      columns: {
        name: "Name",
        type: "Type",
        status: "Status",
        phoneNumber: "Contact",
        email: "Email",
        city_uf: "City/State",
      },
    },
    export: {
      columns: {
        id: "ID",
        farm_id: "Farm",
        name: "Name",
        type: "Type",
        document_type: "Document type",
        document: "Document",
        responsible_name: "Responsible name",
        email: "E-mail",
        phone_number: "Phone",
        address: "Address",
        zip_code: "ZIP",
        city_id: "City ID",
        city_name: "City",
        state_id: "State ID",
        state_name: "State",
        farm_status: "Status",
        external_integration_code: "External integration code",
      },
    },
    drawerTitle: "Supplier Registration",
    drawerTitleEdit: "Edit Supplier",
    drawerSubTitle: "Complete the fields below to create a new Supplier",
    drawerSubTitleEdit: "Complete the fields below to edit the Supplier",
    validationMessage: "Fill in all required fields (*) correctly",
    form: {
      name: "Supplier",
      namePlaceHolder: "Supplier Trading Name",
      type: "Type",
      externalIntegrationCode: "External Integration Code",
      externalIntegrationCodePlaceHolder: "External Integration Code",
      typePlaceHolder: "Supplyer Type",
      phoneNumber: "Contact",
      phoneNumberPlaceHolder: "Phone number",
      document: "IRS/EIN",
      documentPlaceHolder: "IRS or EIN",
      email: "Email",
      emailPlaceHolder: "E-mail",
      zipCode: "ZIP",
      zipCodePlaceHolder: "ZIP",
      address: "Address",
      addressPlaceHolder: "Street, Road...",
      city: "City/County",
      cityPlaceHolder: "City/County",
      state: "Sate",
      statePlaceHolder: "Sate",
      country: "Country",
      countryPlaceHolder: "Country",
      status: "Supplyer status",
      groupFarmVisibility: "Who will use this Supplier?",
      radiogroup: {
        farm: "This farm",
        group: "All farms in the group",
      },
    },
    saveOptions: {
      only_save: "Save",
      save_and_create_new: "Save Supplyer and add a new one",
    },
    messages: {
      cpfInvalid: "Incorrect CPF!",
      cpfInvalidDescription: "Please provide a valid CPF.",
      cnpjInvalid: "Incorrect CNPJ!",
      cnpjInvalidDescription: "Please provide a valid CNPJ.",
      contactFormatInvalid: "Invalid contact format.",
    },
  },
  manufacturer: {
    title: "Manufacturers",
    drawerTitle: "New Manufacturer",
    drawerSubTitle: "Fill in the fields below to create a new manufacturer",
    validationMessage: "Fill in all required fields marked with * correctly",
    form: {
      name: "Name",
      namePlaceHolder: "Manufacturer name",
    },
    messages: {
      duplicateName: "Manufacturer already registered!",
      duplicateNameDescription:
        "A manufacturer with this name already exists on this farm.",
      createSuccess: "Manufacturer created successfully",
      createError: "Could not create the manufacturer",
    },
  },
  clientList: {
    export: {
      columns: {
        name: "Name",
        type: "Type",
        document_type: "Document type",
        document: "Document",
        phone: "Phone",
        farm_status: "Status",
        zip_code: "ZIP",
        address: "Address",
        city: "City",
        state: "State",
      },
    },
  },
  cattleProducer: {
    title: "Producers",
    table: {
      title: "Producers list",
      columns: {
        name: "Name",
        document: "Document",
        status: "Status",
      },
    },
    drawer: {
      title: "Producer Registration",
      titleEdit: "Edit Producer",
    },
    form: {
      name: "Name",
      document: "Document",
      documentPlaceHolder: "CPF or CNPJ",
      properties: "Properties",
      property: "Property",
      propertyName: "Name",
      propertyDocument: "Document",
      addProperty: "Add Property",
      validation: {
        nameRequired: "Name is required",
        cpfError: "Invalid CPF!",
        cpfErrorDescription: "Please enter a valid CPF.",
        cnpjError: "Invalid CNPJ!",
        cnpjErrorDescription: "Please enter a valid CNPJ.",
        propertyCpfError: "Invalid property CPF!",
        propertyCpfErrorDescription:
          "Please enter a valid CPF for the property.",
        propertyCnpjError: "Invalid property CNPJ!",
        propertyCnpjErrorDescription:
          "Please enter a valid CNPJ for the property.",
      },
    },
    buttons: {
      buttonNew: "New Producer",
    },
    select: {
      placeholder: "Select a producer",
    },
    modal: {
      deleteTitle: "Confirm deletion",
      deleteContent: "Are you sure you want to delete this producer?",
    },
    notifications: {
      createSuccess: "Producer created successfully",
      createError: "Producer was not created",
      updateSuccess: "Producer updated successfully",
      updateError: "Producer was not updated",
      deleteSuccess: "Producer deleted successfully",
      deleteError: "Producer was not deleted",
      error5043Message:
        "Producer associated with a Contract. Cannot be deleted.",
    },
  },
  animal: {
    buttonNew: "New Animal",
    buttonGenerateReport: "Generate Animal Listing",
    buttonGenerateReportInfoTooltip:
      "Select one or more animal(s) in the table below to generate the report.",
    buttonGenerateReportERA: "Generate Movement Report",
    listingReportTitle: "Animal Listing",
    dashboard: {
      activeAnimals: "Active Animals",
      activeLots: "Active Batches",
      animalsByGender: {
        title: "Amt. per Gender",
        female: "Female",
        male: "Male",
      },
      hidePanels: "Hide panels",
      showPanels: "Show panels",
      extensive: "EXTENSIVE",
      semiIntensive: "SEMI-INTENSIVE",
      intensive: "INTENSIVE",
      gmd: "ADG",
      avgWeight: "Avg. weight",
      avgAge: "Avg. age",
      animals: "Animals",
      lots: "Batches",
      noAnimalAlert: "No animal alerts on this date",
      fattenTab: "Growing/Fattening",
      reproductionTab: "Reproduction",
    },
    messages: {
      createdSuccess: "Animal created successfully",
      updatedSuccess: "Animal updated successfully",
    },
    drawer: {
      title: "Add animal",
      validation: {
        supplierRequired: "Supplier not informed",
        supplierRequiredDesc:
          'Inform a supplier or check the option "Animal provided by own farm".',
        carcassYieldInvalid: "Invalid Carcass Yield",
        carcassYieldInvalidDesc:
          'The value of the "Carcass Yield" field must be within the range of values (45% and 60%)',
        datesInvalid: "Invalid Dates",
        datesInvalidDesc1: "Acquisition Date cannot be before Birth Date.",
        datesInvalidDesc2: "Weaning Date cannot be before Birth Date.",
        weightsInvalid: "Invalid Weights",
        birthWeightDesc: "Birth Weight cannot be greater than Weaning Weight.",
        duplicateIdentification:
          "There are active animals on this property that have the same Identification.",
      },
      messages: {
        alertTitle: "Alert",
        animalOver60Months: "The animal is more than 60 months old.",
        confirm: "Confirm?",
        createError: "Error registering",
        createErrorDesc: "Unable to register the animal. Contact support",
        updateError: "An error occurred while updating",
        updateErrorDesc: "Please contact the administrator.",
        cannotUpdate: "Unable to update.",
        animalHasEvent:
          "Animal has a {type} event after the specified death date.",
        eventDate: "Date:",
        identifyAnimal: "Attention! Do you want to identify this animal?",
        lastAnimalInLot:
          'Attention! This is the last animal in Batch "{lotName}". Upon confirming the death record, the Batch will have status "Pending". If you no longer use this batch, you can deactivate it.',
        animalDeadTitle: "Animal deceased",
        setAsAlive: "Set animal as alive",
        animalDiscardedTitle: "Animal discarded",
        discardCauseLabel: "Cause:",
        saleScenarioWarningEdit:
          "If the animal is in a batch that has sale scenario(s), upon confirming, reprocess the scenario(s) so the animal is considered.",
        saleScenarioWarningNew:
          "If the animal is added to a batch that has sale scenario(s), upon confirming, reprocess the scenario(s) so the animal is considered.",
      },
      form: {
        ownFarmAnimal: "Animal provided by own farm",
        milkCrossbreed: "Milk Crossbreed",
        ageLabel: "Age (days/months/years)",
        purposeReproduction: "Reproduction",
        purposeFatten: "Fattening",
        firstInsemination: "1st Insemination",
        traceabilitySISBOV: "TRACEABILITY (NAIS)",
        genealogy: "GENEALOGY",
        mother: "MOTHER",
        father: "FATHER",
        supplier: "Supplier",
        identification: "Identification",
        semen: "Semen",
        selectProductionLot:
          "Select an existing Production Lot for this animal:",
        productionLot: "Production lot",
        associateReceiptLot: "Associate the animal to a Receipt Lot.",
        receiptLot: "Receipt Lot",
      },
      saveOptions: {
        saveOnly: "Save only",
        saveAndAddNew: "Save and add new animal",
      },
      tooltips: {
        reproductionCategoryInfo: "",
      },
    },
    reproduction: {
      tabFemales: "Females",
      tabMales: "Males",
      identificationLabel: "Identification",
      identificationOptions: {
        handlingNumber: "Identification",
        tagId: "Electronic Tag",
        sisbov: "NAIS",
        nickname: "Name",
        registry: "Registry",
      },
      radioAnimals: "Animals",
      radioReproductionEvents: "Reproductive Events",
    },
    ageInputPlaceholders: {
      days: "Days",
      months: "Months",
      years: "Years",
    },
    animalDiscard: {
      descriptionPlaceholder: "Discard description",
    },
    animalDeath: {
      descriptionPlaceholder: "Death description",
    },
    curveParameter: {
      drawerTitle: "Animal parameters",
      defineParams: "Define the batch parameters",
      saveSuccess: "Estimated growth curve saved.",
      saveError: "There was an error saving the estimated growth curve.",
    },
    columns: {
      title: "Animals Roster",
      buttonCompare: "Compare",
      handlingNumber: "Identification",
      picket: "Paddock/Pen",
      lot: "BATCH",
      sisbov: "NAIS",
      tagId: "Electronic Tag Id",
      breed: "Breed",
      gender: "Gender",
      birthdayMonths: "Age",
      weightRanking: "Ranking",
      currentWeight: "Last Weight",
      gdp: "ADG",
      lastDailyWeightDate: "Last Weighing Date",
      target: "Target",
      status: "Status",
      supplier: "Supplier",
      reproductionCategory: "Reprod. Category",
      reproductionStatus: "Reprod. Situation",
      reproductionState: "Reprod. Status",
    },
    searchAnimal: {
      label: "Identification",
      modalTitle: "Select an animal",
      fieldLabel: "Search field",
      genderFilter: "Gender",
      genderAll: "All",
      male: "Male",
      female: "Female",
      handlingNumber: "Identification",
      sisbov: "NAIS",
      tagId: "Electronic Tag Id",
      nickname: "Nickname",
      registry: "Registry",
    },
    details: {
      animalProductionPageLink: "Productive Animals",
      animalPageDescription: "Animal Details",
      emptyMessage: "Animal data not found",
      bovexoId: "Id Bovexo",
      registry: "Registry",
      sisbov: "NAIS",
      age: "DOB",
      source: "Supplier",
      farmOwner: "Proprietário",
      castrated: "Castrated",
      tagId: "Electronic Tag Id",
      sex: "Gender",
      male: "Male",
      female: "Female",
      acquisition: "Acquisition",
      handlingNumber: "Identification",
      weight: "Weight",
      current: "Atual",
      location: "Location",
      picket: "Paddock/Pen",
      lot: "BATCH",
      breed: "Breed",
      weightGain: "Weight gain",
      accumulated: "Accumulated",
      lastWeight: "Last Weight",
      forSlaughter: "for Slaughter/Sell",
      expected: "Expected",
      asymptoticWeight: "Sigmoid weight",
      economicReturn: "Economic return",
      currentValue: "Current value",
      accumulatedCost: "Accumulated cost",
      animalFarmFunction: "Purpose",
      animalReproductionCategory: "Category",
      margin: "Margin",
      appropriateCosts: "Appropriated Costs",
      femaleSituation: "Condition",
      femaleSituationTime: "Condition time",
      birthForecast: "Birth Forecast",
      coverageDate: "Reprod Service Date",
      coverageType: "Reprod Service Type",
      coverageSemenOrMaleIdentification: "Bull",
      weightCoverage: "Weight at Reprod Serv.",
      semenDeparture: "Departure",
      observation: "Coverage Obs.",
      bodyConditionScore: "ECC",
      pregnancyDiagnosisDate: "Pregnancy Diagnosis Date",
      pregnancyDiagnosisResult: "Diagnosis Result (PD)",
      pregnancyDiagnosisOvarianEvaluationResult: "Ovarian Evaluation (PD)",
      birthDate: "Birth",
      birthType: "Birth Type",
      gestationDays: "Gestation Period",
      childsGender: "Calf Gender",
      childsIds: "Calf IDs",
      childsBirthday: "Birth Weight",
      childsStatus: "Current Calf Status",
      childsWeaningWeightDate: "Weaning Date",
      childsWeaningWeight: "Weaning Weight",
      iep: "Calving Interval",
      tab: {
        production: "Production",
        reproduction: "Breeding",
        genetic: "Genetic",
        geneology: "Genealogy",
        evaluation: "Assessment",
        zoonosis: "Zoonosis",
        weighing: "Weighings",
        dailyWeights: "Daily weights",
        weightGains: "Weight gains (ADG)",
        measurements: "Measurements",
        animalHistory: "History",
      },
      animalHistory: {
        lots: "Batch History",
        pickets: "Paddock History",
        refresh: "Refresh",
        lotName: "Lot",
        picketName: "Paddock Name",
        activity: "Activity",
        dietStrategy: "Diet Strategy",
        entryDate: "Entry",
        exitDate: "Exit",
        weightIn: "Entry Weight",
        weightOut: "Exit Weight",
        daysQuantity: "Days Qty",
      },
      history: {
        title: "Weight and measurement log",
        tooltipHistoryWeight:
          "In this option, the weights recorded for the animal and the respective weight gain will be displayed.\n\n 1. Weights: All weights recorded for the animal are displayed, even if more than one weighing occurs on the same day, such as weights from dynamic weighing scales.\n 2. Daily Weights: These are the weights that will actually be considered for the animal, whether for calculating GDP or ADG. If dynamic weighing scales are used, which can record more than one weight on the same day for the same animal, the rule defined in the Weights configuration, available in [Parameters/General], will be considered.\n 3. Weight gains (ADG): refers to ADG, that is, the daily gain between the weighing on this date and the previous one.",
        grid: {
          emptyMessage: "There is no recorded weight history",
          emptyMessageMeasurements: "There are no measurements recorded",
          in: "Start",
          out: "End",
          manual: "Manual",
          date: "Date",
          hour: "Time",
          inOut: "S/E",
          weight: "Weight(kg)",
          eventTitle: "Type",
          originEvent: {
            birthday: "DOB",
            purchase: "Acquisition",
            weaning: "Weaning",
            sale: "Sold",
            transfer: "Transfer",
          },
        },
      },
      totalWeight: {
        title: "Total Weight",
        tooltip:
          "Este gráfico compara o último peso do animal com a media dos animais semelhantes no mesmo grupo genético, raça e do mesmo lote",
        graph: {
          currentWeight: "Current Weight",
          lot: "BATCH",
          genetic: "Genetic",
          breed: "Breed",
          weight: "Weight",
          type: "Type",
          estimated: "Expected ED",
        },
      },
      averageDailyGain: {
        title: "Average Daily Gain",
        tooltip:
          "This graph compares the animal's last daily weight gain with the average of similar animals in the same genetic group, breed and from the same batch.",
        graph: {
          currentGain: "Current ADG",
          lot: "BATCH",
          genetic: "Genetic",
          breed: "Breed",
          weight: "Weight",
          type: "Type",
          estimated: "Expected ED",
        },
      },
      dailyWeightGain: {
        title: "EVOLUTION OF WEIGHT AND ADG",
        graph: {
          weight: "Weight",
          time: "Days",
        },
      },
    },
    drawerTitleEdit: "Edit Animal",
    drawerSubTitleEdit: "Fill in the details below to edit an animal",
    drawerSubTitleEditDeathAnimal: "Dead animal, all fields have been disabled",
    drawerAnimalDeathTitle: "Dead Animal",
    animalDeathPopConfirmTitle:
      "Upon confirmation, the animal is considered to be in a state of permanent death.",
    edit: {
      form: {
        nickname: "Name",
        nicknamePlaceHolder: "Name",
        registry: "Registry",
        registryPlaceHolder: "Registry",
        sisbov: "NAIS",
        sisbovPlaceHolder: "NAIS",
        tagId: "Electronic Tag Id",
        tagIdPlaceHolder: "Electronic Tag Id",
        sex: "Gender",
        male: "Male",
        female: "Female",
        acquisition: "Acquisition",
        handlingNumber: "Identification",
        handlingNumberPlaceHolder: "Animal Id.",
        breed: "Breed",
        breedPlaceHolder: "Select breed",
        cap: "Castrated animal?",
        birthday: "DOB",
        birthdayWeight: "Birth weight",
        firstInseminationWeight: "First insemination",
        weaningWeight: "Weaning weight",
        weaningDate: "Weaning Date",
        asymptoticWeight: "Sigmoid weight",
        asymptoticWeightInfoTooltip:
          "Sigmoid weight is the weight that, based on the information that the user/producer has about the history of the Animal or Batch of Animals (considering genetics, previous management, genotype-environment interaction, frame, among other variables), he believes to be the potential weight limit. In other words, above this weight, this animal will hardly gain weight under normal conditions.",
        acquisitionDate: "Acquisition date",
        purchaseCost: "Acquisition price",
        acquisitionEstimatedWeight: "Acquisition weight",
        carcassHarnessing: "Carcass yield",
        animalFarmFunction: "Purpose",
        animalReproductionCategory: "Category",
        sisbovIdentificationDate: "Identif Date",
        sisbovInsertBNDDate: "Date Inclusion NAIS",
        sisbovSlaughterDate: "Slaughter Release Date",
        farmOwner: "Owner",
      },
      weights: "Weights",
      receipt: "Received",
      sale: "Sale",
    },
    drawerAnimalDiscardTitle: "Animal disposal",
    discard: {
      motives: {
        Age: "Age",
        ReproductiveProblems: "Reproductive Issues",
        IllnessesOrPhysicalProblems: "Illnesses or Physical Problems",
        BodyCondition: "Body condition",
        NegativePregnancy: "Negative Pregnancy",
        MaternalAbility: "Maternal Ability",
      },
    },
    carcassHarnessingInfoTooltip:
      "The animal's carcass yiled must be reported if there is an ultrasound carcass analysis. The utilization of the Batch and the Diet Strategy are expectations. When both are present, Animal, Diet, Batch prevail in this order.",
  },
  dietStrategy: {
    new: {
      title: "Creating diet strategy",
      message:
        "Select the total period of the strategy and define the diets and the execution time of each one",
      name: "Diet Strategy name",
      namePlaceHolder: "Diet Strategy name",
      totalPeriod: "Total period",
      year: "Year",
      oneYear: "1 year",
      twoYears: "2 years",
      threeYears: "3 years",
      dietAndExecutionTime: "Diets and execution time",
      dietPlaceHolder: "Select a diet",
      deleteDietPeriod: "Delete diet",
      totalTime: "Total period",
      weeks: "Week(s)",
      buttonAddDiet: "Add Diet",
      drawerTitle: "Diet Strategy summary",
      start: "Start",
      end: "End",
      notification: {
        success: {
          message: "Diet strategy created!",
          description: "The strategy was included in the system.",
        },
        error: {
          dontHaveName: {
            message: "Error",
            description: "You must enter a name for the diet strategy!",
          },
          dontHaveDiet: {
            message: "Error",
            description: "All periods need a selected diet.",
          },
        },
      },
    },
    title: "Diet Strategies List",
    buttonNewDietStrategy: "New Strategy",
    table: {
      status: "Status",
      name: "Name",
      diet: "Diet",
      totalTime: "Total time",
    },
    modal: {
      simple: {
        title: "Divergent Production Subsystem",
        message:
          "The production subsystem selected for this period does not correspond to the subsystem used in the paddock/pen where the batch is allocated. To obtain good performance, it is recommended that both use the same system.",
        confirmButton: "OK, I get it.",
      },
    },
  },
  weightStrategy: {
    title: "Weight Strategy",
    tabs: {
      dietStrategy: "Diet Strategy",
      weightGainProjection: "Weight Gain Projection",
    },
  },
  generalParameters: {
    weatherSeason: {
      title: "Weather Stations",
      editMessage:
        "Define the most suitable weather stations for the location of the farm using the box on the side:",
      table: {
        columnDayMonth: "Days/Month",
        columnNextSeason: "Next Season",
        columnMonthSeason: "Current Season",
      },
    },
    farmDeathReason: {
      buttonNew: "New",
      table: {
        title: "Cause Mortis",
        columns: {
          name: "Name",
          status: "Condition",
        },
      },
    },
    quotas: {
      buttonNew: "New",
      table: {
        title: "Quotas",
        columns: {
          name: "Name",
          type: "Type",
          status: "Condition",
        },
      },
    },
    successParameterUpdated: "Parameters changed successfully!",
    errorParameterUpdated: "Oops... the parameters were not changed",
  },
  cost: {
    tabs: {
      fixedCost: "Fixed Assets Costs",
      infrastructureCost: "Infrastructure and workforce",
      operatingVariableCost: "Operational variables",
      zootechnicalVariableCost: "Zootechnical costs",
      sanityCost: "Animal health",
    },
    form: {
      error:
        'It is necessary to inform the fields "Cost Value"and "Depreciation"in the costs marked in red',
      growth: "Cow-Calf",
      recreateFattenPasture: "R&F - Pasture",
      recreateFattenSemiConfinement: "R&F - Pasture/Feedlot",
      recreateFattenConfinement: "R&F - Feedlot ",
      area: "Area",
      potentialOccupation: "Max Stocking Density",
      staticCapacity: "Carrying Capac.",
      staticCapacityTooltip:
        "The values in this field are calculated by multiplying the Area by the Max Stocking Density.",
      fence: "Fencing",
      costValue: "Cost",
      depreciationValue: "Depreciation",
      total: "Total",
      amountAnimals: "Amt. Animals",
      totalDailyCostPerAnimal: "Daily cost per animal",
      dietCost: "Diet",
      costProtocol: "Custo de Vet Procedure",
    },
    costType: {
      FixedCost: "Fixed Asset Costs",
      InfrastructureCost: "Infrastructure and workforce costs",
      OperatingVariableCost: "Operational variables",
      ZootechnicalVariableCost: "Zootech/Vet Costs",
      sanityCost: "Animal Health costs",
    },
    code: {
      1: "Offices & Buildings",
      2: "Taxes ",
      3: "Insurance",
      4: "Pasture establishment",
      5: "Fencing",
      6: "Corral",
      7: "Dams",
      8: "Machines and Implements",
      9: "Buildings & infra",
      10: "Operational workforce",
      11: "Technical workforce",
      12: "3rds Tech workforce",
      13: "Energy",
      14: "Phone/Internet",
      15: "ERP",
      16: "Accounting office",
      17: "Maintenance of Buildings/Infra",
      18: "Maintenance of Machines/Implem",
      19: "Fuel and Lubricants",
      20: "Pasture maintenance",
      21: "Fertilization",
      22: "Maintenance of Corral/Fences",
      23: "Pasture Leasing",
      24: "Vaccines",
      25: "Vermifuges",
      26: "Medicines",
      27: "Identification",
      28: "Costs with Service Animals and related",
      29: "Other Admin. Costs",
      30: "Vet Procedure cost",
    },
  },
  saleScenario: {
    error: {
      DietStrategyExpired:
        "It was not possible to process the sales scenario because it contains expired diet strategies.",
      InternalError:
        "There was an error processing the scenario. Please contact support.",
    },
  },
  purchaseScenario: {
    error: {
      DietStrategyExpired:
        "The Purchase Scenario could not be processed because the Diet Strategy provided is Expired.",
    },
  },
  movementHistory: {
    title: "Transaction History(s)",
    table: {
      columns: {
        originalLotsNames: "Origin Batches",
        destinationLotsNames: "Destination Batches",
        requestDate: "Movement Date",
        fromDismemberLot: "Splitting?",
        fileName: "File name",
        animalHandlingNumber: "Animal",
        lotOriginName: "Origin Batch",
        lotDestinationName: "Destination Batch",
        createdAtDate: "Registration Date",
      },
    },
  },
  financial: {
    tabs: {
      costing: "Costing",
      cashFlow: "Cash Flow",
      parameters: "Parameters",
      transactions: "Financial Entries",
      animalSell: "Transf/Production Sales",
      resultCenterAnalysis: "CC/PC Analysis",
      bankConciliation: "Bank Conciliation",
    },
    costType: {
      Growth: "Cow-Calf",
      RecreateFattenPasture: "Ext - Pasture",
      RecreateFattenSemiConfinement: "Semi- Pasture/Feedlot",
      RecreateFattenConfinement: "Int - Feedlot",
      Agriculture: "Crops",
      Others: "Others",
    },
    transactions: {
      title: "Entries",
      buttonCreateNewFinancialTransaction: "New Posting",
      buttonExportTransactions: "Export records",
      form: {
        title: "New Posting",
        documentNumber: "Invoice/Sales Tax doc number",
        supplierId: "Supplier",
        billingDate: "Invoice Date",
        expirationDate: "Due date",
        mainValueCurrency: "Select currency",
        mainValue: "Gross Value",
        fees: "Interest/Fines Value",
        discount: "Discounts",
        value: "Net value",
        payment: "Payment",
        actions: "Action",
        actionsOptions: {
          launch: "Post",
          launchAndSettle: "Post and Settling",
          settle: "Settling",
        },
        settleDate: "Settling date",
        inCash: "In cash",
        part: "Installments",
        financialNatureId: "Nature",
        financialClassId: "Class",
        costActivityType: "Activity",
        description: "Description",
        resultCenter: "Profit Center",
        resultCenterApportionmentDefault: "Default",
        resultCenterApportionmentCustom: "Redefine",
        transactionType: "Type",
        clientId: "Customer",
        financialProjectId: "Investment Project",
        bonus: "Bonus",
        financialIssueId: "Financial Issue",
        financialPaymentMethodId: "Payment Method",
        financialTaxableDeductibleId: "Taxable/Deductible IR",
        bankAccountFarmId: "Paying Source",
        errors: {
          installmentsNotGeneratedError:
            'It is necessary to generate the installments. To do this, click on the "Installments"option in the "Payment"field.',
        },
      },
      modalInstallments: {
        title: "Create Installments",
        value: "Trx Value",
        expirationDate: "Due date",
        installmentTotal: "No  of Installments",
        buttonCalc: "Calculate",
        expireDateRequired:
          "It is necessary to enter the Due Date to generate the installments.",
      },
      modalEditInstallment: {
        title: "Edit installment settlement details",
      },
      table: {
        columns: {
          nature: "Nature",
          class: "Class",
          values: "Values",
          origin: "Origin",
          billingDate: "Invoice Date",
          expirationDate: "Due Date",
          installment: "Installment",
          documentNumber: "Invoice Number",
          value: "Value",
          bankAccountFarmName: "Payment Source",
          isPaidPartially: "Part. Paid",
          isSettled: "Status",
          settleDate: "Settling Date",
          financialClassDepreciation: "Allocation",
          valueDepreciation: "Allocation Cost",
          supplierName: "Supplier/Customer",
          costActivityType: "Activity",
          r: "CR",
          financialProjectName: "Projects",
          transactionType: "Type",
          entityName: "Supplier/Customer",
          financialIssueId: "Financial Issue",
          financialPaymentMethodId: "Payment Method",
          financialTaxableDeductibleId: "Taxable/Deductible IR",
          bankAccountFarmId: "Paying Source",
          discount: "Discount",
          fees: "Fees",
        },
      },
      modalResultCenterApportionment: {
        title: "Allocation by Profit Center",
      },
    },
    cashFlow: {
      title: "Cash Flow",
      buttonDisbursementReport: "Disbursement Report",
      buttonCashFlowReport: "Cash Flow Report",
      buttonCreateBudget: "New Budget",
      filters: {
        status: "Status",
        visualization: "Visualization",
        exibition: "Display",
        timeExibition: "Time Exibition",
        timeExibitionOptions: {
          year: "Year",
          harvest: "Harvesting year",
        },
        harvest: "Harvesting year/Year",
        costType: "Activity",
        financialProjectId: "Investment Project",
        bankAccountFarmId: "Paying Source",
      },
      table: {
        columns: {
          nature: "Nature",
          class: "Class",
          values: "Values",
        },
      },
    },
    costing: {
      title: "Costs Table",
      filters: {
        visualization: "Display",
        timeExibition: "Time Exibition",
        timeExibitionOptions: {
          year: "Year",
          harvest: "Harvesting year",
        },
        harvest: "Harvesting year/Year",
        costType: "Activity",
        financialProjectId: "Investment Project",
        bankAccountFarmId: "Paying Source",
      },
      table: {
        columns: {
          nature: "Nature",
          class: "Class",
          values: "Values",
        },
      },
    },
    parameters: {
      tabs: {
        parameters: "Parameters",
        costing: "Costing",
        resultCenter: "Profit Center",
        costCenter: "Cost Center",
        financialProject: "Investiment Projects",
        additionalControls: "Additional Controls",
        financialIssue: "Financial Issues",
        financialPaymentMethod: "Payment Methods",
        financialTaxableDeductible: "Taxable/Deductible IR",
        bankAccountFarm: "Bank Accounts",
      },
      generalFinancialParameters: {
        title: "Parameters",
        parameter4001: "Use currency conversion?",
        parameter4002: "Diet Costs",
        parameter4002Help:
          "Define whether diet costs will be appropriate for animals based on the Diet Strategy or Supply",
        parameter4002DietStrategy: "Diet Strategy",
        parameter4002SupplementSupply: "Supply",
        farmConvertions: {
          title: "Currencies",
          buttonNew: "New Currency",
          table: {},
          form: {
            titleNew: "New Currency",
            currency: "Currency",
            standard: "Set as default?",
          },
        },
      },
      costing: {
        title: "Costing Parameters Table",
        table: {
          columns: {
            nature: "Nature",
            stock: "Inventory Control",
            class: "Class",
            depreciation: "Depreciation (Months)",
            shouldCost: "Costing",
            shouldDisbursement: "Disbursement",
            product: "Product",
            costCenter: "Cost Center",
            type: "Type",
            expense: "Expense",
            revenue: "Revenue",
            defaultValueChanged: "Default value changed",
          },
        },
        buttonNew: "New class",
        messages: {
          inactivateSuccess: "Financial class inactivated successfully.",
          inactivateError:
            "Could not inactivate financial class. Contact support.",
          activateSuccess: "Financial class activated successfully.",
          activateError: "Could not activate financial class. Contact support.",
          resetSuccess:
            "Financial class reset successfully, BovExo default values have been restored.",
          resetError: "Could not reset financial class. Contact support.",
          resetDefault: "Reset default values",
        },
      },
      resultCenter: {
        title: "Table of Profit Centers",
        buttonNew: "New",
        form: {
          title: "Profit Centers",
          labelTitle: "Title:",
          labelType: "Type:",
          labelStartDate: "Start Validity:",
          labelEndDate: "End Validity:",
          labelName: "Name",
          labelCode: "Code",
          labelNameColon: "Name:",
          labelCodeColon: "Code:",
        },
        financialNatureApportionmentForm: {
          title: "Criteria for Allocation of Expenses/Indirect Costs",
        },
        messages: {
          deleteSuccess: "Result Center deleted successfully",
          deleteError: "Could not delete the Result Center. Contact support",
          saveSuccess: "Result Center created successfully",
          updateSuccess: "Result Center updated successfully",
          saveError: "Could not save the Result Center. Contact support",
          loadError: "Could not load the result center. Contact support",
          apportionmentUpdateSuccess: "Apportionment updated successfully",
          apportionmentUpdateError:
            "Could not update the apportionment. Contact support",
          apportionmentLoadError:
            "Could not load result center apportionment. Contact support",
          validateError: "Values must add up to 100%",
          finalDateBeforeInitial:
            "The End Validity cannot be before the Start Validity.",
          noRetreats: "No retreats registered.",
          noOwners: "No owners registered.",
          noActivities: "Activities not entered.",
          noItems: "Items not entered.",
        },
        tableColumns: {
          nome: "Name",
          tipo: "Type",
          status: "Status",
          padrao: "Standard",
        },
        types: {
          activityType: "Activities",
          retreat: "Retreats",
          farmOwner: "Owners",
          custom: "Manual",
        },
      },
      costCenter: {
        title: "Costs Centers Table",
        buttonNew: "New",
        form: {
          title: "Costs Centers",
          labelTitle: "Title:",
          labelStartDate: "Start Validity:",
          labelEndDate: "End Validity:",
          labelResultCenter: "Result Center",
          columnClass: "Class",
          columnName: "Name",
          apportionmentAutomatic: "Automatic",
          apportionmentNumberOfAnimals: "# Animals",
          apportionmentArea: "Area",
        },
        apportionmentForm: {
          title: "Cost Centers x Profit Centers",
        },
        modal: {
          title: "Costs Centers",
          table: {
            columns: {
              financialClass: "Class",
            },
          },
        },
        messages: {
          deleteSuccess: "Cost Center deleted successfully",
          deleteError: "Could not delete the Cost Center. Contact support",
          saveSuccess: "Cost Center created successfully",
          updateSuccess: "Cost Center updated successfully",
          saveError: "Could not save the Cost Center. Contact support",
          loadError: "Could not load the cost center. Contact support",
          apportionmentUpdateSuccess: "Apportionment updated successfully",
          apportionmentUpdateError:
            "Could not update the apportionment. Contact support",
          apportionmentLoadError:
            "Could not load cost center information. Contact support",
          resultCenterLoadError:
            "Could not load result center information. Contact support",
          finalDateBeforeInitial:
            "The End Validity cannot be before the Start Validity.",
          noItems: "Cannot save the Cost Center without entering all items",
        },
      },
      farmConvertions: {
        messages: {
          currencyCreated: "Currency registered successfully.",
          currencyAlreadyRegistered: "Currency already registered!",
          currencyFavorited: "Currency set as default successfully.",
          currencyActivated: "Currency activated successfully.",
          currencyInactivated: "Currency inactivated successfully.",
        },
      },
    },
    animalSell: {
      title: "Transf/Production Sales",
      buttonNew: "New Transf./Sale",
      buttonExport: "Sales result",
      form: {
        title: "Transfer/Production Sales",
        animalSelectionDescription:
          "Select the animals in the table to proceed with the sale.",
        sellDate: "Departure Date",
        client: "Client",
        financialNatureId: "Financial Nature",
        financialClassId: "Class",
        priceNegotiated: "Negotiated Price",
        weightPerAnimal: "Average Weight/Animal",
        carcassHarnessing: "Carcass Yield",
        documentNumber: "Tax Document No.",
        supplier: "Supplier",
        billingDate: "Billing Date",
        expirationDate: "Due Date",
        payment: "Payment",
        inCash: "In Cash",
        part: "Installments",
        resultCenter: "Result Center",
        resultCenterApportionmentDefault: "Default",
        resultCenterApportionmentCustom: "Redefine",
        totalValue: "Total Billing",
        AVERAGE_COST: "Current Avg. Cost",
        AVERAGE_MARKET_VALUE: "Avg. Market Value",
        MARGIN_VALUE: "Margin on Cost",
        MARGIN_VALUE_INFO_TOOLTIP:
          'The "Negotiated Price" will be the Current Avg. Cost plus the informed margin.',
        INPUT_PRICE: "Informed Value",
        AVERAGE_LAST_WEIGHT: "Avg. Weight Last Weighing",
        AVERAGE_PROGRESSIVE_WEIGHT: "Current Estimated Avg. Weight",
        INPUT_WEIGHT: "Informed Weight",
        animalTableColumns: {
          handlingNumber: "ID",
          lotName: "Lot",
          picketName: "Picket/Bay",
          breedName: "Breed",
          gender: "Gender",
          age: "Age",
          lastDailyWeight: "Last Weight",
          lastDailyWeightDate: "Last Weighing",
          weightSell: "Sale Weight",
          carcassHarnessing: "Carcass Yield",
          pricePerKilo: "Price/Kg",
          pricePerArroba: "Price/@",
          priceNegotiated: "Sale Price",
          removeAnimal: "Remove",
          removeSelectedAnimals: "Remove selected",
        },
        financialIssueId: "Financial Issue",
        financialPaymentMethodId: "Payment Method",
        financialTaxableDeductibleId: "Taxable/Deductible IR",
        bankAccountFarmId: "Paying Source",
        carcassType: {
          PERCENTAGE: "%",
          WEIGHT: "Weight",
        },
      },
      table: {
        columns: {
          origin: "Origin",
          isTransfer: "Transf.",
          documentNumber: "Invoice Number",
          client: "Customer",
          sellDate: "Inv. Date",
          amountAnimais: "No  Animals",
          gender: "Gender",
          totalValue: "Total Amount",
          averageValue: "Value/animal",
          carcassHarnessing: "% Carc. Yield",
          paymentType: "Payment",
          financialProjectName: "Projects",
        },
      },
      transferPanelTable: {
        columns: {
          status: "Status",
          originGroupName: "Origin Group",
          originFarmName: "Origin Farm",
          amountAnimals: "Qty. Animals",
        },
      },
      messages: {
        errorAtLeastOneAnimal:
          "At least one animal must be selected for the sale.",
        selectClientText1:
          "Will this animal transfer involve financial compensation (payment) between the parties?",
        selectClientText2:
          "We have detected that this may be an operation of animal transfer between units of the same economic group. BovExo does not manage the tax/legal aspects of the operation, but for the purpose of analyzing operation results, the minimum value that will be recorded, for general purposes, is the accumulated cost of the transacted animals.",
        infoTooltipText1:
          "This value will be calculated according to the type of Negotiated Value, as follows:",
        infoTooltipText2:
          "Negotiated Value per @: Corresponds to the average weight of the animals, converted into @ (i.e., divided by 15). The number of @ is multiplied by the negotiated @ value with the buyer, and then multiplied by the carcass yield. This results in the average value per animal, which is then multiplied by the number of animals, leading to the total billing amount.",
        infoTooltipText3:
          "Negotiated Value per Kg: Corresponds to the average weight of the animals, multiplied by the number of animals, and then multiplied by the reported Kg value, leading to the total billing amount.",
        successSubmitCreate:
          "Your sale is being processed and will be completed soon.",
        errorSubmitCreate:
          "The sale could not be completed. Please contact support.",
        successSubmitUpdate:
          "The update to your sale is being processed and will be completed soon.",
        errorSubmitUpdate:
          "The sale could not be updated. Please contact support.",
        error5032:
          'Attention! This sale cannot be modified because its financial transaction has been "Processed".',
        modalErrorAnimalsWithPreviousEvents:
          "Animals have events after the informed sale date!",
        modalAlertAnimalsInSaleScenarioText1: "Attention!",
        modalAlertAnimalsInSaleScenarioText2:
          "There are selected animals that are associated with Active Sales Scenarios. By confirming the sale, these Sales Scenarios will be reprocessed, generating a new result for the animals that are still active.",
        modalConfirmPriceNegotiatedText1:
          'The value entered in the "Negotiated Price" field is lower than what should be assigned for managerial purposes.',
        modalConfirmPriceNegotiatedText2: "Do you confirm the value?",
        successOnDelete: "Transfer/Sale successfully deleted.",
        errorMessageOnDeleteTransferAlreadyConfirmed:
          "Attention! This sale/transfer has already been confirmed at the Destination farm.",
        errorMessageOnDelete: "Sale was not deleted. Please contact support.",
        modalConfirmFinancialTransactions:
          "Update the Financial Transaction for this Sale?",
        modalConfirmExpirationDate:
          "Attention! The due date is earlier than the billing date.",
        error: "Error",
        errorNoAnimals: "Cannot continue without informing animals",
        errorAnimalsWithoutSaleWeight:
          "There are animals without sale weight information",
        errorCarcassHarnessingRange:
          "Carcass yield must be between 25% and 75.5%",
        errorCarcassHarnessingGreaterThanWeight:
          "Carcass yield cannot be greater than animal weight",
        errorAnimalsWithoutCarcassHarnessing:
          "There are animals without carcass yield information",
        errorAnimalsCarcassHarnessingOutOfRange:
          "There are animals with carcass yield outside the allowed range 25% to 75.5%",
        errorAnimalsCarcassWeightOutOfRange:
          "There are animals with carcass weight outside the allowed range",
        errorBillingDateBeforeSellDate:
          "Billing date cannot be earlier than departure date.",
        errorInvalidInstallments: "Invalid installments!",
        errorInvalidResultCenter: "Invalid Result Center!",
        errorFinancialProjectAfterBillingDate:
          "The selected financial project starts after the billing date. Please select another project.",
        errorSaleWithEventsAfterDate:
          "Sale of animals with events after the departure date is not allowed!",
        errorRegisterTransaction: "Could not register transaction.",
        modalAnimalLastEventIdentification: "Identification",
        modalAnimalLastEventEvent: "Event",
        modalAnimalLastEventDate: "Date",
        ok: "Ok",
        attention: "Attention",
        generateDocumentTooltip:
          'Generate unique "{documentNumber}" automatically.',
      },
    },
    resultCenterAnalysis: {
      filters: {
        resultCenter: "Profit Center",
        costCenter: "Cost Center",
        period: "Period",
        visualization: {
          label: "Visualization",
          costing: "Costing",
          cashFlow: "Cash Flow",
        },
        buttonConfirm: "Process",
      },
      income: {
        title: "Revenue",
        costCenterName: "Cost Center",
        total: "Total Value",
        totalPercentage: "Total (%)",
      },
      expense: {
        title: "Expenses",
        costCenterName: "Cost Center",
        total: "Total Value",
        totalPercentage: "Total (%)",
      },
      total: "Balance",
    },
    messages: {
      deleteSuccess: "Transaction deleted successfully.",
      deleteError: "Transaction was not deleted. Contact support.",
      issueResolved: "Transaction issue resolved.",
      issueReopened: "Transaction issue reopened.",
      saveSuccess: "Financial transaction saved successfully.",
      updateSuccess: "Financial transaction updated successfully.",
      saveError:
        "An error occurred while registering the transaction. Contact support",
      errorTitle: "Registration error",
      projectAfterBillingDate:
        "The selected financial project starts after the billing date. Please select another project.",
      budgetExceeded: "Budgeted value for this Class has been exceeded.",
      budgetWarningTitle: "Attention!",
      classNotCosting:
        "Transactions associated with this Class are not considered for Costing, only for Cash Flow management.",
      classNotCostingTitle: "Attention",
      errorDateExpiration: "Attention! Due date is earlier than Billing date.",
      errorDateConfirm: "Confirm",
      errorDateCancel: "Cancel",
      editingTransaction: "Editing transaction",
      resultCenterReinform: "Please re-enter the Result Center apportionment.",
      noAnimalsForSale: "To continue, you must select at least 1 animal.",
      resultCenterLoadError: "No result center found!",
      deleteTransactionConfirm:
        "When deleting this transaction, all transactions related to the Document and Supplier/Customer will also be deleted",
      saveErrorTitle: "Error saving",
      saveInvoiceError: "Error saving invoice. Contact support.",
    },
    table: {
      rateio: "Apportionment",
      parcelas: "Installments",
      partialPayment: "Part. Payment",
      issueResolved: "Issue Resolved",
      issueReopen: "Reopen Issue",
      valuePaid: "Paid Amount",
      remainingValue: "Remaining value",
      tagOpen: "Open",
      tagSettled: "Settled",
      tagConciliated: "Conciliated",
      tagPartialConciliated: "Part. Conciliated",
      tagExternal: "External",
      tagConversion: "Conversion",
      tagPending: "Pending",
      tagStandard: "Standard",
      settle: "Settle",
      removeSettle: "Remove settle(s)",
      tooltipSettle: "Select one or more transactions to settle",
      tooltipRemoveSettle:
        "Select one or more transactions to remove the settlements",
    },
    apportionmentActivity: {
      title: "Activity Apportionment",
      totalValue: "Total value",
      apportionmentType: "Apportionment type",
      byHead: "By Head",
      byPercentage: "Percentage",
    },
    resultCenter: {
      editedLabel: "(Edited)",
      numberOfAnimals: "# Animals",
      area: "Area",
    },
    financialNatureApportionmentForm: {
      natureza: "Nature",
      rateio: "Apportionment",
      numberOfAnimals: "# Animals",
      area: "Area",
      automatic: "Automatic",
    },
    resultCenterApportionment: {
      loadError: "Could not load result center information. Contact support",
      apportionmentTypeRequired: "Apportionment type not informed.",
      apportionmentSumError: "Sum of apportionment must be 100%.",
    },
    bankConciliation: {
      statement: {
        fileLoaded: "File loaded successfully",
        fileError: "Error sending the file",
        fileErrorBankNotRegistered:
          "Error processing the file. Bank not registered.",
        fileErrorAccountNotRegistered:
          "Error processing the file. Bank Account not registered.",
        fileErrorAlreadyImported:
          "Error processing the file. File has already been imported.",
        statementSaved: "Statement saved successfully",
        statementSaveError: "Error saving the statement",
        selectFile: "Select a file",
        selectRecord: "Select at least one record to continue",
      },
    },
    settleModal: {
      messages: {
        fetchError: "Error fetching financial transactions",
        settleSuccess: "Financial transactions have been updated and settled",
        settleError:
          "Could not settle the financial transactions. Contact support.",
        unsettleSuccess:
          'Financial transactions have been updated and their status changed to "Open"',
        unsettleError:
          "Could not update the financial transactions. Contact support.",
        selectFirst: "You need to select the transactions first.",
        dateIncompatibleError:
          "Settle date incompatible with the billing date of {{count}} Financial Transaction(s).",
        alreadySettledWarningTitle: "Warning",
        alreadySettledWarningContent:
          "Transactions that were already settled will be updated. Do you wish to continue?",
        alreadySettledWarningOk: "No",
        alreadySettledWarningCancel: "Yes",
        selectOnlySettledError:
          'Please select only transactions with the status "Settled".',
        selectOnlyNotPartiallyPaidError:
          "Please select only transactions that were not partially paid.",
        errorTitle: "Error",
        warningTitle: "Warning",
      },
    },
    financialClass: {
      messages: {
        saveSuccess: "Financial class created successfully.",
        updateSuccess: "Financial class updated successfully.",
        saveError: "Error creating/updating financial class. Contact support.",
        warningTitle:
          "Upon confirming, the following items should be considered:",
        warningContent:
          'Update the information of this new Class in "Cost Center X Result Center" for all Cost Centers in Parameters > Costing > Cost Center, otherwise the costs and transactions of this Class will not be appropriated.',
      },
    },
    financialProject: {
      messages: {
        alreadyExists: "Warning! A project with this name already exists.",
        saveSuccess: "Financial Project registered/updated successfully.",
        saveError: "Error saving the Financial Project. Contact support.",
      },
    },
    financialCashFlowBudget: {
      title: "New budget",
      form: {
        monthYear: "Month/Year*",
        activities: "Activities*",
        defaultCurrency: "Default currency",
        total: "Total:",
        insertUntilMonthYear: "Insert/Update until Month/Year",
      },
      messages: {
        dateError:
          'The month and year of the "Insert/Update until Month/Year" field must be greater than the start month and year.',
        valueError: 'It is necessary to enter a value for a "Class".',
        saveSuccess: "Budget registered successfully",
        saveError: "Error registering budget. Contact support.",
      },
    },
    importFinancialTransactionNote:
      "Note: If a Document Number is not provided, the system will generate a random number.",
    importSelectCurrencyLabel: "Select the import currency",
    import: {
      messages: {
        templateGenerating:
          "Your import template is being generated and will be downloaded shortly. Please wait.",
        templateError:
          "There was an error generating the template. Contact support.",
        importedAndUpdated: "Financial transactions imported and updated",
        importedAndUpdatedDesc:
          'Some financial transactions were updated/inserted. Access the "Imports" menu, "Financial Transactions" tab for details.',
        imported: "Financial transactions imported",
        partiallyImported: "Financial transactions partially imported",
        partiallyImportedDesc:
          'Some financial transactions were not imported. Access the "Imports" menu, "Financial Transactions" tab for details.',
        processedWithError: "File processed with error!",
        processedWithErrorDesc:
          'All financial transactions were not imported. Access the "Imports" menu, "Financial Transactions" tab for details.',
        importError: "Import error",
        importErrorDesc: "No financial transaction was included.",
      },
    },
    partialPayment: {
      messages: {
        saveSuccess: "Partial payment saved successfully.",
        saveError: "Could not save partial payment. Contact support.",
        valueExceedsError:
          'The value of the "Partial Payment Value" field must be less than the value of {{value}} of the original financial transaction.',
      },
    },
    export: {
      messages: {
        dateError: "Expiration date cannot be before billing date.",
        exportError: "Internal error. Contact support!",
      },
    },
    dashboard: {
      form: {},
      messages: {
        loadError: "Error returning financial dashboard result!",
        projectsNotFound: "No financial projects found!",
        resultCenterNotFound: "No result center found!",
        costCenterNotFound: "No cost center found!",
      },
    },
  },
  costs: {
    messages: {
      depreciationRequired:
        "It is mandatory to enter the Depreciation value for costs that have been filled in with their value.",
    },
  },
  costType: {
    AllTypes: "All",
    Growth: "Cow-Calf",
    RecreateFattenPasture: "R&F - Pasture",
    RecreateFattenSemiConfinement: "R&F - Pasture/Feedlot",
    RecreateFattenConfinement: "R&F - Feedlot",
    Agriculture: "Crops",
    Others: "Others",
  },
  buttons: {
    assign: "Assign",
    back: "Back",
    next: "Next",
    save: "Save",
    cancel: "Cancel",
    confirm: "Confirm",
    login: "Log in",
    buttonNewProfitCenter: "New Activity",
    buttonNewFarm: "New farm",
    buttonNewSupplier: "New Supplier",
    yes: "Yes",
    no: "No",
    putToDeath: "Set as dead",
    allocateLot: "Allocate Batch",
    download: "Download",
    processWeights: "Process imported weighings",
    processAnimals: "Process imported animals",
    processSupplements: "Process supplem./concent.",
    processVaccinations: "Process vaccinations",
    edit: "Edit",
    editing: "Editing",
    addInfo: "Report data",
    delete: "Delete",
    useAsFavorite: "Set as Favorite",
    generate: "Create",
    putToDiscard: "Discard",
    process: "Process",
    accept: "Accept",
    reject: "Reject",
    updateTable: "Update table",
    viewAll: "View all",
    add: "Add",
    close: "Close",
    activate: "Activate",
    inactivate: "Inactivate",
  },
  topbar: {
    title: "Administration  ",
    group: {
      title: "Groups",
      subtitle: "Select a Group",
      submenus: {
        farm: "Farm(s)",
        add_farm: "Add Farm",
      },
    },
    question: {
      title: "Questions",
      submenus: {},
    },
    notification: {
      title: "Remarks",
      submenus: {},
      footer: "Display all",
    },
    add: {
      title: "Add",
      submenus: {
        profit_center: "Activity",
        picket: "Paddock/Pen",
        picketSupplementSupply: "New/Edit Feeding",
        user: "User",
        balance: "Weighing Device",
        sell_and_buy: "Acquisition/Sales Scenario",
        animal: "Animal",
        lotProduction: "Production Batch",
        buy: "Acquisition",
        birth: "DOB",
        importAnimalsWeights: "Import weighings",
        importAnimals: "Import animals",
        importSupplements: "Import Supplem./Concent.",
        importFinancialTransactions: "Import financial transactions",
        importSuppliersClients: "Import suppliers/clients",
        importAnimalCoverage: "Import coverages and DG's",
        importAnimalBirth: "Import births and losses",
        importVaccinations: "Import vaccinations",
        downloadBovManager: "Dowload BovManager",
      },
    },
    language: {
      title: "Translation",
      submenus: {
        pt_br: "Português - BR",
        en: "English - US",
        es: "Español - ES",
      },
    },
    user: {
      title: "User",
      submenus: {
        edit_profile: "Edit profile",
        change_user: "Change user",
        change_password: "Change password",
        add_new_user: "Add user",
        signout_application: "Log out",
      },
    },
    search: {
      title: "Search",
      submenus: {
        user: "User",
        profit_center: "Activity",
        picket: "Paddock/Pen",
        balance: "Weighing device",
        animal: "Animal",
        buy: "Acquisition",
        birth: "DOB",
      },
    },
  },
  table: {
    menu: {
      makeStandard: "Set as Standard",
      edit: "Edit",
      details: "Details",
      delete: "Delete",
      inactivate: "Inactivate",
      activate: "Activate",
      addAnimalsToLotProduction: "Add animals",
      dismemberLotProduction: "Batch splitting",
      allocateLotToPicket: "Allocate Batch to paddock/stall",
      putPicketInMaintenance: "Perform maintenance",
      putPicketInBreak: "Rest",
      putPicketInRenovation: "Renovate",
      setBaseline: "Set as Default",
      movePickets: "Transf Paddocks/Pens",
      classify: "Classify",
    },
  },
  error: {
    formError: "Please fill in the required fields (*) correctly.",
    noGroupSelected: "Select a Group from the top menu",
    sisbovInvalidTitle: "Invalid NAIS",
    sisbovInvalidMessage: "The NAIS number must contain at least 15 characters",
  },
  notifications: {
    types: {
      newObject: "New object",
      purchase: "Acquisition",
      sale: "Sale",
      alert: "Alert",
      warning: "Warning",
      other: "Other",
    },
    drawer: {
      title: "Your notifications and alerts",
      buttonVilualizeAll: "Set all as Read",
      buttonLoadOldNotifications: "Upload older ones",
      notificationsNotRead: "Remarks not read",
      tabNotificationTitle: "Notifications",
      tabAlertTitle: "Alerts",
    },
  },
  sessionExpired: {
    title: "Session expired!",
    message:
      "To keep your account secure, we periodically check your presence, please log in again",
    titleAlmostExpired: "Your session will expire soon!",
    messageAlmostExpired:
      "To keep your account secure, we periodically check your presence, don't forget to save what you are doing before your session expires.",
    buttonLogout: "Log out now",
    buttonConfirm: "Ok, I get it",
    toExpire: "to expire...",
  },
  sidebar: {
    home: "Home",
    farm: "Farms",
    profit_center: "Activities",
    picket: "Range Unit/Paddocks",
    lot: "Batches",
    animal: "Animals",
    decision: "Decisions",
    parameters: "Parameters",
    imports: "Importings",
    administration: "Administration",
    suppliers: "Suppliers",
    operations: "Operations",
    breed: "Breeds",
    handling: "Husbandry",
    diet: "Diets",
    pasture: "Grazing areas",
    supplement: "Supplem./Concent.",
    adminAndUser: "Farm's employees",
    userInvite: "Access invitation",
    client: "Customers",
    cattleProducer: "Producers",
    payment: "Payments",
    supplierManagement: "Suppliers management",
    financial: "Financial Entries",
    stock: "Supply Inventory",
    feedFactory: "Feed Factory",
    report: "Reports",
  },
  languages: {
    pt_br: "PT",
    en: "EN",
    es: "SP",
  },
  status: {
    active: "Active",
    inactive: "Inactive",
    dismembered: "Splitted",
    pendingData: "Missing data",
    informedData: "Reported Data",
    pending: "Pending",
    processing: "Processing",
    completed: "Completed",
    refused: "Refused",
    error: "Error",
    transfer: "Transferred",
    dead: "Dead",
    sold: "Sold",
    processed: "Processed",
    confirmed: "Confirmed",
    classified: "Classified",
  },
  productionSubSystem: {
    semiIntensive: "Semi- Pasture/Feedlot",
    intensive: "Int - Feedlot",
    extensive: "Ext - Pasture",
    SI: "Semi- Pasture/Feedlot",
    I: "Int - Feedlot",
    E: "Ext - Pasture",
    Extensive: "Ext - Pasture",
    SemiIntensive: "Semi- Pasture/Feedlo",
    Intensive: "Int - Feedlot",
  },
  productionSystem: {
    fatten: "Finishing",
    create: "Cow-Calf",
    recreate: "Bakground rearing",
  },
  kpi: {
    capacity: "Occupancy",
    production: "Production",
    cost: "Cost",
    margin: "Margin",
    gdp: "ADG",
    enjoy: "Turnover (%head)",
    carbonFootprint: "Carbon Footprint",
    disbursement: "Disbursement (/head/month)",
    weanCalf: "Tot Weight Weaned Calves / Tot Weight Cows",
    iep: "CIV",
    reproductiveEfficiency: "Reproductive efficiency",
    weanCalfCost: "Cost per Weaned Calf",
    discardedCows: "Disposed Cows",
    assetValue: "Cattle Asset Value",
    incrementalMargin: "Incremental Margin",
    tooltips: {
      tooltipCapacity:
        "The Occupancy is the ratio (in %) of the current number of heads allocated and the total capacity, as defined in the confinement pen registry.",
      tooltipEnjoy:
        "The Turnover rate measures the herd's ability to generate surplus (@ = 30kg BW) in a given space of time.",
      tooltipProduction: "Amount of @ (30 kg BW) produced per hectare/year.",
      tooltipGDP:
        "Weight Daily Average gain, since the animal enters the Farm.",
      tooltipMargin: "Expected profit margin per @ (=30kg BW) produced.",
      tooltipCost: "Production Cost of @ (=30kg BW).",
      tooltipCarbonFootprint:
        "Maximum emission target in Kg of CO₂E per Kg of weight gain.",
      tooltipDisbursement:
        "Disbursement per Head/Month of animals currently in each production subsystem.",
      tooltipAssetValue: "Cattle Asset Value.",
      tooltipIncrementalMargin: "Incremental Margin.",
      tooltipWeanCalf:
        "Indicator of the proportion of the weight of weaned animals in relation to breeding females.",
      tooltipIEP:
        "Calving interval for breeding females that have calved at least twice (Secondiparous)",
      tooltipReproductiveEfficiency:
        "Final Reproductive Efficiency of serviced cows, considering Pregnancy Rate (PR), Birth Rate (BR) and Weaning Rate (WR).",
      tooltipWeanCalfCost:
        "Cost of weaned calf, including all costs incurred by the cow and calf.",
      tooltipDiscardedCows: "% of cows discarded in the period.",
    },
  },
  zipCodeValid: "ZIP found",
  zipCodeInvalid: "ZIP not found",
  defaultSelectPlaceholder: "Select an option",
  defaultMultiSelectPlaceholder: "Select one or more options",
  defaultDatePickerPlaceholder: "Select a date",
  defaultPlaceholder: "Enter a value",
  filters: {
    applyFilter: "Apply Filter",
    cleanFilter: "Clean Filter",
    filterBy: "Filter by",
    filterByOptions: {
      age: "Age",
      gender: "Gender",
      breed: "Breed",
      supplier: "Suppliers",
      farmOwner: "Owners",
    },
    compareBy: "Compare by",
    value: "Value(s)",
    male: "Male",
    female: "Female",
    min: "Min",
    max: "Max",
    equal: "Equal to",
    greaterThan: "Greater than",
    lessThan: "Less than",
    between: "Between",
  },
  groupAndFarmModal: {
    hello: "Hi!",
    groupSelectedLabel: "Select a Group",
    groupSelectedPlaceHolder: "Select a Group ",
    farmSelectedLabel: "Select a Farm",
    farmSelectedPlaceHolder: "Select a Farm",
    buttonAccessFarm: "Access Farm ",
  },
  importAnimalWeights: {
    title: "Import weighing and measurement history ",
    message:
      '<p class="message">Download <strong>the template below, fill the spreadsheet columns</strong> with weight values, <strong>and import the file</strong> in the sequence, clicking to process weighings</p>',
    draggerMessage: "Click or drag the file to this area to upload it. ",
    importType: {
      label: "Select the import type:",
      weights: "Import Weights",
      weightsAndMeasurements: "Import Weights and Measurements",
    },
  },
  importAnimals: {
    title: "Import animals into the production batch ",
    message:
      '<p class="message">Select a production batch, download <strong>the template below, fill the spreadsheet columns</strong> with the data from the animals to import, <strong>execute importing</strong> and click to process animals</p>',
    messageForDifferentsLots:
      '<p class="message">Download <strong>the template below, fill the spreadsheet columns</strong> with both animal and batch related data, <strong>execute import</strong> and click to process animals</p>',
    messageForIdentifyAnimals:
      '<p class="message">Download<strong>the template below, fill the spreadsheet columns</strong> with data related to both animals, production batches and receiving batches, <strong>execute importing</strong> and click to process animals</p>',
    draggerMessage: "Click or drag the file to this area to upload it. ",
    helpMessage:
      'Import animals by batch and supplier: Enter the batch and supplier for each animal in the spreadsheet. This way, it is possible to import animals from different suppliers and for more than one production batch. The supplier and production batch must be registered in advance, and the "Batch Id"field must be used in the spreadsheet for the production batch, while for the supplier, enter the "IRS/EIN"from registration. \nImport animals for a single batch and supplier: Select a production batch and a supplier already registered. If the animal to be imported is from the farm itself, select the "Animal(s) supplied by the farm itself"option.',
  },
  invoiceUploadViewer: {
    buttons: {
      loadXml: "Upload Xml",
      loadPdf: "Upload Pdf",
      viewDocument: "View Document",
    },
    errors: {
      parseXml: "Could not read the XML file. Check if it is a valid NF-e.",
      parsePdf: "Could not read the PDF file. Check if it is a valid DANFE.",
    },
    drawer: {
      title: "Invoice Document",
      emitter: {
        title: "Issuer",
        razaoSocial: "Company Name",
        nomeFantasia: "Trade Name",
        cnpj: "CNPJ",
        ie: "State Registration",
        municipioUf: "City/State",
      },
      identification: {
        title: "NF-e Identification",
        accessKey: "Access Key",
        protocol: "Protocol",
        status: "SEFAZ Status",
        number: "Number",
        series: "Series",
        issueDate: "Issue Date",
        exitEntryDate: "Exit/Entry Date",
        operationNature: "Operation Nature",
      },
      recipient: {
        title: "Recipient",
        razaoSocial: "Company Name",
        cnpj: "CNPJ/CPF",
        municipioUf: "City/State",
      },
      taxes: {
        title: "Tax Calculation",
        products: "Products Value",
        freight: "Freight Value",
        insurance: "Insurance Value",
        discount: "Discount",
        ipi: "IPI Value",
        icms: "ICMS Value",
        pis: "PIS Value",
        cofins: "COFINS Value",
        others: "Other Expenses",
        total: "Invoice Total",
      },
      items: {
        title: "Items",
        code: "Code",
        description: "Description",
        ncm: "NCM",
        cfop: "CFOP",
        unit: "Unit",
        quantity: "Qty",
        unitValue: "Unit Value",
        totalValue: "Total Value",
        empty: "No items",
      },
    },
  },
  error404: {
    title: "ERROR 404",
    subTitle: "Page not found",
    button: "Go to Home",
  },
  months: {
    january: "January",
    jan: "Jan",
    february: "February",
    feb: "Feb",
    march: "March",
    mar: "Mar",
    april: "April",
    apr: "Apr",
    may: "May",
    mmay: "May",
    june: "June",
    jun: "Jun",
    july: "July",
    jul: "Jul",
    august: "August",
    aug: "Aug",
    september: "September",
    sep: "Sep",
    october: "October",
    oct: "Oct",
    november: "November",
    nov: "Nov",
    december: "December",
    dec: "Dec",
  },
  notInformed: "Not informed",
  Profile: {
    drawerTitle: "Personal Data ",
    form: {
      fullName: "Full name",
    },
  },
  scenarePage: {
    title: "Boitel Scenarios",
    table: {
      column: {
        clientID: "Client ID",
        name: "Scenario name",
        createdAt: "Date Created ",
        updatedAt: "Last Update Date",
        status: "Status",
        labelStatus: {
          hired: "Contracted",
          saved: "Saved",
        },
      },
      detailsRow: {
        rangeWeight: "Weight range",
        amountAnimals: "No of Animals ",
        entryDate: "Entry Date ",
        exitDay: "Departure Date ",
        daysOfStay: "No of Daily Rates ",
        dailyPrice: "Daily Price",
        dietStrategy: "Diet",
        carcassHarnessing: "Carcass Yield - %",
        totalIncome: "Total Revenue",
        incomeForCab: "Revenue/head",
        marginForCab: "Margin/head",
      },
    },
  },
  boitelContractsPage: {
    title: "Contracts",
    buttonNewContract: "New Contract",
    buttonExportContractsReport: "Export Contracts Report",
    buttonExportContractsSaleResultReport: "Export Sale Result Report",
    table: {
      menu: {
        selectAnimals: "Select Animals",
      },
      column: {
        identificationContract: "Contract Number",
        customerName: "Producer",
        dateContract: "Contract Date",
        finalDateContract: "Contract Term",
        status: "Status",
        statusOptions: {
          vigente: "Active",
          encerrado: "Closed",
          pendente: "Pending",
          erro: "Error",
        },
        amountAnimals: "Qty. Animals",
        selectedAnimals: "Selected Animals",
        animalGender: "Animal Gender",
        animalGenderOptions: {
          vaca: "Cow",
          V: "Cow",
          novilha: "Heifer",
          N: "Heifer",
          machoInteiro: "Entire Male",
          I: "Entire Male",
          machoCastrado: "Castrated Male",
          C: "Castrated Male",
        },
        entryWeight: "Entry Weight",
        contractDays: "Contract Days",
        consecutiveDays: "Consecutive Days",
        fileUrl: "File",
        contractType: "Contract Type",
        contractTypeOptions: {
          daily: "Daily",
          dryMatterConsume: "DM Cons.",
          arrobaProduction: "@ Prod.",
          partnership: "Partnership",
        },
      },
    },
    detailsDrawer: {
      title: "Boitel Contract Details",
      tabs: {
        general: "General Information",
        animals: "Selected Animals",
      },
      errorLoadingAnimals: "Error loading animals.",
      emptyAnimals: "No animals selected for this contract.",
    },
    deleteModal: {
      title: "Confirm deletion",
      content: "Are you sure you want to delete this contract?",
      success: "Contract deleted successfully",
      error: "Error deleting contract",
    },
    selectAnimals: {
      title: "Select Contract Animals",
      relateButton: "Relate",
      footerTotalSelected: "Animals selected for contract:",
      herdsColumn: "Herd",
      summaryTitle: "Summary by herd",
      animalsLabel: "animals",
      cardEdit: "Edit",
      cardDelete: "Delete",
      deleteConfirmTitle: "Delete relationship",
      deleteConfirmText:
        "Do you want to remove this herd's relationship with the contract?",
      relateDrawerEditTitle: "Edit herd relationship",
      noAnimalsToSave: "No related animals to save.",
      saveSuccess: "Contract animals saved successfully.",
      saveError: "Error saving contract animals.",
      errorLoadingAnimals: "Error loading animals.",
      relateDrawer: {
        title: "Relate animals to herd",
        selectHerd: "Contract herd",
        selectHerdPlaceholder: "Select herd",
        selectHerdRequired: "Select a herd.",
        entryDateType: "Entry date",
        entryDateSingle: "Single date for all",
        entryDatePerAnimal: "Specific date per animal",
        entryDate: "Entry Date",
        entryDateRequired: "Enter entry date.",
        entryDateAllRequired: "Enter entry date for all animals.",
        selectedAnimalsList: "Selected animals",
        validationExceedsAmount: "Selected animal count exceeds herd capacity.",
        validationNoSlots: "Not enough slots in herd for selected animals.",
        validationBreedMismatch:
          "There are animals of breeds different from those specified in the selected set.",
      },
    },
    form: {
      titleCreate: "New Contract",
      titleEdit: "Edit Contract",
      successCreate: "Contract created successfully",
      successUpdate: "Contract updated successfully",
      errorSave: "Error saving contract",
      carcassPercentageRangeError:
        "Carcass Approval % must be between 40 and 70.",
      errorLoading: "Error loading contract",
      sections: {
        contractData: "Contract Data",
        client: "Client",
        herd: "Herd",
        contractType: "Contract Type",
      },
      identificationContract: "Contract Identification",
      identificationContractPlaceholder: "Enter contract identification",
      contractDate: "Date",
      contractDateTooltip: "Contract effective start date.",
      initialDateContract: "Initial Date",
      initialDateContractTooltip: "Expected start date for Animal Lot entries.",
      fileUrl: "File",
      uploadFile: "Select file",
      cattleProducer: "Producer",
      multipleFarm: "Farm",
      cattleProducerFarm: "Producer Farm",
      cattleProducerFarmPlaceholder: "Select farm",
      cattleProducerFarmRequired: "A producer farm must be selected",
      cattleProducerRequired: "A producer must be selected",
      addHerd: "Add Herd",
      herdsRequired: "At least one herd must be added",
      contractType: "Type",
      contractTypePlaceholder: "Select contract type",
      herds: {
        cjt: "SET",
        amountAnimals: "Qty",
        amountAnimalsPlaceholder: "Quantity",
        breed: "Breed",
        breedPlaceholder: "Select breed",
        gender: "Sex/Category",
        genderPlaceholder: "Select gender",
        genderOptions: {
          vaca: "Cow",
          novilha: "Heifer",
          machoInteiro: "Intact Male",
          machoCastrado: "Castrated Male",
        },
        weightAverage: "Average Weight",
        weightAveragePlaceholder: "Average weight",
        useSisbov: "Sisbov",
        trace: "Individual Id.?",
        entryDate: "Entry Date",
        farm: "Farm",
        farmPlaceholder: "Select farm",
        supplement: "Diet",
        supplementPlaceholder: "Select diet",
      },
      herdForm: {
        title: "Add/Edit Herd",
      },
      dailyContract: {
        cjt: "SET",
        amountAnimals: "Qty. Animals",
        numberOfDays: "N° Days",
        numberOfDaysPlaceholder: "Number of days",
        protocolValue: "Sanitary Protocol",
        protocolValuePlaceholder: "Protocol value",
        fixedValue: "Fixed Value",
        fixedValuePlaceholder: "Fixed value",
        dietValue: "Diet Value",
        dietValuePlaceholder: "Diet value",
        otherValue: "Others",
        otherValuePlaceholder: "Other values",
        dailyValue: "Daily Value",
        dailyValuePlaceholder: "Daily value",
        observation: "Observation",
        observationPlaceholder: "Enter an observation",
        prevCost: "Previous Cost",
      },
      dryMatterConsumeContract: {
        measurement: "Measurement",
        preFixed: "Pre-Fixed",
        provision: "Provision",
        report: "Report",
        cjto: "Set",
        unique: "Unique",
        cjt: "SET",
        averageOffer: "Average Offer",
        averageOfferPlaceholder: "Average offer",
        numberOfDays: "N° Days",
        numberOfDaysPlaceholder: "Number of days",
        value: "Value",
        costPerKilogramDryMatterPlaceholder: "Value per KgMS",
        valuePlaceholder: "Value",
      },
      arrobaProductionContract: {
        report: "% Carcass Approval Report",
        byLot: "By Lot",
        unique: "Unique",
        cjt: "SET",
        carcassHarnessingPercentage: "% Carcass Approval Entry",
        carcassHarnessingPercentagePlaceholder: "% Carcass Approval Entry",
        valuePerArroba: "Value @",
        valuePerArrobaPlaceholder: "Value @",
      },
      partnershipContract: {
        partnershipType: "Partnership Type",
        partnerPercentage: "Partner Percentage",
        numberOfDays: "N° Days",
        numberOfDaysPlaceholder: "Number of days",
        partnershipTypeOptions: {
          CARCASS_HARNESSING: "% Carcass",
          ARROBA_PRODUCTION: "@ Production",
        },
        report: "Report",
        byLot: "By Lot",
        unique: "Unique",
        cjt: "SET",
        carcassEntryPercentage: "% Carcass Approval Entry",
        carcassEntryPercentagePlaceholder: "% Carcass Approval Entry",
        agreedWeightLabel: "Select Agreed Weight",
        agreedWeightPvFaz: "Pv Farm",
        agreedWeightPvConf: "Pv Conf.",
        maxBreak: "Maximum Allowed Breakage",
        maxBreakPlaceholder: "Maximum break",
      },
    },
    tabs: {
      contracts: "Contracts",
      slaughterSchedule: "Schedule",
    },
  },
  slaughterSchedule: {
    title: "Slaughter Schedule",
    errorLoading: "Error loading slaughter schedule data",
    drawer: {
      title: "Lot Details",
    },
    table: {
      column: {
        status: "Status",
        statusOptions: {
          active: "Active",
          inactive: "Inactive",
          sold: "Sold",
        },
        picketName: "Paddock/Pen",
        lotName: "Lot",
        type: "Type",
        contractTypeOptions: {
          daily: "Daily",
          dryMatterConsume: "Dry Matter Consumption",
          arrobaProduction: "Arroba Production",
          partnership: "Partnership",
          own: "Own",
        },
        ownType: "Own",
        producerPartner: "Producer/Partner",
        animalsAmount: "Animals Qty",
        gender: "Gender",
        genderOptions: {
          male: "Male",
          female: "Female",
          both: "Both",
        },
        breed: "Breed",
        entryDate: "Entry Date",
        entryWeight: "Entry Weight",
        contractForecast: {
          blockTitle: "Contract Forecast",
          forecastAdg: "Forecast ADG",
          currentForecastWeight: "Current Forecast Weight",
          stayTime: "Stay Time",
          slaughterWeight: "Slaughter Weight",
          slaughterDays: "Days to Slaughter",
          slaughterDate: "Slaughter Date",
        },
        saleScenarioBlock: {
          blockTitle: "BovExo Sale Scenario",
          projectedWeightEd: "Proj. Weight ED",
          saleScenario: "Sale Scenario",
          cvProcessingDate: "Sale Scenario Processing Date",
          suggestedSaleDate: "Suggested Sale Date",
          estimatedSaleWeight: "Estimated Sale Weight",
        },
      },
    },
  },
  boitelSaleScenario: {
    title: "Sale Scenarios",
    result: "Result(s)",
    btn: {
      newScenare: "New Scenario",
    },
    table: {
      column: {
        scenare: "Scenario",
        client: "Customer",
        favorite: "Favorite",
        status: "Status",
        actions: "Actions",
        labelStatus: {
          analyzing: "Evaluating",
          processed: "Processed",
          canceled: "Canceled",
          partialCanceled: "Part. Canceled",
          sold: "Sold",
          partialSold: "Part. Sold",
        },
      },
      detailsRow: {
        identification: "Identification",
        saleAnimals: "Animals for sale ",
        receive: "To receive",
        margin: "Margin",
        processedAt: "Processed at ",
      },
    },
    new: {
      title: "Creating: Boitel Sale",
      tabs: {
        lots: {
          title: "Batches selection",
        },
        dietStrategy: {
          title: "Diet strategy selection",
        },
        parameters: {
          title: "Parameters definition",
          form: {
            name: "Scenario name*",
            animalsInTruck: "Animals per truck*",
            minimumAge: "Min age for sale*",
            maximumAge: "Max age for sale*",
            minimumWeight: "Min weight for sale*",
            maximumWeight: "Max weight for sale*",
            useDefaultMaximumWeight: "Max weight for sale*",
            allowSeparateSell: "Can Batches be splitted?",
            goalType: "Scenario goal*",
            commitments: "Is there any commitment for the scenario?",
            newCommitment: "Add a new commitment",
            marketAnalysisId: "Market analysis*",
            useCustomCarcassHarnessing: "Enter new % Carcass Yield?",
            useCustomCarcassHarnessingHelp:
              "By default, the system uses the Carcass Yield % informed in the animal acquisition process and batch formation.",
            carcassHarnessing: "Carcass Yield",
          },
        },
      },
    },
    edit: {
      title: "Editing: Boitel Sale",
    },
    details: {
      messageSelectDates:
        "Select a suggested date(s) from the calendar to view animal information.",
      calendarSuggested: "Suggested calendar",
      weekDateNull: "Animals with violation Boitel ",
      animalsToSell: "Animals for sale ",
      planningIncome: "Estimated Revenue",
      dietStrategiesSuggested: "Suggested diet strategy",
      commitments: "Commitments",
      violations: "Violations",
      parameters: "Scenario Parameters",
      marketValues: "Reference values ",
      violationAge: "Age",
      violationWeight: "Weight",
      violationBoitel: "Boitel",
      violationMinAge: "Min age",
      violationMaxAge: "Max age",
      violationMinWeight: "Min weight",
      violationMaxWeight: "Max weight",
      table: {
        columns: {
          animalHandlingNumber: "Identification",
          sellDate: "Suggested date",
          weight: "Estim. weight",
          lastDailyWeight: "Last Weight",
          averageWeightGain: "ADG",
          aggregateArroba: "Net added @",
          saleIncome: "Revenue",
          aggregateIncome: "Added Revenue",
          cost: "Cost",
          aggregateMargin: "Added Margin",
          margin: "Margin",
        },
      },
    },
  },
  importSupplements: {
    title: "Import supplements ",
    message:
      '<p class="message">Download <strong>the template below, fill the spreadsheet columns</strong> with supplements data, <strong> import it</strongand click to process supplements</p>',
    draggerMessage: "Click or drag the file to this area to upload it. ",
  },
  importSuppliersClients: {
    title: "Import suppliers/clients",
    message:
      '<p class="message">Download <strong>the template below, fill the spreadsheet columns</strong> with suppliers/clients data, <strong> import it</strong> and click to process</p>',
    draggerMessage: "Click or drag the file to this area to upload it.",
    groupFarmVisibility: "Where will suppliers/clients be imported?",
    success: {
      title: "Suppliers/Clients imported",
      description: "The import was processed successfully.",
    },
    error: {
      title: "Import error",
      description: "No supplier/client was included.",
    },
  },
  eventLog: {
    fromValueLabel: "Modified from",
    toValueLabel: "to",
    dateLabel: "Date",
    attributeLabel: "Property",
    userLabel: "User",
    nullLabel: "empty",
    Supplement: {
      createdAt: "Creating register: ",
      name: "Name",
      type: "Type",
      classification: "Classification",
      industrialName: "Brand name",
      status: "Condition",
      cost: "Cost",
      cp: "CP",
      tdn: "TDN",
      npn: "NNP",
      dryMatterPercentage: "DM",
      nitrogen: "Nitrogen",
      calcium: "Calcium",
      phosphorus: "Phosphorus",
      zinc: "Zinc",
      sodium: "Sodium",
      minimumVoluntaryConsumption: "Voluntary feed(Min)",
      maximumVoluntaryConsumption: "Voluntary feed(Max)",
      voluntaryConsumptionType: "Unit",
      minimumPure: "Pure product offered (Min)",
      maximumPure: "Pure product offered (Max)",
      minimumPureTrough: "Recom. Trough size (Min)",
      maximumPureTrough: "Recom. Trough size (Max)",
      pureConsumptionType: "Unit",
      minimumMix: "Mixed Product Offered (Min)",
      maximumMix: "Mixed Product Offered (Max)",
      minimumMixTrough: "Recom. Trough size (Min)",
      maximumMixTrough: "Recom. Trough size (Max)",
      mixConsumptionType: "Unit",
      currentVersion: "Version",
      proportion: "Proportion",
      additiveEffect: "Additive Effect",
      additiveEffectUnit: "Unidade Efeito Aditivo",
      fda: "ADF",
      lignin: "Lignin",
      ee: "Ethereal Extract",
    },
  },
  reproductionParameters: {
    title: "Reproduction Parameters ",
    parameters: {
      IDADE_INICIO_FASE_REPRODUTIVA: "Min age for breeding*",
      PERIODO_DESCANSO_POS_PARTO: "Postpartum rest period *",
      TEMPO_APOS_COBERTURA_PARA_DG:
        "Post-service Time for Pregnancy Diagnosis *",
      TOURO_COBERTURAS_DESCONHECIDAS: "Servicing Bull unknown*",
      IDADE_DESMAMA: "Weaning age*",
      CONSISTIR_TEMPO_GESTACAO_NO_PARTO:
        "When launching IA births, with gestation time above the parameterized, launch automatically an MC/Repass, of UNKNOWN BULL, using the average gestation time?*",
    },
    reproductionPeriod: {
      title: "Breeding Seasons",
      titleHelper:
        "The Breeding Season is the property's reproductive period, starting on D0 of the first Insemination protocol/Service for the batch and ending with the Final Gestation Diagnosis.",
    },
    score: {
      title: "Reproductive Success Probability Score ",
      titleHelper:
        "Define, based on the score scale of 1 to 9, the probability in % of reproductive success. This score will be applied in the table to generate the Age X Weight X Body Score Curve.",
    },
    breedScore: {
      title: "Age X Weight X Body Score Curve ",
      titleHelper:
        "Define for the Breeding Females, considering Age, Current Weight and Reproduction Success Probability Score, the variables necessary to calculate the cost to, until the next Breeding Season, reach each body score.",
      form: {
        title: "New entry (Breed X Age X Weight X Score)",
        breedId: "Breed*",
        age: "Age*",
        startWeight: "Starting weight*",
        endWeight: "Ending weight*",
        weight: "Weight",
        score: "Score*",
        errors: {
          errorWithFieldWeights:
            ' There are some weights without "Score". Fill them in to save the form.',
        },
      },
    },
  },
  semen: {
    title: "Semen Listing ",
    buttonNewSemen: "New Semen",
    table: {
      columns: {
        name: "Name",
        registration: "Register",
        breedName: "Breed",
      },
    },
    form: {
      titleCreateNewSemen: "New Semen",
      titleEditSemen: "Edit Semen",
      name: "Name",
      registration: "Register",
      breedId: "Breed",
      genealogy: "Genealogy",
      father: "Father",
      mother: "Mother",
      identification: "Identification",
    },
  },
  movimentAnimals: {
    title: "Transfers between Batches",
    description:
      ' Select animals in the table and click the "Transfer"button to relocate the animals ',
    buttonMovementAnimals: "Transfer",
    form: {
      title: "New Transfer - Destination Batch ",
    },
  },
  closedSalesReport: {
    form: {
      title: "Sales Results",
      salesPeriod: "Sales Period",
      clientId: "Customer",
      supplierId: "Supplier",
      saleScenarioId: "Sales Scenario(s)",
      animalGender: "Gender",
      showOriginData: "Show origin of animals sold?",
      dailyOperationalCostMode: "Operational Daily Cost",
      dailyOperationalCostModeOptions: {
        BOVEXO_COSTING: "BovExo-Calculated",
        USER_DEFINED: "User-Defined ($/Day)",
      },
      additionalSlaughterCostValue: "Additional Slaughter Costs",
    },
  },
  exportFinancialTransactions: {
    modal: {
      title: "Export financial transactions ",
      billingPeriod: "Invoicing ",
      expirationPeriod: "Maturity ",
      suppliers: "Supplier(s)",
      costActivities: "Activity(ies)",
      clients: "Customer(s)",
      transactionType: "Type",
      financialProjectId: "Investment Project",
      status: "Status",
    },
  },
  unit: {
    title: "Unit Listing ",
    buttonNew: "New Unit",
    table: {
      columns: {
        name: "Abbreviation",
        description: "Description",
        basicUnit: "Basic Unit",
        multiplier: "Multiplier",
        status: "Status",
        createdAt: "Date Created",
        createdBy: "Responsible for Creation",
      },
    },
    form: {
      titleCreateNew: "New Unit",
      titleEdit: "Edit Unit",
      groupFarmVisibility: "Who will use the Unit?",
      name: "Abbreviation",
      description: "Description",
      basicUnit: "Basic Unit",
      multiplier: "Multiplier",
      status: "Status",
    },
  },
  measurement: {
    title: "Measurements List",
    buttonNew: "New Measurement",
    table: {
      columns: {
        name: "Name",
        code: "Code",
        status: "Status",
        createdAt: "Date Created",
        createdBy: "Responsible for Creation",
      },
    },
    form: {
      titleCreateNew: "New Measurement",
      titleEdit: "Edit Measurement",
      name: "Name",
      code: "Code",
      status: "Status",
      nameRequired: "Name is required",
      codeRequired: "Code is required",
    },
  },
  veterinary: {
    title: "List of Veterinary Supplies ",
    buttonNew: "New veterinary input",
    table: {
      columns: {
        name: "Brand name",
        type: "Type",
        supplierId: "Supplier",
        supplierName: "Supplier",
        status: "Status",
        createdAt: "Date Created",
        createdBy: "Responsible for Creation",
      },
    },
    form: {
      titleCreateNew: "New veterinary input",
      titleEdit: "Edit veterinary input",
      groupFarmVisibility: "Who will use the veterinary input?",
      name: "Brand name",
      type: "Type",
      supplierId: "Supplier",
      applicationGender: "Gender",
      applicationAge: "Age",
      applicationType: "Administration route",
      applicationValue: "Administration amt.",
      applicationWeightValueParam: "Weight",
      unitId: "Unit used",
      applicationCost: "Administration cost",
      status: "Status",
    },
  },
  handlingReproduction: {
    title: "Husbandry",
    tabs: {
      reproductiveProtocol: "Protocols",
      coverage: "Reproduction service",
      pregnancyDiagnosis: "Pregnancy Diagnosis ",
      animalBirth: "Births and Losses ",
    },
    dashboards: {
      dashboardReproductionPeriod: {
        reproductionPeriodSelected: "Breeding Season",
        lotIdsSelected: "Lots",
        totalFemalesSuitable: "Eligible Females",
        totalCoverageFemales: "Worked Females",
        totalInserminatedFemales: "Inseminated Females",
        totalInserminations: "Number of Inseminations",
        totalCoverageIatfPlusRepasseFemales: "Females under Natural Service",
        totalPregnancyFemales: "Pregnant Females",
        pregnancyRate: "Pregnancy Rate",
        totalFemalesWithNoResult: "No Result",
        totalFemalesWithGestationalLosses: "Gestational Losses",
      },
    },
  },
  handlingReproductionCoverage: {
    title: "Reprod Service Listing",
    buttonHandlingReproductionCoverage: "New servicing",
    type: {
      iatf: "AI/FTAI",
      repasse: "FS/Repeat",
    },
    table: {
      columns: {
        animalHandlingNumber: "Female",
        coverageDate: "Date",
        type: "Type",
        maleHandlingNumber: "Bull",
        semenNameAndRegistration: "Semen",
        semenOrMaleIdentification: "Bull/Semen",
        lotName: "BATCH",
        dose: "Dosage",
        reproductionPeriodDescription: "Breeding Season",
        inseminatorName: "AI Technician",
        pregnancyDiagnosisResult: "Result",
        semenDeparture: "Departure",
        observation: "Observation",
        bodyConditionScore: "ECC",
        last_weight: "Last Weight",
        last_weight_date: "Last Weighing Date",
        animal_farm_function: "Purpose",
      },
    },
    form: {
      type: "Type",
      animalId: "Identification",
      category: "Category",
      semenId: "Semen",
      maleId: "Bull",
      dose: "Dosage",
      inseminatorId: "AI Technician",
      coverageDate: "Service Date",
      reproductionPeriodId: "Breeding Season",
      semenDeparture: "Departure",
      observation: "Observation",
      bodyConditionScore: "ECC",
    },
    errorsAndMessages: {
      successMessage: "Service saved/updated successfully!",
      femaleWithoutReproductionAge:
        "Female is not old enough to start the reproductive phase, do you want to continue?",
      femaleDontHaveAgeToCoverage:
        "Attention! Female is not old enough for this service.",
      reproductionPeriodWithoutCurrentDate:
        "Attention! It is necessary to have a Breeding Season registered during the service period.",
      errorFemaleWithFutureCoverages:
        "Attention! Female already has service posted on later dates.",
      errorFemaleWithCoverageInSameDateAndType:
        "Attention! Service already registered previously.",
      errorInternalError:
        "Error registering/updating service. Contact support.",
    },
  },
  inseminator: {
    title: "AI Technicians Listing",
    buttonNewInseminator: "New AI Technician",
    table: {
      columns: {
        name: "Name",
        code: "Code ID",
        status: "Status",
      },
    },
    form: {
      titleCreateNewInseminator: "Novo AI Technician",
      titleEditInseminator: "Editar AI Technician",
      name: "Name",
      code: "Code ID",
    },
  },
  multipleBull: {
    title: "Multiple Bulls",
    buttonNewMultipleBull: "New Multiple Bull",
    table: {
      columns: {
        name: "Name",
        code: "Code ID",
        males: "Bulls",
        formationDate: "Grouping Date",
        status: "Status",
      },
    },
    form: {
      titleCreateNewMultipleBull: "New Multiple Bull",
      titleEditMultipleBull: "Edit Multiple Bull",
      name: "Name",
      code: "Code ID",
      males: "Bulls",
      formationDate: "Grouping Date",
      status: "Status",
    },
  },
  ovarianResult: {
    SemAvaliacao: "No Evaluation",
    CorpoLuteo: "corpus luteum ",
    Foliculo: "Follicular",
    Cisto: "Ovarian cysts ",
    Anestro: "Anestrus ",
    Normal: "Normal",
    Reabsorvendo: "Resorption",
    Gemelar: "Twin condition",
  },
  animalPregnancyDiagnosis: {
    title: "Pregnancy Diagnosis",
    buttonNew: "New Pregnancy Diagnosis",
    table: {
      columns: {
        animalHandlingNumber: "Female",
        lotOriginalName: "BATCH",
        diagnosisDate: "PD Date",
        result: "Result",
        ovarianEvaluationResult: "Ovarian Evaluation",
      },
      export: {
        columns: {
          handling_number: "Identification",
          tag_id: "Electronic Identification",
          sisbov: "SISBOV",
          name: "Name",
          status: "Status",
          last_lot: "Last Batch",
          move_date: "Movement Date",
          current_lot: "Current Batch",
          last_pregnancy_diagnosis_date: "Second-to-Last PD Date",
          last_pregnancy_diagnosis_result: "Second-to-Last PD Result",
          last_pregnancy_diagnosis_ovarian_evaluation_result:
            "Second-to-Last PD Ovarian Evaluation Result",
          current_pregnancy_diagnosis_date: "Last PD Date",
          current_pregnancy_diagnosis_result: "Last PD Result",
          current_pregnancy_diagnosis_ovarian_evaluation_result:
            "Last PD Ovarian Evaluation Result",
          current_birth_date: "Last Birth Date",
          current_birth_type: "Birth Type",
        },
      },
    },
    form: {
      titleCreateNew: "New Pregnancy Diagnosis",
      titleEdit: "Edit Pregnancy Diagnosis",
      diagnosisDate: "Diagnostic Date",
      animalId: "Identification",
      animalReproductionCategory: "Category",
      femaleSituation: "Condition",
      lastCoverage: "Last service",
      lotName: "Current Batch",
      result: "Result",
      ovarianEvaluationResult: "Ovarian Evaluation",
      lastCoverageReproductionPeriodId: "Breeding Season",
      lotDestination: "Destination Batch",
      timeGestationMC: "Gestation period MC",
      gestationDays: "Gestation period",
      birthForecast: "Birth Forecast",
      shouldDiscardFemale: "Discard Female?",
      discardMotive: "Cause",
      defineCoverage: "Define Service",
      selectCoverageTitle: "Select the service responsible for the pregnancy:",
      coverageModalDate: "Date",
      coverageModalReproductor: "Bull",
      coverageModalGestationDays: "Gestation (days)",
      coverageModalInputPlaceholder: "Type",
      newEntry: "New entry",
      editEntry: "Edit entry",
    },
    messages: {
      deleteSuccess: "Pregnancy diagnosis deleted successfully!",
      deleteErrorWithBirth:
        "It is not possible to delete the Pregnancy Diagnosis because there is a Birth record.",
      deleteError: "Could not delete Pregnancy Diagnosis. Contact support.",
      saveSuccess: "Pregnancy Diagnosis saved successfully!",
      validResultRequired: "Enter a valid result: Positive or Negative",
      ovarianResultRequired: "Enter a result for the Ovarian Evaluation",
      selectCoverage: 'Select a service using the "Define Service" button.',
      inconsistentGestationDays:
        "Attention! Gestation period entered is inconsistent, as it covers a period in which the female already has service(s) with result(s).",
      duplicateDiagnosisDate:
        "Attention! A pregnancy diagnosis already exists on the same selected date.",
    },
  },
  animalWeightHistory: {
    title: "Weighing List ",
    buttonExport: "Weighing Analysis",
    buttonNew: "New Weighing ",
    table: {
      columns: {
        origination: "Origin",
        handlingNumber: "Animal",
        date: "Date",
        weight: "Weight",
        originationLotName: "BATCH",
        originationPicketName: "Paddock",
        event: "Type",
      },
    },
    originEvents: {
      birthday: "DOB",
      sale: "Sale",
      weaning: "Weaning",
      purchase: "Acquisition",
    },
    form: {
      titleCreateNew: "Add Weighing",
      titleEdit: "Edit Weighing ",
      animalId: "Animal Id",
      date: "Weighing Date",
      weight: "Weight",
      gmd: "ADG",
      lotOriginalId: "Current Batch",
      lotDestinationId: "Destination Batch",
      lastDateWeight: "Last Weighing Date",
      lastWeight: "Last Weighing",
      weaningWeight: "Weaned?",
      editIdentifications: "Edit Identifications?",
    },
    modalExportReport: {
      title: "Weighing Analysis",
      periodDate: "Weighing Period",
      gender: "Gender",
      status: "Animals status",
      periodAge: "Idade(meses)",
      lotId: "BATCH",
      supplierId: "Supplier",
      listAnimalsWithoutWeight: "List animals without weighing in the period?",
      showProjectedWeight:
        "Display the weight projected by the Diet Strategy on the current date?",
    },
    messages: {
      successMessage: "Weight saved/updated successfully!",
      errorMessage: "Error saving/updating weight. Contact support.",
      error5029Message:
        "Attention! Animal already has a movement between batches at a later date.",
      weaningWeightError:
        "Attention! It is not possible to mark the weighing as weaning. The animal may be greater than 12 months old or already at weaning weight.",
      deleteSuccess: "Weighing deleted successfully!",
      deleteError: "Weighing was not deleted. Contact support.",
      alreadyInLot: "Attention! Animal is already in this Batch.",
    },
  },
  animalMeasurement: {
    title: "Measurement List",
    buttonNew: "New Measurement",
    tabs: {
      weights: "Weighings",
      measurements: "Measurements",
    },
    table: {
      columns: {
        origination: "Origin",
        handlingNumber: "Animal",
        breedName: "Breed",
        gender: "Gender",
        measurementDate: "Date",
        originationLotName: "Batch",
        originationPicketName: "Paddock/Pen",
        measurementName: "Measurement",
        value: "Value",
      },
    },
    origination: {
      bovManager: "BovManager",
      import: "Import",
      manual: "Manual",
    },
    gender: {
      M: "Male",
      F: "Female",
    },
    export: {
      columns: {
        status: "Status",
        handlingNumber: "Identification",
        tagId: "Electronic ID",
        gender: "Gender",
        breedName: "Breed",
        lastWeightDate: "Last Weighing Date",
        lastWeight: "Last Weighing",
        measurementDate: "Evaluation Date",
        measurementName: "Measurement",
        value: "Value",
        tempPerm: "Days on Farm",
        exitDate: "Exit Date",
        exitWeight: "Exit Weight",
      },
      filters: {
        status: "Status",
        gender: "Gender",
        breed: "Breed",
        measurementDate: "Evaluation Date",
        measurement: "Measurement",
        value: "Measurement Value",
        lot: "Batch",
        picket: "Paddock/Pen",
      },
      statusOptions: {
        active: "Active",
        sold: "Sold",
        dead: "Dead",
      },
      genderOptions: {
        male: "Males",
        female: "Females",
      },
    },
    form: {
      titleCreateNew: "New Measurement",
      titleEdit: "Edit Measurement",
      date: "Date",
      measurement: "Measurement",
      value: "Value",
      currentLot: "Current Batch",
      gender: "Gender",
      breed: "Breed",
      lotDestination: "Destination Batch",
      lastMeasurement: "PREVIOUS MEASUREMENT",
      lastDate: "Last measurement date",
      lastValue: "Last measurement value",
      saveOptions: {
        onlySave: "Save only",
        saveAndAddNew: "Save and add new measurement",
      },
      messages: {
        successMessage: "Measurement saved successfully!",
        errorMessage: "Error saving the measurement. Please try again.",
        deleteSuccess: "Measurement deleted successfully!",
        deleteError: "Error deleting the measurement. Please try again.",
      },
    },
  },
  dailyLiveCattlesDataAgro: {
    codes: {
      D_PEPR_GO_BR: "@ GO",
      D_PEPR_MG_BR: "@ MG",
      D_PEPR_MT_BR: "@ MT",
      D_PEPR_MS_BR: "@ MS",
      D_PEPR_SP_BR: "@ SP",
      D_PEPR_RO_BR: "@ RO",
      D_PEPR_TO_BR: "@ TO",
      D_PEPR_PA_BR: "@ PA",
      D_PEPR_BA_BR: "@ BA",
      D_PEPR_MT_N_BR: "@ MT N",
      D_PEPR_MT_S_BR: "@ MT S",
      D_PEPR_MT_NE_BR: "@ MT NE",
      D_PEPR_MT_SE_BR: "@ MT SE",
    },
  },
  animalBirth: {
    title: "List of Births and Reproductive Losses",
    buttonNew: "New Birth/Loss",
    table: {
      columns: {
        matrizAnimalHandlingNumber: "Breeding cow",
        birthDate: "Date of delivery",
        type: "Type",
        coverageDate: "Serv. Date",
        coverageType: "Serv. Type",
        reproductor: "Bull",
        child_handling_number: "Calf",
        child_gender: "Gender",
        child_birthday_weight: "Birth Weight",
        child_situation: "Situation",
        child_weaning_weight: "Weaning Weight",
        child_weaning_date: "Weaning Date",
        iep: "Calving Interval",
        childs: {
          handlingNumber: "Identification",
          gender: "Gender",
          birthdayWeight: "Birth weight",
          situation: "Condition",
        },
      },
    },
    types: {
      parto: "Birth",
      aborto: "Abortion",
      morteEmbrionaria: "Embryonic Death",
    },
    form: {
      titleCreateNew: "New Birth/Loss",
      titleEdit: "Edit Birth/Loss",
      matrizAnimalId: "Identification",
      type: "Type",
      birthDate: "Date",
      animalReproductionCategory: "Category",
      femaleSituation: "Condition",
      gestationDays: "Gestation period",
      coverageInfoType: "Type",
      coverageInfoDate: "Date",
      coverageInfoGestationTime: "Gestation period",
      coverageInfoBirthForecast: "Birth Forecast",
      coverageInfoBull: "Bull",
      coverageInfoDGDate: "PD Date",
      coverageInfoDGResult: "PD Result",
      shouldDiscardFemale: "Discard Female?",
      discardMotive: "Cause",
      lotMatrizDestinationId: "Production Batch",
      observation: "Remarks",
      child: {
        nickname: "Name",
        nicknamePlaceHolder: "Name",
        sisbov: "NAIS",
        sisbovPlaceHolder: "NAIS",
        tagId: "Electronic Tag Id",
        tagIdPlaceHolder: "Electronic Tag Id",
        sex: "Gender",
        male: "Male",
        female: "Female",
        acquisition: "Acquisition",
        handlingNumber: "Identification",
        handlingNumberPlaceHolder: "Animal Id.",
        breed: "Breed",
        breedPlaceHolder: "Select a breed",
        cap: "Castrated animal?",
        birthday: "DOB",
        birthdayWeight: "Birth weight",
        firstInseminationWeight: "First insemination",
        weaningWeight: "Weaning weight",
        weaningDate: "Weaning Date",
        asymptoticWeight: "Sigmoid weight",
        asymptoticWeightInfoTooltip:
          "Sigmoid weight is the weight that, based on the information that the user/producer has about the history of the Animal or Batch of Animals (considering genetics, previous management, genotype-environment interaction, frame, among other variables), he believes to be the potential weight limit. In other words, above this weight, this animal will hardly gain weight under normal conditions.",
        acquisitionDate: "Acquisition date",
        acquisitionEstimatedWeight: "Acquisition weight",
        carcassHarnessing: "Carcass yield",
        animalFarmFunction: "Purpose",
        animalReproductionCategory: "Category",
        sisbovIdentificationDate: "Identif Date",
        sisbovInsertBNDDate: "Date Inclusion NAIS",
        sisbovSlaughterDate: "Slaughter Release Date",
        lotId: "Production Batch",
        farmOwner: "Owner",
        purchaseCost: "Acq. value",
        stillborn: "Stillborn?",
      },
      newEntry: "New entry",
      editEntry: "Edit entry",
      newChild: "New Calf",
      childTab: "Calf",
      defineCoverage: "Define Service",
      selectCoverageTitle: "Select the service responsible for the pregnancy:",
      coverageModalDate: "Date",
      coverageModalReproductor: "Bull",
      coverageModalGestationDays: "Gestation (days)",
      coverageModalInputPlaceholder: "Type",
      childStatusNatural: "Live",
      childStatusStillborn: "Stlb.",
      coverageDataTitle: "Service Data",
    },
    messages: {
      deleteSuccess: "Birth deleted successfully!",
      deleteError: "Error deleting birth.",
      deleteErrorWithChilds:
        "This birth cannot be deleted because the calf ({{childs}}) has records after the creation date.",
      saveSuccess: "Birth saved successfully!",
      saveErrorConflict:
        "Attention! This birth cannot be saved, there are date conflicts among reproductive events.",
      saveError: "Error saving Birth, contact support.",
      selectCoverage: 'Select a service using the "Define Service" button.',
      inconsistentGestationDays:
        "Attention! Gestation period entered is inconsistent, as it covers a period in which the female already has service(s) with result(s).",
      minGestationViolation:
        "Attention! Gestation period below the minimum time ({{days}} days), defined in the breed parameters of the Breeding Cow. Operation cancelled!",
      maxGestationViolation:
        "Attention! Gestation period above the maximum time ({{days}} days), defined in the breed parameters of the Breeding Cow. Operation cancelled!",
      gestationDaysRequired: 'Enter a value for the "Gestation (days)" field',
    },
    discardMotives: {
      age: "Age",
      reproductiveProblems: "Reproductive Problems",
      diseaseOrPhysicalProblems: "Diseases or Physical Problems",
      bodyCondition: "Body Condition",
      negativePregnancy: "Negative Pregnancy",
      maternalAbility: "Maternal Ability",
    },
    modal: {
      maleOperationError: "This operation cannot be performed on Males!",
      gestationDaysError:
        "Birth date is {differenceDays} days above the maximum gestation period ({maxGestationDaysBreed} days).",
      femaleAgeError:
        "Female does not have the age to begin the reproductive phase.",
      fattenFemaleConfirm:
        "Female intended for Fattening, do you want to continue?",
      changeToReproductionConfirm:
        "Do you want to change the female to Reproduction?",
      emptyFemaleConfirm: "Empty female. Do you want to proceed with Birth?",
    },
  },
  animalVaccination: {
    messages: {
      animalNotFound: "No animal found!",
      saveSuccess: "Application created/updated successfully.",
      saveError: "Application was not created/updated. Contact support",
    },
  },
  animalReproductionState: {
    solteira: "Non-pregnant cow",
    parida: "Calved cow",
  },
  animalReproductionCategory: {
    nulipara: "Nulliparous",
    novilha: "Heifer",
    primipara: "Primiparous",
    secundipara: "Secundiparous",
    multipara: "Multiparous",
    Bull: "Bull",
    reprodutor: "Sire",
  },
  femaleSituation: {
    vazia: "Empty",
    prenha: "Pregnant",
    servida: "Serviced",
  },
  animalFarmFunction: {
    reproduction: "Reproduction",
    fatten: "Fattening",
  },
  birthTypes: {
    parto: "Birth",
    aborto: "Abortion",
    morteEmbrionaria: "Embryonic Death",
  },
  animalStatus: {
    A: "Active",
    Active: "Active",
    S: "Sold",
    Sold: "Sold",
    D: "Dead",
    Dead: "Dead",
    I: "Inactive",
    Inactive: "Inactive",
    T: "Transferred",
    Transfer: "Transferred",
    P: "Pending",
    Pending: "Pending",
  },
  animalMovementEvents: {
    weight: "Weighing",
    vacination: "Vaccination",
    coverage: "Service",
    pregnancyDiagnosis: "Pregnancy Diagnosis",
    birth: "Birth",
    discard: "Discard",
    lotEntry: "Entry to the Lot",
  },
  financialClass: {
    buttonNew: "New Class",
    form: {
      titleCreateNew: "New Class",
      titleEdit: "Edit Class",
      financialNatureId: "Nature",
      name: "Name",
      shouldCost: "Considered for Costing?",
      shouldDisbursement: "Considered for Desimbursement?",
      depreciation: "Depreciation",
      costCenterName: "Cost Center",
      externalIntegrationCode: "External Integration Code",
    },
  },
  financialNature: {
    buttonNew: "New Nature",
    form: {
      titleCreateNew: "New Financial Nature",
      titleEdit: "Edit Financial Nature",
      name: "Name",
      type: "Type",
      typeIncome: "Income",
      typeExpense: "Expense",
      stock: "Stock",
      stockTooltip: "Select if this financial nature is related to stock.",
      canBudget: "Can Budget?",
      canBudgetTooltip:
        "Select if this financial nature can be used in budgets.",
      externalIntegrationCode: "External Integration Code",
      scope: "Scope",
      scopeFarm: "Current Farm",
      scopeGroup: "Group",
    },
    messages: {
      createSuccess: "Financial nature created successfully.",
      updateSuccess: "Financial nature updated successfully.",
      error: "Error creating/updating Financial nature. Contact support.",
      adjustResultCenterWarning:
        "We recommend adjusting the Result Centers created for the farm, after saving the financial nature.",
    },
  },
  costCenterDefaultNames: {
    PRODUCAO_ANIMAL: "Animal Production",
    UTILIDADES: "Utilities",
    INFRAEST_PRODUTIVA: "Product Infrast.",
    INFRAEST_OPERACIONAL: "Operat. Infrast.",
    INFRAEST_APOIO: "Service Infrast.",
    TAXA_IMPOSTOS: "Fees & Taxes",
    SERVICOS: "Services",
    INVSUMOS_OPERACIONAIS: "Oper. Inputs",
    PRODUCAO_PASTO_AGRICOLA: "Crop/Pasture Prod.",
  },
  financialProject: {
    title: "Investiment Projects",
    buttonNew: "New Project",
    messages: {
      deleteSuccess: "Financial project deleted successfully.",
      errorTitle: "Error",
      linkedError:
        "This Financial Project cannot be deleted, it is already linked to Financial Transactions.",
      deleteError: "Error deleting financial project.",
    },
    table: {
      columns: {
        name: "Project name",
        description: "Remarks",
        startProjectDate: "Start Date",
        finishProjectDate: "End Date",
        status: "Status",
      },
    },
    form: {
      titleCreateNew: "New Investment Project",
      titleEdit: "Edit Investment Project",
      name: "Project name",
      description: "Remarks",
      startProjectDate: "Start Date",
      finishProjectDate: "End Date",
      status: "Active?",
    },
  },
  animalGender: {
    Female: "Female",
    Male: "Male",
  },
  lotItemEntry: {
    form: {
      entryDate: "Entry Date",
      amountAnimals: "Amount",
      averageWeight: "Avg. Weight",
      animalFarmFunction: "Purpose",
      animalReproductionCategory: "Category",
      ageInDays: "Age (days/months/years)",
      usePrefixedIdentification: "Use prefixed identification",
      prefixIdentification: "Prefix for Identification ",
      initialIdentificationSequence: "Initial identification sequence",
      lotDestinationId: "Destination Batch",
    },
  },
  picketSupplyForecast: {
    buttonOpen: "Edit Forecast",
    title: "Edit Supply Forecast",
    forecastDate: "Forecast date",
    table: {
      picket: "Pen/Paddock",
      lot: "Lot",
      baseDayTotalSupplied: "Supplied (base day)",
      supplyNumber: "Treat",
      recipe: "Recipe",
      calculatedQuantity: "Calculated",
      quantity: "To supply",
      realizedTooltip: "Treat already done on this date",
      restoreCalculated: "Restore calculated value",
      empty: "No pen in the forecast for this date",
    },
    messages: {
      noSupply: "There is no supply on the day before the chosen date.",
      loadError: "An error occurred while loading the forecast. Please contact support.",
      nothingToSave: "No changes to save.",
      saveSuccess: "Forecast saved successfully.",
      saveError: "An error occurred while saving the forecast. Please contact support.",
    },
  },
  picketSupplementSupply: {
    title: "Feed delivering",
    buttonNew: "Feed delivering report",
    table: {
      columns: {
        supplyDate: "Date",
        picketsCount: "Paddocks/Pens",
        totalSupplementSupplied: "Tot Delivered(Kg)",
        responsibleName: "Responsible",
        subTable: {
          retreatName: "Range Unit/Row",
          picketName: "Paddocks/Pens",
          lotName: "BATCH",
          totalAnimals: "Amt. Animals",
          supplementName: "Supplem./Concent.",
          weightedAverageDryMatter: "%DM",
          totalSupplementSupplied: "Amt. Delivered",
          productionSubSystem: "Production subsystem",
          subTable: {
            supplyNumber: "Delivery run N°",
            supplementName: "Supplem./Concent.",
            dryMatterPercentage: "%DM",
            quantitySupplied: "Amt. Delivered",
            responsibleName: "Responsible",
            version: "Version",
            prevSupplyHourInMinutes: "Planned Time",
            supplyHourInMinutes: "Actual Time",
            readFeederValue: "Food Intake Assessment",
          },
        },
      },
    },
    form: {
      titleCreateNew: "New/Edit Food Delivering",
      titleEdit: "Edit Delivering",
      filtersTitle: "Filters",
      speedersTitle: "Accelerators",
      applyFilterHint:
        "When you click Apply, the data in the 'Delivering' section will be overwritten by the filtered paddocks.",
      applyDefaultsHint:
        "When you click Apply, the empty fields in the 'Delivering' section will be overwritten by the values chosen in the fields next to it.",
      supplyDate: "Date",
      supplyNumber: "Delivery run N°",
      responsibleName: "Responsible",
      retreats: "Range Unit/Row",
      pickets: "Paddocks/Pens",
      lots: "Batches",
      subSystems: "Production subsystem",
      quantitySupplied: "Amt. Delivered",
      supplement: "Supplem./Concent.",
      hourSupplied: "Delivery Time",
      searchPicketOrLot: "Search paddock/pen or batch",
      noResults: "No results found.",
      current: "Current",
      previous: "Previous",
      applyPreviousValue: "Apply previous value",
      saveOptions: {
        only_save: "Save",
        save_and_create_new: "Save and create new delivery",
      },
      tableSupplies: {
        picketName: "Picket/Bay",
        lotName: "Lot",
        animalsCount: "Animal Qty",
        avgWeight: "Estimated Weight",
        avgGdp: "Estimated GDP",
        supplementId: "Supplement/Feed",
        dryMatterPercentage: "DM: Dry Matter",
        quantitySupplied: "Qty Supplied",
        prevSuppliedPerAnimal: "Prev. per animal/day",
        prevSuppliedDryMatterByWeight: "Prev. DM %BW",
        prevSupplyHourInMinutes: "Scheduled Time",
        supplyHourInMinutes: "Actual Time",
        observation: "Observation",
      },
    },
    dashboard: {
      picketId: "Pickets/Bays",
      lotId: "Lots",
      periodType: "Period",
      startDate: "Start Date",
      endDate: "End Date",
      exhibitionType: "Display",
      exhibitionTypeOptions: {
        column: "Columns/Bar",
        line: "Line",
      },
      buttonProcessDashboard: "Filter/Process Chart",
    },
  },
  partialPayment: {
    title: "Create Partial Payment ",
    form: {
      valuePartialPayment: "Partial Payment Amt.",
      settleDate: "Settling date",
      expirationDate: "New Due Date",
      valuePendingPayment: "Due Payment Amt.",
      fees: "Interest/Fines Amount ",
    },
  },
  financialDashboard: {
    resultCenter: "Profit Center",
    costCenter: "Cost Center",
    costType: "Activity",
    period: "Period",
    financialProject: "Inv. Project",
    bankAccount: "Banking acct.",
    buttonConfirm: "Process",
    periods: {
      lastSevenDays: "Last 7 days",
      lastThirdyDays: "Last 30 days",
      currentMonth: "Current Month",
      lastMonth: "Last Month",
      currentYear: "Current Year",
      lastYear: "Last Year",
      currentHarvest: "Current Harvesting Year",
      lastHarvest: "Last Harvesting Year",
      customDateRange: "Specify Date ",
    },
  },
  animalHandlingAlert: {
    title: "Handling Alerts",
    buttonNew: "New Alert",
    table: {
      columns: {
        status: "Status",
        handlingNumber: "Animal",
        visualizationType: "Visualization Type",
        message: "Message",
      },
    },
    form: {
      titleNew: "New Handling Alert",
      titleEdit: "Edit Handling Alert",
      animals: "Animals",
      message: "Message",
      visualizationType: {
        label: "Visualization Type",
        permanent: "Permanent",
        confirm: "Confirmation",
        expiration: "Expiration",
      },
      expirationDate: "Expiration Date",
      notifications: {
        saveSuccess: "Alert saved/updated successfully.",
        saveError: "Error saving/editing Handling Alert.",
        inactivateSuccess: "Alert inactivated successfully!",
        inactivateError: "Error inactivating Alert. Contact support.",
        deleteSuccess: "Alert deleted successfully!",
        deleteError: "Error deleting Alert. Contact support.",
        activateSuccess: "Alert activated successfully!",
        activateError: "Error activating Alert. Contact support.",
        validationAnimals: "Select at least one animal for the alert.",
      },
    },
  },
  reproductiveProtocol: {
    title: "Reproductive Protocols ",
    buttonNew: "New Protocol",
    table: {
      columns: {
        status: "Status",
        name: "Name",
        duration: "Duration",
        createdAt: "Date Created",
        createdBy: "Responsible for Creation",
        applicationDays: {
          orderApplication: "Order",
          dayApplication: "Day?",
          product: "Product/Hormone ",
        },
      },
    },
    form: {
      titleCreateNew: "New Protocol",
      titleEdit: "Edit Protocol",
      groupFarmVisibility: "Who will use this Protocol?",
      name: "Generic name",
      duration: "Protocolo duration",
      newApplicationDay: "Row",
      observations: "Remarks",
      applicationDays: {
        orderApplication: "Order",
        dayApplication: "Day?",
        product: "Product/Hormone ",
      },
    },
  },
  animalFarmReproductiveProtocol: {
    title: "Posting Protocols",
    buttonNew: "Protocol Execution",
    table: {
      columns: {
        handlingNumber: "Female",
        dateApplication: "Date",
        reproductiveProtocolName: "Protocol",
        reproductionPeriodDescription: "Breeding Season",
        lotOriginName: "Batch of Origin",
        lotDestinationName: "Destination Batch",
      },
    },
    form: {
      titleCreateNew: "Apply Protocol",
      titleEdit: "Edit Protocol",
      buttonApply: "Apply",
      applyForAnimalsGroupForm: {
        dateApplication: "D0 Date",
        reproductiveProtocolId: "Protocol",
        reproductionPeriodId: "Breeding Season",
        lotDestinationId: "Destination Batch",
      },
      groupTitle: "Executions",
      animalsTable: {
        handlingNumber: "Identification",
        lotName: "BATCH",
        breedName: "Breed",
        age: "Age",
        femaleSituation: "Condition",
        animalFarmFunction: "Purpose",
        animalReproductionState: "Condition",
        animalReproductionCategory: "Category",
        lastBirthDate: "Last Birth Date",
      },
      selectAllAnimals: "Select all animals",
      clearSelections: "Clear selections",
    },
    messages: {
      deleteSuccess: "Protocol entry deleted successfully.",
      deleteError: "Error deleting protocol entry.",
      saveSuccess: "Protocol applied successfully.",
      saveErrorConflict:
        "Attention! Some animals already have a protocol recorded on the same date.",
      saveError: "Error applying Protocol",
      allAnimalsAlreadySelected:
        "All active animals on the farm have already been selected.",
    },
  },
  currency: {
    AED: "Dirham - Emirated",
    AFN: "Afghani - Afghanistan",
    ALL: "Lek - Albany",
    AMD: "Dram - Armenia",
    ANG: "Guilder - Netherlands Antillean ",
    AOA: "Kwanza - Angola",
    ARS: "Peso - Argentina",
    AUD: "Dollar - Australia",
    AZN: "Manat - Azerbaijan ",
    BAM: "Mark - Bosnia and Herzegovina ",
    BBD: "Dolar - Barbados",
    BDT: "Taka - Bangladesh",
    BGN: "Lev - Bulgary",
    BHD: "Dinar - Bahrein",
    BIF: "Franco - Burundi",
    BND: "Dolar - Brunei",
    BOB: "Bolivar - Bolivia",
    BRL: "Real - Brasil",
    BRLT: "Real Tourist - Brasil",
    BSD: "Dolar - Bahamas",
    BTC: "Bitcoin",
    BWP: "Pula - Botswana",
    BYN: "Ruble - Belarus",
    BZD: "Dolar - Belize",
    CAD: "Dolar - Canada",
    CHF: "Franco - Switzerland",
    CHFRTS: "Franco - Switzerland",
    CLP: "Peso - Chile",
    CNH: "Yuan – China offshore",
    CNY: "Yuan - China",
    COP: "Peso - Colombia",
    CRC: "Colón – Costa Rica",
    CUP: "Peso - Cuba",
    CVE: "Escudo – Cape Verde",
    CZK: "Coroa - Czech ",
    DJF: "Franco - Djubouti",
    DKK: "Coroa - Denamark",
    DOGE: "Dogecoin",
    DOP: "Peso – Dominican Rep.",
    DZD: "Dinar - Algeria",
    EGP: "Libra - Egypt",
    ETB: "Birr - Ethiopia",
    ETH: "Ethereum",
    EUR: "Euro",
    FJD: "Dolar - Fiji",
    GBP: "Pound Sterling – Great British",
    GEL: "Lari - Georgia",
    GHS: "Cedi - Ghana",
    GMD: "Dalasi - Gambiam",
    GNF: "Franco - Guinea",
    GTQ: "Quetzal - Guatemalan",
    HKD: "Dolar - Hong Kong",
    HNL: "Lempira - Honduras",
    HRK: "Kuna - Croatia",
    HTG: "Gourde - Haiti",
    HUF: "Florim - Hungary",
    IDR: "Rupia - Indonesia",
    ILS: "Novo Shekel – Israel",
    INR: "Rúpia - India",
    IQD: "Dinar - Iraq",
    IRR: "Rial - Iran",
    ISK: "Coroa - Iceland",
    JMD: "Dolar - Jamaica",
    JOD: "Dinar - Jordan",
    JPY: "Iene - Japan",
    JPYRTS: "Iene - Japan",
    KES: "Shilling - Kenya",
    KGS: "Som - Kyrgyzstan ",
    KHR: "Riel Cambodia",
    KMF: "Franco - Comoros",
    KRW: "Won – South Korea",
    KWD: "Dinar - Kwait",
    KYD: "Dolar - Cayman",
    KZT: "Tengue - Kazakhstan",
    LAK: "Kip - Laos",
    LBP: "Libra - Libya",
    LKR: "Rúpia - Sri Lanka",
    LSL: "Loti - Lesoto",
    LTC: "Litecoin",
    LYD: "Dinar - Libya",
    MAD: "Dirham - Morroccos",
    MDL: "Leu - Moldavia",
    MGA: "Ariary - Madagascar",
    MKD: "Denar - Macedonia",
    MMK: "Kyat - Mianmar",
    MNT: "Mongolian - Tugrik",
    MOP: "Pataca - Macau",
    MRO: "Ouguiya - Mauritania",
    MUR: "Rúpia - Mauritius",
    MVR: "Rufiyaa - Maldivas",
    MWK: "Kwacha - Malawi",
    MXN: "Peso - Mexico",
    MYR: "Ringgit - Malaysia",
    MZN: "Metical - Mozambique",
    NAD: "Dolar - Namib",
    NGN: "Naira - Nigeria",
    NGNI: "Naira - Nigeriaa",
    NGNPARALLEL: "Naira Nigeriana",
    NIO: "Córdoba - Nicaragua",
    NOK: "Krone - Norwich",
    NPR: "Rúpia - Nepal",
    NZD: "Dolar – New Zealand",
    OMR: "Rial - Oman",
    PAB: "Balboa - Panama",
    PEN: "Sol - Peru",
    PGK: "Kina Papua-New Guinea",
    PHP: "Peso - Philippines",
    PKR: "Rúpia - Pakistan",
    PLN: "Zlóti - Poland",
    PYG: "Guarani - Paraguay",
    QAR: "Rial - Qatar",
    RON: "Leu - Romania",
    RSD: "Dinar - Servia",
    RUB: "Rublo - Russia",
    RUBTOD: "Rublo - Russia",
    RUBTOM: "Rublo - Russia",
    RWF: "Franco - Rwanda",
    SAR: "Riyal - Arabia",
    SCR: "Rúpias - Seichelles",
    SDG: "Libra - Sudan",
    SDR: "DSE",
    SEK: "Krown - Sweden",
    SGD: "Dolar - Singapore",
    SOS: "Shilling - Somaly",
    STD: "Dobra - San Tome/Príncipe",
    SVC: "Colon - El Salvador",
    SYP: "Libra - Syria",
    SZL: "Lilangeni - Swaziland",
    THB: "Baht - Thailand",
    TJS: "Somoni - Tajikistan",
    TMT: "TMT",
    TND: "Dinar - Tunisia",
    TRY: "Nova Lira - Turkey",
    TTD: "Dolar - Trinidad",
    TWD: "Dolar - Taiwan",
    TZS: "Shilling - Tanzania",
    UAH: "Hryvinia - Ukraine",
    UGX: "Shilling - Uganda",
    USD: "Dolar – United States",
    USDT: "Dolar – United States",
    UYU: "Peso - Uruguay",
    UZS: "Som - Uzbekistan",
    VEF: "Bolívar - Venezuela",
    VND: "Dong - Vietnam",
    VUV: "Vatu - Vanuatu",
    XAF: "Franco - CFA Central",
    XAGG: "Prata",
    XBR: "Brent Spot",
    XCD: "Dolar - Western Caribe ",
    XOF: "Franco CFA Eastern",
    XPF: "Franco CFP",
    XRP: "XRP",
    YER: "Riyal - Yemen",
    ZAR: "Rand – South Africa",
    ZMK: "Kwacha - Zambia",
    ZWL: "Dolar - Zimbabwe",
    XAU: "Gold",
  },
  importFinancialTransaction: {
    title: "Import Financial Transactions",
    message:
      '<p class="message">Download <strong>template below, fill in the spreadsheet columns</strong> with financial entries, <strong>import it</strong> and click process.</p>',
    draggerMessage: "Click or drag the file to this area to upload it. ",
    importNewSupplierClientLabel: "Import new Suppliers/Clients?",
  },
  importPicketSupplementSupplyAndFeedReader: {
    title: "Import Supplement Supply and Trough Reading",
    buttonImport: "Import Supply/Reading",
    message:
      '<p class="message">Download <strong>the template below, fill in the spreadsheet</strong> with the supplement supplies and trough readings, <strong>import it</strong> and click process.</p>',
    draggerMessage: "Click or drag the file to this area to upload it. ",
    messages: {
      templateGenerating:
        "Your import template is being generated and will be downloaded soon. Please wait for the download.",
      templateError:
        "There was an error generating the template. Contact support.",
      importedAndUpdated:
        "Supplement supplies and trough readings imported and updated",
      importedAndUpdatedDesc:
        "Some supplies/trough readings were updated/inserted.",
      imported: "Supplement supplies and trough readings imported",
      partiallyImported:
        "Supplement supplies and trough readings partially imported",
      partiallyImportedDesc: "Some supplies/trough readings were not imported.",
      processedWithError: "File processed with error!",
      processedWithErrorDesc:
        "None of the supplies/trough readings were imported.",
      importError: "Import error",
      importErrorDesc: "No supply/trough reading was included.",
    },
  },
  confinementResultReport: {
    form: {
      title: "Feedlot Result",
      salesPeriod: "Sales Period",
      clientId: "Customer",
      supplierId: "Supplier",
      saleScenarioId: "Sales Scenario(s)",
      documentNumber: "Doc. N° ",
      lotIds: "Batches",
      showDeathData: "Display Deaths data in the period?",
      showOriginData: "Show origin of animals sold?",
      dailyOperationalCostMode: "Operational Daily Cost",
      dailyOperationalCostModeOptions: {
        BOVEXO_COSTING: "BovExo-Calculated",
        USER_DEFINED: "User-Defined ($/Day)",
      },
      additionalSlaughterCostValue: "Additional Slaughter Costs",
    },
  },
  farmDayScaleTreatmentParameter: {
    title: "Semen List",
    buttonNewSemen: "New Semen",
    table: {
      columns: {
        name: "Name",
        registration: "Register",
        breedName: "Breed",
      },
    },
    form: {
      titleCreateNewSemen: "New Semen",
      titleEditSemen: "Edit Semen",
      name: "Name",
      registration: "Register",
      breedId: "Breed",
      genealogy: "Genealogy",
      father: "Father",
      mother: "Mother",
      identification: "Identification",
    },
  },
  troughFeedingAssessment: {
    title: "Food intake Assessment",
    buttonNew: "Report Food Intake Assessment",
    table: {
      columns: {
        readingDate: "Date",
        supplyDate: "Food Delivery run",
        responsibleName: "Responsible",
        picketName: "Paddocks/Pens",
        lotName: "BATCH",
        dietStrategyName: "Diet Strategy",
        totalAnimals: "Amt. Animals",
        quantitySupplied: "Amt. Delivered(Kg)",
        readValue: "Intake Assessment ",
      },
    },
    form: {
      titleCreateNew: "New/Edit Intake Assessment ",
      filtersTitle: "Filters",
      speedersTitle: "Accelerators",
      applyFilterHint:
        "When you click Apply, the data in the 'Assessments' section will be overwritten by the filtered paddocks.",
      applyDefaultsHint:
        "When you click Apply, the empty fields in the 'Assessments' section will be overwritten by the values chosen in the fields next to it.",
      readingAlreadyDone: "Intake assessment already done on this date.",
      dietWithoutDryMatter:
        "Diet without registered DM: the adjustment will not be applied.",
      dietWithoutDryMatterOnSave:
        "The pens {{pickets}} have a diet without registered DM. The reading will be saved, but the adjustment will not be applied to them.",
      searchPicketOrLot: "Search paddock/pen or batch",
      noResults: "No results found.",
      daysUnit: "Days",
      daysConfinementUnit: "Conf. Days",
      informType: "Report by",
      informTypeValues: {
        byDate: "Date",
        byPicket: "Paddock/Pen",
      },
      readingType: "Intake Assessment Format",
      readingTypeValues: {
        unique: "Single",
        perSupply: "Run",
      },
      readingResult: "Intake Asses. value",
      readingDate: "Intake Asses. Date",
      readingHour: "Intake Asses. Time ",
      supplyNumber: "Delivery run N°(s)",
      supplyDates: "Date run",
      responsibleName: "Responsible",
      retreats: "Range Unit/Row",
      pickets: "Paddocks/Pens",
      lots: "Batches",
      tableSupplyNumber: "#Run",
      amountAnimals: "#Heads",
      confinementTime: "Stay Time",
      supplement: "Supplem./Concent.",
      realHour: "Actual Time",
      prevHour: "Planned Time",
      prevQuantitySupplied: "Forecast Amt. (Kg)",
      realQuantitySupplied: "Delivered Amt. (Kg)",
      observation: "Remarks",
      saveOptions: {
        only_save: "Save",
        save_and_create_new: "Save and create new Intake Assement",
      },
    },
  },
  processTransferAnimalTransactionModal: {
    title: "Process Animal Transfer",
    form: {
      origin: "Origin",
      amountAnimals: "Qty. Head",
      sellDate: "Date",
      animalValue: "Average Value",
      totalValue: "Total Value",
      totalInstallments: "Qty. Installments",
      firstInstallmentDate: "Date of 1st Installment",
      firstInstallmentValue: "Value of 1st Installment",
      resultCenter: "Result Center",
      lotDestinationId: "Destination Lot",
      financialNatureId: "Nature",
      financialClassId: "Class",
      farmOwnerId: "Owner",
      dividerTitle: "ADDITIONAL DATA",
      useFarmOwnersFromOrigin: "Keep owners from Origin Farm",
    },
    messages: {
      rejectModalTitle: "Alert",
      rejectModalContent:
        "Do you really want to reject this transfer? This action is irreversible!",
      successSubmit:
        "The transfer has been successfully confirmed and is now being processed. The transaction will be completed soon.",
      errorSubmit:
        "An error occurred while trying to confirm the transfer. Please contact support.",
      successReject:
        "The transfer is being rejected. The transaction will be successfully rejected soon.",
      errorReject:
        "An error occurred while trying to reject the transfer. Please contact support.",
      errorNotSelectFarmOwnerOrCheckUseOriginalFarmOwner:
        "You must select an Owner or check the option to keep the owners from the Origin Farm.",
      errorFarmOwnerNotCreated:
        "Attention! There are owners (listed below) of animals, not registered on this farm. To adjust, go to [Administration/Farms]",
    },
  },
  weightRanking: {
    top: "Top",
    middle: "Middle",
    bottom: "Bottom",
  },
  menuNavigation: {
    menu_stock: "INVENTORY",
    menu_diet_strategy: "DIET STRATEGY",
    menu_picket_supplement_supply: "SUPPLY",
    menu_trough_feeding_assessment: "TROUGH FEEDING ASSESSMENT",
    menu_weights: "WEIGHINGS AND MEASUREMENTS",
    menu_veterinary: "VETERINARY",
    menu_reproductive: "REPRODUCTIVE",
    menu_dashboard: "DASHBOARD",
    menu_purchase_scenario: "PURCHASE SCENARIO",
    menu_sale_scenario: "SALE SCENARIO",
    menu_purchase_scenario_boitel: "PURCHASE SCENARIO",
    menu_sale_scenario_boitel: "SALE SCENARIO",
    menu_nutritional: "NUTRITIONAL",
    menu_entry: "ENTRY",
    menu_technician_veterinary: "VETERINARY",
    menu_exit: "EXIT",
    menu_manager: "MANAGEMENT",
    menu_handling: "HANDLINGS",
    menu_purchase: "PURCHASE",
    menu_sale: "SALE",
    menu_purchase_boitel: "PURCHASE",
    menu_sale_boitel: "SALE",
    menu_recreate_fatten_extensive: "R/E PASTURE",
    menu_growth: "GROWTH",
    menu_confinement: "R/E CONFINEMENT",
    menu_boitel: "BOITEL",
    menu_commercial_boitel: "COMMERCIAL",
    menu_contracts_boitel: "CONTRACTS",
    menu_contracts_boitel_confinament: "COMMERCIAL",
  },
  weather: {
    title: "Weather Data",
  },
  arrobaPrice: {
    title: "Financial Data",
    dataAgro: {
      selectDate: "Select a date: ",
    },
    marketAnalysisDash: {
      title: "Price Curve",
      selectCurve: "Select the curve you want to view:",
      emptyMessage: "Select a curve to display the chart",
    },
  },
  alertPanel: {
    title: "alerts & pending items",
    emptyMessage: "No alerts found on this date",
  },
  viewTransferAnimalTransactionModal: {
    title: "Animal Transfer Details",
    form: {
      origin: "Origin",
      amountAnimals: "Qty. Head",
      sellDate: "Date",
      animalValue: "Average Value",
      totalValue: "Total Value",
      totalInstallments: "Qty. Installments",
      firstInstallmentDate: "Date of 1st Installment",
      firstInstallmentValue: "Value of 1st Installment",
      resultCenter: "Result Center",
      lotDestinationId: "Destination Lot",
      financialNatureId: "Nature",
      financialClassId: "Class",
      farmOwnerId: "Owner",
      dividerTitle: "ADDITIONAL DATA",
    },
    table: {
      columns: {
        handlingNumber: "Animal",
        dateTransferCreation: "Registration Date",
        dateTransferAccept: "Confirmation Date",
        weightTransfer: "Weight",
        priceTransfer: "Price",
        lotOriginName: "Origin Lot",
        lotDestinationName: "Destination Lot",
        responsibleCreateTransfer: "Origin Responsible",
        responsibleAcceptTransfer: "Destination Responsible",
      },
    },
  },
  movementAnimalReportParameter: {
    title: "Herd Dynamics by Age",
    classification: "Classification",
    externalIntegrationCode: "External Integration Code",
    messages: {
      errorLenghtEqualZero:
        "At least one age classification by gender is required.",
      errorClassificationWithoutMinAge:
        "Classifications must have a minimum age.",
      errorClassificationWithManyMaxAgeNull:
        "Only one classification without a maximum age per gender is allowed.",
      errorClassificationWithMaxAgeLessThanOrEqualToMinAge:
        "The maximum age must be greater than the minimum age.",
      errorClassificationWithWrongOrder:
        "Classifications must follow an age order, where the minimum age of a classification must be greater than the maximum of the previous one.",
    },
  },
  movementAnimalReportModalRequest: {
    title: "Animal Movements",
    form: {
      onlyFinalStock: "Current Animal Stock",
      allFarmGroups: "All Farms",
      datePeriod: "Period",
      breedId: "Breed",
      ownerId: "Owner",
      supplierId: "Supplier",
      lotIds: "Batches",
    },
  },
  successGenerateReport: "Report generated successfully",
  errorGenerateReport:
    "There was an error generating the report. Please contact support",
  reports: {
    tabs: {
      favorite: "Favorites",
      animal: "Animals",
      produciton: "Production",
      financial: "Financial",
      management: "Management",
      operational: "Operations",
    },
    titles: {
      SimpleAnimalReport: "Simple Animal Report",
      ListAnimalReportReproduction: "Animal Listing Report (Reproduction)",
      ListAnimalReportFatten: "Animal Listing Report (Fattening)",
      AnimalWeightImportReport: "Weight Import Report",
      AnimalManagementObservation: "Management Observations Report",
      ReportMovementAnimals: "Movement Report",
      ReportNutritionalConsumption: "Feed/Supplement Consumption Report",
      ReportPicketFeedingAssessment: "Supply Spreadsheet",
      IntensiveResultReport: "Confinement Results Report",
      FarmSalesReport: "Sales Results Report",
      FinancialTransactionsReport: "Financial Transactions Export",
      FinancialCashFlowReport: "Cash Flow Report",
      DisbursementReport: "Disbursement Report",
      ReportAnimalWeightHistory: "Weight Report",
      ReportLotStock: "Stock Report by Lot",
      ReportTroughReadingSheet: "Trough Reading Sheet",
      ContractsReport: "Contracts Report",
      ContractsSaleResultReport: "Sale Result Report - Contracts",
    },
    messages: {
      errorUpdateFavorite:
        "An error occurred while updating/removing the report from favorites",
    },
  },
  financialCashFlowReportModalRequest: {
    title: "Cash Flow Report",
    form: {
      transactionType: "Type",
      periodStartDate: "Start",
      periodEndDate: "End",
      periodType: "Period",
      intervalType: "Interval",
      farmIds: "Farm(s)",
      financialNatureId: "Nature",
      financialClassId: "Class",
      costActivityType: "Activity",
      showZeroValues: "Show Classes with no movements in the period?",
      showAnalyticalData: "Generate analytical report?",
    },
    periods: {
      lastSevenDays: "Last 7 days",
      lastThirdyDays: "Last 30 days",
      currentMonth: "Current Month",
      lastMonth: "Previous Month",
      currentYear: "Current Year",
      lastYear: "Previous Year",
      currentHarvest: "Current Harvest",
      lastHarvest: "Previous Harvest",
      customDateRange: "Specify Date (Max. 12 months)",
    },
    intervals: {
      daily: "Daily",
      weakly: "Weekly",
      monthly: "Monthly",
      yearly: "Yearly",
    },
    messages: {
      errorPeriodMoreThanTwelveMonths: "Period cannot exceed 12 months.",
      errorNoDataFound: "No results were found with the applied filter",
    },
  },
  disbursementReportModalRequest: {
    title: "Disbursement Report",
    form: {
      transactionType: "Type",
      periodStartDate: "Start",
      periodEndDate: "End",
      periodType: "Period",
      intervalType: "Interval",
      farmIds: "Farm(s)",
      financialNatureId: "Nature",
      financialClassId: "Class",
      costActivityType: "Activity",
      showZeroValues: "Display Classes without transactions in the period?",
      showAnalyticalData: "Generate analytical report?",
    },
    periods: {
      lastSevenDays: "Last 7 days",
      lastThirdyDays: "Last 30 days",
      currentMonth: "Current Month",
      lastMonth: "Previous Month",
      currentYear: "Current Year",
      lastYear: "Previous Year",
      currentHarvest: "Current Harvest",
      lastHarvest: "Previous Harvest",
      customDateRange: "Specify Date (Max. 12 months)",
    },
    intervals: {
      daily: "Daily",
      weakly: "Weekly",
      monthly: "Monthly",
      yearly: "Yearly",
    },
    messages: {
      errorPeriodMoreThanTwelveMonths: "Period cannot exceed 12 months.",
      errorNoDataFound:
        "There are no financial transactions and/or animals in the period reported.",
    },
  },
  reportTroughReadingSheetModalRequest: {
    title: "Trough Reading Sheet",
    form: {
      date: "Date",
      pickets: "Range Unit/Paddocks",
    },
    messages: {
      informData: "Enter the data below to generate the trough reading sheet.",
      preparingReport:
        "Your report is being prepared and will be downloaded shortly! Please do not close this browser tab.",
      noDataFound: "No data was found with the provided filters.",
    },
  },
  financialPaymentMethod: {
    parameter4004: "Use payment method?",
    title: "Payment Method",
    buttonNew: "New Method",
    table: {
      columns: {
        name: "Payment Method",
        code: "Code",
        status: "Status",
      },
    },
    form: {
      groupFarmVisibility: "Who will use the Payment Method?",
      titleCreateNew: "New Payment Method",
      titleEdit: "Edit Payment Method",
      name: "Name",
      code: "Code",
      status: "Active?",
    },
    messages: {
      successMessage: "Payment Method successfully saved/updated.",
      errorMessage:
        "Unable to save/update the payment method. Please contact support.",
      activateMessage: "Payment Method activated",
      inactivateMessage: "Payment Method deactivated",
      deleteSuccess: "Payment Method deleted successfully.",
      errorTitle: "Error",
      linkedError:
        "This Payment Method cannot be deleted, it is already linked to Financial Transactions.",
      deleteError: "Error deleting payment method.",
    },
  },
  financialIssue: {
    parameter4003: "Use financial issues?",
    title: "Financial Issue",
    buttonNew: "New Issue",
    table: {
      columns: {
        name: "Financial Issue",
        code: "Code",
        status: "Status",
      },
    },
    form: {
      groupFarmVisibility: "Who will use the Financial Issue?",
      titleCreateNew: "New Financial Issue",
      titleEdit: "Edit Financial Issue",
      name: "Name",
      code: "Code",
      status: "Active?",
    },
    messages: {
      successMessage: "Financial Issue successfully saved/updated.",
      errorMessage:
        "Unable to save/update the financial issue. Please contact support.",
      activateMessage: "Financial Issue activated",
      inactivateMessage: "Financial Issue deactivated",
      deleteSuccess: "Financial Issue deleted successfully.",
      errorTitle: "Error",
      linkedError:
        "This Financial Issue cannot be deleted, it is already linked to Financial Transactions.",
      deleteError: "Error deleting financial issue.",
    },
  },
  financialTaxableDeductible: {
    parameter4005: "Use taxable and deductible IR?",
    title: "Taxable and Deductible",
    buttonNew: "New Taxable and Deductible",
    table: {
      columns: {
        name: "Taxable and Deductible",
        code: "Code",
        status: "Status",
      },
    },
    form: {
      groupFarmVisibility: "Who will use Taxable and Deductible?",
      titleCreateNew: "New Taxable and Deductible",
      titleEdit: "Edit Taxable and Deductible",
      name: "Name",
      code: "Code",
      status: "Active?",
    },
    messages: {
      successMessage: "Taxable and deductible successfully saved/updated.",
      errorMessage:
        "Unable to save/update taxable and deductible. Please contact support.",
      activateMessage: "Taxable and deductible activated",
      inactivateMessage: "Taxable and deductible deactivated",
      deleteSuccess: "Taxable and deductible deleted successfully.",
      errorTitle: "Error",
      linkedError:
        "This Taxable and Deductible cannot be deleted, it is already linked to Financial Transactions.",
      deleteError: "Error deleting taxable and deductible.",
    },
  },
  radiogroup: {
    farm: "Only this farm",
    group: "Group farms",
  },
  importAnimalCoverage: {
    title: "Import Coverages and DG's",
    message:
      '<p class="message">Download the <strong>template below, complete the spreadsheet</strong> with the coverages and/or DGs, <strong>import it</strong>, and then click process.</p>',
    draggerMessage: "Click or drag the file to this area to upload",
  },
  bankAccountFarm: {
    parameter4006: "Use bank account?",
    title: "Bank Account",
    buttonNew: "New Method",
    table: {
      columns: {
        description: "Name",
        bankName: "Bank",
        bankCode: "Bank Code",
        bankAccountNumber: "Account Number",
        bankAgencyNumber: "Agency Number",
        initialBalanceDate: "Initial Balance Date",
        initialBalance: "Initial Balance",
        status: "Status",
      },
    },
    form: {
      groupFarmVisibility: "Who will use the bank account?",
      titleCreateNew: "New Bank Account",
      titleEdit: "Edit Bank Account",
      description: "Name",
      bankId: "Bank",
      bankAccountNumber: "Account Number",
      bankAgencyNumber: "Agency Number",
      initialBalanceDate: "Initial Balance Date",
      initialBalance: "Initial Balance",
      status: "Active?",
      type: "Account Type",
      types: {
        PESSOA_FISICA: "Individual",
        PESSOA_JURIDICA: "Business",
      },
    },
    messages: {
      successMessage: "Bank account saved/updated successfully.",
      errorMessage: "Could not save/update the bank account. Contact support.",
      activateMessage: "Bank account activated",
      inactivateMessage: "Bank account deactivated",
    },
  },
  bankConciliation: {
    tabs: {
      bankConciliation: "Conciliate",
      bankStatement: "Statement",
    },
  },
  statement: {
    title: "Statements",
    buttonNew: "Import Statement",
    table: {
      columns: {
        bankCode: "Bank Code",
        bankName: "Bank",
        bankAccountNumber: "Account Number",
        bankAgencyNumber: "Agency Number",
        fileName: "File Name",
        startTransactionsDate: "Start Date",
        endTransactionsDate: "End Date",
        transactionDate: "Date",
        type: "Type",
        name: "Description",
        amount: "Amount",
        accountFarmDescription: "Bank Account",
        status: "Status",
      },
    },
    form: {
      steps: {
        step1: "Load",
        step2: "Review",
        step3: "Import BovExo",
      },
      bankCode: "Bank Code",
      bankName: "Bank",
      bankAccountNumber: "Account Number",
      bankAgencyNumber: "Agency Number",
      fileName: "File Name",
      startTransactionsDate: "Start Date",
      endTransactionsDate: "End Date",
      transactionDate: "Date",
      type: "Type",
      name: "Description",
      amount: "Amount",
      accountFarmDescription: "Bank Account",
      status: "Status",
      period: "Period",
      transactions: "Transactions",
    },
    types: {
      DEBIT: "Debit",
      CREDIT: "Credit",
      XFER: "Transfer",
      CHECK: "Check",
      PAYMENT: "Payment",
      CASH: "Cash",
      DIRECTDEP: "Direct Deposit",
      DIRECTDEBIT: "Direct Debit",
      HOLD: "Pending",
      OTHER: "Other",
      DEP: "Deposit",
    },
    messages: {
      reviewMessage:
        "Review the imported statement data and select the transactions to be reconciled.",
      successMessage: "Bank account saved/updated successfully.",
      errorMessage: "Could not save/update the bank account. Contact support.",
      activateMessage: "Bank account activated",
      inactivateMessage: "Bank account deactivated",
    },
  },
  conciliation: {
    form: {
      statementTransactionType: "Type",
      statementTransactionBankAccountFarmName: "Paying Source",
      statementTransactionDate: "Date",
      statementTransactionAmount: "Amount",
      statementTransactionDescription: "Description",
    },
    table: {
      columns: {
        statementTransactionType: "Type",
        statementTransactionBankAccountFarmName: "Paying Source",
        statementTransactionDate: "Date",
        statementTransactionAmount: "Amount",
        statementTransactionDescription: "Description",
        expirationDate: "Date",
        billingDate: "Date",
        value: "Amount",
        documentNumber: "Document Number",
        installmentNumber: "Installment",
        transactionType: "Type",
        supplierClientName: "Supplier/Client",
        paymentMethodName: "P. Method",
        bankAccountFarmName: "Paying Source",
      },
    },
    transactionTypes: {
      income: "Income",
      expense: "Expense",
    },
    selectFinancialInstallmentsModal: {
      statementTransactionType: "Type",
      statementTransactionBankAccountFarmName: "Paying Source",
      statementTransactionDate: "Date",
      statementTransactionAmount: "Amount",
      statementTransactionDescription: "Description",
      selectedRows: "Selected",
      selectedRowsSum: "Total Selected",
      differenceLabel: "Difference",
    },
    messages: {
      successConciliation: "Reconciliation successfully completed",
      errorConciliation: "Error while reconciling. Contact support",
      errorNoTransactionsSelectedMessage: "No transactions selected",
      errorNoTransactionsSelectedDescription:
        "Please select at least one transaction to reconcile.",
      errorSelectedStatementsWithoutTransactionsSelected:
        "There are transactions without selected financial movements",
      errorTransactionsWithWrongSumValueMessage:
        "Invalid values in financial movements",
      errorTransactionsWithWrongSumValueDescription:
        "All financial movement values must be filled, and the sum must equal the transaction amount.",
      errorWrongSumValuesMessageOnSelectInstallmentModal: "Error",
      errorWrongSumValuesDescriptionOnSelectInstallmentModal:
        "The sum of the selected values differs from the statement amount.",
      successRemoveConciliation:
        "The bank reconciliation for this record has been removed",
      errorRemoveConciliation:
        "Could not remove the bank reconciliation for this record. Contact support",
      successAddNewConciliation: "A record has been added for reconciliation",
      errorAddNewConciliation:
        "Could not add a record for reconciliation. Contact support",
    },
  },
  contractsReportModal: {
    title: "Contracts Report",
    form: {
      cattleProducerId: "Cattle Producer",
      contractDate: "Contract Date",
      identificationContract: "Contract Identification",
      identificationContractPlaceholder: "Enter contract identification",
      cattleProducerRequired: "Cattle Producer is required",
    },
    messages: {
      errorNoDataFound: "No results were found with the given filter",
      checkVigente: "Confirm if the filtered contracts have status VIGENTE",
      checkActiveLot:
        "Confirm if all animals selected in contracts have a Lot with status Ativo",
    },
  },
  contractsSaleResultReportModal: {
    title: "Report: Sale Result - Contracts",
    form: {
      salesPeriod: "Sales Period",
      contractType: "Contract Type",
      contractTypeOptions: {
        ARROBA_PRODUCTION: "Partnership (@ Produced)",
      },
      cattleProducerId: "Partner",
      dailyOperationalCostMode: "Operational Daily Cost",
      dailyOperationalCostModeOptions: {
        BOVEXO_COSTING: "BovExo-Calculated",
        USER_DEFINED: "User-Defined ($/Day)",
      },
      additionalSlaughterCostValue: "Additional Slaughter Costs",
      splitByOriginLot: "Split by Origin Lot",
    },
    messages: {
      errorNoDataFound: "No results were found with the given filter",
    },
  },
  exportReportLotStockModal: {
    title: "Batch Stock Report",
    form: {
      breedIds: "Breeds",
      lotIds: "Batches",
      supplierIds: "Suppliers",
      farmOwnerIds: "Owners",
    },
    messages: {
      errorNoDataFound: "No results were found with the given filter",
    },
  },
  farmReadFeederTreatmentParameter: {
    form: {
      freeScale: "Feeder Reading Scale",
      freeScaleOption: {
        default: "Default",
        free: "Free",
      },
      readFrequency: "Feeder Reading Frequency",
      readFrequencyOption: {
        readOnceADay: "Once a day",
        readAtEveryTreat: "At every feed",
        readInTreat: "During feedings",
      },
      applicationType: "Adjustment of Quantity should apply to",
      applicationTypeOption: {
        apply_equal_for_all_treats: "Uniform across all feedings",
        concentrated_on_last_treat: "Concentrated on the last feeding",
      },
      adjustmentType: "Feeder Reading Calculation",
      adjustmentTypeOption: {
        percent_original_matter: "% AF (As Fed)",
        percent_dry_matter: "% DM (Dry Matter)",
        kg_dry_matter: "kg DM (Dry Matter)",
      },
    },
    messages: {
      confirmAdjustmentTypeChange:
        "Changing the feeder reading calculation will clear the scale values, which must be entered again. Do you want to continue?",
      percentAboveLimit:
        'The percentage value of scale "{{scale}}" exceeded 25%, do you want to confirm?',
      successSave: "Feeder Reading Parameters saved successfully!",
      errorSave: "Error saving Feeder Reading Parameters",
    },
  },
  areaMap: {
    title: "Area Map",
    newArea: "New Area",
    clearAllAreas: "Clear All Areas",
    totalAreas: "Total",
    form: {
      title: "New Area",
      editTitle: "Edit Area",
      identificationCode: "Identification Code",
      identificationCodePlaceholder: "Enter the identification code",
      type: "Type",
      typePlaceholder: "Select the type",
      picketSelection: "Picket Selection",
      picketPlaceholder: "Select a picket",
      retreatSelection: "Retreat Selection",
      retreatPlaceholder: "Select a retreat",
      observation: "Observation",
      observationPlaceholder: "Enter an observation about the area",
      color: "Map marking color",
      colorPlaceholder: "Select a color",
      area: "Area in hectares",
      areaPlaceholder: "0.00",
      areaDescription: "Area calculated automatically from the drawn polygon",
      save: "Save",
      update: "Update",
      cancel: "Cancel",
    },
    colors: {
      red: "Red",
      green: "Green",
      blue: "Blue",
      yellow: "Yellow",
      magenta: "Magenta",
      cyan: "Cyan",
      orange: "Orange",
      purple: "Purple",
      darkGreen: "Dark Green",
      darkBlue: "Dark Blue",
      brown: "Brown",
      pink: "Pink",
    },
    types: {
      AGRICULTURA: "Agriculture",
      BENFEITORIAS: "Improvements",
      CONFINAMENTO: "Confinement",
      INTEGRACAO_LAVOURA_PECUARIA: "Crop-Livestock Integration",
      INTEGRACAO_LAVOURA_PECUARIA_FLORESTA: "Crop-Livestock-Forest Integration",
      INTEGRACAO_LAVOURA_FLORESTA: "Crop-Forest Integration",
      PASTAGEM: "Pasture",
      RESERVA: "Reserve",
      SILVICULTURA: "Silviculture",
    },
    messages: {
      mapLoadError: "Error loading map",
      mapLoadErrorDescription:
        "Please check if the Google Maps API key is configured correctly.",
      areasLoadError: "Error loading areas",
      areasLoadErrorDescription: "Could not load existing areas from the map.",
      polygonRequired: "Polygon required",
      polygonRequiredDescription: "Draw a polygon on the map before saving.",
      drawingHint: "Drawing mode active",
      drawingHintDescription:
        "Click on the map to add vertices. To finish, double-click or use the button below (minimum 3 vertices).",
      drawingVerticesLabel: "Vertices",
      drawingFinishButton: "Finish polygon",
      areaSaved: "Area saved successfully",
      areaSavedDescription: "Area of {area} hectares has been saved.",
      areaUpdated: "Area updated successfully",
      areaUpdatedDescription: "Area of {area} hectares has been updated.",
      areaSaveError: "Error saving area",
      areaSaveErrorDescription:
        "Could not save the area. Please contact support.",
      picketAlreadySelected:
        "The selected Picket or Retreat has already been selected in another area",
      loadingAreas: "Loading areas...",
      areaDeleted: "Area deleted successfully",
    },
    validation: {
      colorRequired: "Color is required",
      areaRequired: "Area is required",
      areaMin: "Area must be greater than 0",
    },
    centerCard: {
      infoMessage:
        "To center the map correctly, configure your property's location data.",
      configureLocation: "Configure Location",
      formTitle: "Configure Map Centering",
      savedLocation: "Configured Location",
      coordinates: "Coordinates",
      edit: "Edit",
      savedAt: "Saved on",
      form: {
        locationType: "Location Type",
        coordinates: "Coordinates (Lat/Lng)",
        address: "Address",
        addressPlaceholder: "Enter the property address",
        latitude: "Latitude",
        latitudePlaceholder: "Ex: -15.7801",
        longitude: "Longitude",
        longitudePlaceholder: "Ex: -47.9292",
        description: "Description (optional)",
        descriptionPlaceholder: "Ex: Farm headquarters, Main gate",
        save: "Save",
        cancel: "Cancel",
        loadingPlaces: "Loading address service...",
        geocoding: "Getting coordinates...",
      },
      validation: {
        locationTypeRequired: "Location type is required",
        addressRequired: "Address is required",
        latitudeRequired: "Latitude is required",
        longitudeRequired: "Longitude is required",
        latitudeMin: "Latitude must be greater than -90",
        latitudeMax: "Latitude must be less than 90",
        longitudeMin: "Longitude must be greater than -180",
        longitudeMax: "Longitude must be less than 180",
      },
      messages: {
        saved: "Location saved successfully",
        savedDescription:
          "The map will be centered on the configured location.",
        saveError: "Error saving location",
        saveErrorDescription: "Could not save the location. Please try again.",
        placesApiError: "Error loading Google Places",
        placesApiErrorDescription:
          "Could not load the address autocomplete service.",
        geocodingWarning: "Geocoding Warning",
        geocodingWarningDescription:
          "Could not get coordinates for the address. Please verify the address is correct.",
      },
    },
    modal: {
      title: "Area Information",
      identificationCode: "Identification Code",
      type: "Type",
      picketName: "Picket Name",
      retreatName: "Retreat Name",
      areaSquareMeters: "Area (m²)",
      areaHectares: "Area (hectares)",
      observation: "Observation",
      deleteButton: "Delete Area",
      deleteConfirmTitle: "Confirm Deletion",
      deleteConfirmMessage:
        "Are you sure you want to delete this area? This action cannot be undone.",
      deleteConfirmOk: "Yes, delete",
      deleteConfirmCancel: "Cancel",
      tabs: {
        details: "Area Details",
        production: "Production",
        history: "History",
        observations: "Observations",
      },
      details: {
        status: "Status",
        picketProductionSubSystem: "Activity",
        identificationCode: "Identification Code",
        type: "Type",
        picketName: "Picket/Pen Name",
        areaSquareMeters: "Area (m²)",
        areaHectares: "Area (hectares)",
        picketPastureName: "Forage",
        areaObservations: "Area Observations",
      },
      production: {
        stockingRate: "Stocking Rate",
        animalInfo: "Animal Information",
        activeAnimals: "ACTIVE ANIMALS",
        dataReference: "Data referring to",
        averageWeight: "Average weight",
        averageWeightProjected: "Projected average weight",
        averageGdp: "Average GDP",
        averageAge: "Average age",
        months: "Months",
        kg: "kg",
      },
      history: {
        title: "Lot History",
        recentLot: "Lot History - Most recent lot",
        lotName: "Lot Name",
        entryDate: "Entry",
        exitDate: "Exit",
        totalDays: "Total days",
        viewAll: "View all",
      },
      observations: {
        title: "Picket Observations",
        timeline: "Timeline",
      },
      status: {
        A: "Active",
        B: "Break",
        P: "Pasturage",
        R: "Renovation",
        M: "Maintenance",
        L: "Leased",
        D: "Deleted",
        X: "Farm Excluded",
        I: "Inactive",
        Break: "Resting",
        Pasturage: "Grazing",
        Renovation: "Renovation",
        Maintenance: "Maintenance",
        Leased: "Leased",
        Deleted: "Deleted",
        Active: "Active",
        Inactive: "Inactive",
      },
      picketProductionSubSystem: {
        extensive: "Extensive",
        semiIntensive: "Semi-Intensive",
        intensive: "Intensive",
      },
    },
  },
  excelExport: {
    buttonText: "Export",
    modalTitle: "Export to Excel",
    fields: {
      exportName: "Report Name",
      columns: "Columns",
      filters: "Filters",
    },
    placeholders: {
      exportName: "Enter report name",
      inOperator: "Separated by commas",
    },
    operators: {
      EQ: "Equal",
      NEQ: "Not Equal",
      GT: "Greater Than",
      LT: "Less Than",
      GTE: "Greater or Equal",
      LTE: "Less or Equal",
      LIKE: "Contains",
      IN: "In",
      BETWEEN: "Between",
    },
    buttons: {
      export: "Export",
      selectAllColumns: "Select All",
      deselectAllColumns: "Deselect All",
    },
    validation: {
      exportNameRequired: "Report name is required",
    },
    successMessage: "File exported successfully!",
    errorMessage: "Error exporting file. Please try again.",
  },
  importAnimalBirth: {
    title: "Import Births and Reproductive Losses",
    message:
      "Import the file of births and reproductive losses for the system.",
    draggerMessage: "Click or drag the file to this area to upload",
  },
  stockItem: {
    pageTitle: "Supply Inventory",
    tabs: {
      stockItems: "Stock Items",
      materialMovements: "Movements",
      pendencies: "Pendencies",
      audit: "Audit",
      parameters: "Parameters",
    },
    summaryCards: {
      stockValue: "Stock Value",
      totalQty: "Total Qty",
      items: "Items",
      belowReplenishment: "Below Replenishment",
    },
    table: {
      internalId: "Identification",
      abbreviation: "Abbrev",
      group: "Group",
      subgroup: "Subgroup",
      currentQty: "Current Qty",
      unit: "Unit",
      replenishmentPoint: "Replenishment",
      currentCost: "Current Cost",
      value: "Value",
      actions: "Actions",
    },
    searchPlaceholder: "Search by ID, abbreviation or description...",
    toggleInactive: "Inactive",
    toggleActive: "Active",
    newItem: "New Item",
    drawerLabels: {
      internalId: "Identification",
      abbreviation: "Abbreviation",
      description: "Description",
      group: "Group",
      subgroup: "Subgroup",
      unit: "Unit",
      currentQty: "Current Qty",
      replenishmentPoint: "Replenishment Point",
      currentCost: "Current Cost",
      lastPurchaseCost: "Last Purchase Cost",
      lastPurchaseDate: "Last Purchase Date",
      lastSupplier: "Last Supplier",
      notes: "Notes",
      variantControl: "Variant Control",
      batchControl: "Batch Control",
      variantsAndBatches: "Variants & Batches",
      variants: "Variants",
      batches: "Batches",
      dietItem: "Diet Item",
      supplementSupplierId: "Supplier",
      supplementGroup: "Supplement Group",
      supplementSubGroup: "Supplement Subgroup",
      supplementPresentation: "Presentation",
      nutritionalDetails: "Nutritional Details",
      cost: "Cost",
      dryMatterPercentage: "Dry Matter %",
      ndt: "TDN: Total Digestible Nutrients",
      pb: "CP: Crude Protein",
      ee: "Ethereal Extract",
      fdn: "NDF",
      fda: "ADF",
      ca: "Calcium",
      p: "Phosphorus",
      k: "Potassium",
      s: "Sulfur",
      na: "Sodium",
      zinc: "Zinc",
      manufacturer: "Manufacturer",
      veterinarySupplement: "Veterinary Item",
      type: "Type",
      name: "Brand name",
      supplierId: "Supplier",
      applicationGender: "Gender",
      applicationType: "Administration route",
      applicationValue: "Administration amt.",
      applicationWeightValueParam: "Weight",
      unitId: "Unit used",
      applicationCost: "Administration cost",
      originalSupplement: "Original Supplement/Product",
    },
    journal: {
      tabs: { details: "Details", movements: "Movements" },
      searchPlaceholder: "Search by invoice or requester...",
      filter: {
        type: "Type",
        origin: "Origin",
        startDate: "Start date",
        endDate: "End date",
        clear: "Clear filters",
      },
      sort: {
        label: "Sort by",
        movementDate: "Movement date",
        createdAt: "Registration date",
        amount: "Quantity",
        unitCost: "Unit cost",
        cost: "Total cost",
        ascending: "Ascending order",
        descending: "Descending order",
      },
      card: {
        amount: "Quantity",
        unitCost: "Unit Cost",
        cost: "Total Cost",
        cmpResult: "Avg. Cost (WAC)",
        amountBalance: "Qty. Balance",
        costBalance: "Cost Balance",
        invoice: "Invoice",
        requester: "Requester",
        createdAt: "Registered at",
      },
      viewInvoice: "View Invoice",
      total: "{count} movement(s)",
      empty: "No movements found.",
      loadError: "Error loading the item movements.",
    },
    form: {
      internalId: "Identification",
      abbreviation: "Abbreviation",
      description: "Description",
      group: "Group",
      subgroup: "Subgroup",
      measurementUnit: "Measurement Unit",
      replenishmentPoint: "Replenishment Point",
      currentCost: "Current Cost ($)",
      variantControl: "Variant Control",
      batchControl: "Batch Control",
      notes: "Additional Notes",
      dietItem: "Diet Item",
      product: "Product",
      supplementSupplierId: "Supplement Supplier",
      supplementGroup: "Supplement Group",
      supplementSubGroup: "Supplement Subgroup",
      supplementPresentation: "Presentation",
      nutritionalDetails: "NUTRITIONAL DATA",
      supplementTypeNew: "New",
      supplementTypeExisting: "Existing",
      veterinarySupplement: "Veterinary Item",
      veterinaryDetails: "VETERINARY SUPPLEMENT DATA",
      veterinarySupplementTypeNew: "New",
      veterinarySupplementTypeExisting: "Existing",
      veterinarySupplementId: "Veterinary Supplement",
      type: "Type",
      name: "Brand name",
      supplierId: "Supplier",
      applicationGender: "Gender",
      applicationType: "Administration route",
      applicationValue: "Administration amt.",
      applicationWeightValueParam: "Weight",
      unitId: "Unit used",
      applicationCost: "Administration cost",
      cost: "Cost",
      dryMatterPercentage: "Dry Matter %",
      ndt: "TDN: Total Digestible Nutrients",
      pb: "CP: Crude Protein",
      ee: "Ethereal Extract",
      fdn: "NDF",
      fda: "ADF",
      ca: "Calcium",
      p: "Phosphorus",
      k: "Potassium",
      s: "Sulfur",
      na: "Sodium",
    },
    auditWarning:
      "Fields marked with ⚡ require another user's approval to take effect.",
    pendingAuditAlert:
      "Item locked — There are pending changes awaiting audit approval. Editing and movements are blocked until resolved.",
    confirmInactivate: 'Are you sure you want to inactivate "{description}"?',
    confirmReactivate: 'Are you sure you want to reactivate "{description}"?',
    confirmDelete:
      'Are you sure you want to delete "{description}"? This action cannot be undone.',
    saveOptions: {
      savedSuccess: "Item saved successfully!",
      deletedSuccess: "Item deleted successfully.",
      inactivatedSuccess: "Item inactivated.",
      reactivatedSuccess: "Item reactivated.",
    },
    error: {
      loadError: "Error loading stock items.",
      saveError: "Error saving item.",
      deleteError: "Error deleting item.",
    },
    movements: {
      summary: { entries: "Entries", exits: "Exits", pending: "Pending" },
      searchPlaceholder: "Search by item, ID or invoice...",
      filter: {
        all: "All",
        entries: "Entries",
        exits: "Exits",
        inactive: "Inactivated",
      },
      buttons: { newEntry: "Entry", newExit: "Exit" },
      table: {
        id: "ID",
        type: "Type",
        origin: "Origin",
        item: "Item",
        batch: "Batch",
        quantity: "Quantity",
        unitCost: "Unit Cost",
        measurementUnit: "Measurement Unit",
        nf: "Invoice",
        status: "Status",
        date: "Date",
        user: "User",
        actions: "Actions",
        totalCost: "Total Cost",
        createdAt: "Created At",
      },
      type: { entry: "Entry", exit: "Exit" },
      status: {
        pending: "Pending",
        completed: "Completed",
        audit: "Audit",
        inactive: "Inactive",
        processing: "Processing",
        error: "Error",
      },
      entryOrigins: {
        purchase: "Purchase",
        adjustment: "Adjustment",
        transfer: "Transfer",
        return: "Return",
        production: "Production",
      },
      exitOrigins: {
        sale: "Sale",
        withdrawal: "Withdrawal",
        loss: "Loss",
        adjustment: "Adjustment",
        transfer: "Transfer",
        productionConsumption: "Production Consumption",
      },
      form: {
        title: { entry: "Material Entry", exit: "Material Exit" },
        origin: "Origin",
        documentType: "Document Type",
        nfReference: "Invoice Number",
        documentTypes: {
          invoice: "Invoice",
          simpleRemittance: "SR (Simple Remittance)",
          internalDoc: "Internal Doc.",
        },
        nfDate: "Issue Date",
        receiptDate: "Receipt Date",
        issueDate: "Issue Date",
        productionDate: "Production Date",
        supplier: "Supplier",
        cpfCnpj: "Tax ID",
        requester: "Requester",
        materials: "Materials",
        addItem: "Add Item",
        totalCost: "Total Items Cost",
        stockItem: "Stock Item",
        variant: "Variant",
        newVariant: "+ New variant",
        batch: "Batch",
        newBatch: "+ New batch",
        manufacturer: "Manufacturer",
        batchNumber: "Batch Number",
        serialNumber: "Serial Number",
        specification: "Specification",
        measurementUnit: "Measurement Unit",
        quantity: "Quantity",
        unitCost: "Unit Cost",
        expiration: "Expiration",
        expirationMode: { date: "Date", days: "Days" },
        locations: "Locations",
        location: {
          warehouse: "Warehouse",
          shelf: "Shelf",
          rack: "Rack",
          drawer: "Drawer",
          deposit: "Deposit",
          tank: "Tank",
        },
        conversion: {
          title: "Unit Conversion (Invoice → Stock)",
          nfQty: "Invoice Qty",
          nfUnit: "Invoice Unit",
          factor: "Factor",
          nfUnitCost: "Invoice Unit Cost",
          stockUnit: "Stock Unit",
        },
        observations: "Observations",
        loadXml: "Load XML",
        loadPdf: "Load PDF",
        view: "View",
        pendingHint:
          'If the invoice has not yet been registered in the Financial module, the movement will be set to "Pending".',
        auditHint:
          "This movement will create a pending item for approval by another user.",
        financialTransaction: {
          title: "Linked Financial Expense",
          mainValueHelp:
            "Value automatically calculated from the total cost of this movement's items (quantity x unit cost).",
        },
      },
      detail: {
        title: "Movement Details",
        generalInfo: "General Information",
        itemInfo: "Item",
        observations: "Observations",
        viewNfe: "View Invoice",
        delete: "Delete",
        blocked:
          "Movement blocked — There is a deletion request pending audit approval.",
      },
      deleteConfirm: {
        title: "Request Movement Deletion",
        description:
          "An audit record will be created and the deletion must be approved by a second user. While pending, this movement and related items will be blocked.",
        confirm: "Confirm Deletion",
      },
      duplicateNf: {
        title: "Invoice already registered",
        cancel: "Cancel movement",
        continue: "Continue anyway",
      },
      saveOptions: {
        savedSuccess: "Movement(s) saved successfully!",
        deleteRequested: "Deletion request sent for audit.",
      },
      error: {
        loadError: "Error loading movements.",
        saveError: "Error saving movement.",
        originRequired: "Select the movement origin.",
        requesterRequired: "Enter the requester.",
        receiptDateRequired: "Enter the receipt date.",
        supplierRequired: "Select the supplier.",
        stockItemRequired: "Select the stock item.",
        manufacturerRequired: "Select the manufacturer.",
        measurementUnitRequired: "Select the measurement unit.",
        conversionFactorRequired: "Enter the conversion factor.",
        quantityRequired: "Enter the quantity.",
        costRequired: "Enter the unit cost.",
        lineRequired: "Add at least one item with quantity.",
      },
      emptyTable: "No movements found.",
      notifications: {
        batchCreated: "Batch created successfully",
        errorBatchCreated: "Error creating batch",
        variantCreated: "Variant created successfully",
        errorVariantCreated: "Error creating variant",
      },
    },
  },
  importAnimalVaccination: {
    title: "Import Vaccinations",
    message:
      '<p class="message">Download the <strong>template below, complete the spreadsheet</strong> with the vaccinations, <strong>import it</strong>, and then click process vaccinations</p>',
    draggerMessage: "Click or drag the file to this area to upload",
    identificationLabel: "Identification*",
    identification: "Identification",
    electronicId: "Electronic Id",
    sisbov: "SISBOV",
    successMessage: "Vaccinations in processing",
    successDescription:
      "Your file is being processed, please wait. You will be notified when all vaccinations are processed.",
    errorMessage: "Error importing",
    errorDescription: "No vaccination was included.",
  },
  register: {
    title: "User registration",
    subtitle: "Fill in the fields below to start registration",
    form: {
      registrationEmail: "Registration e-mail",
      fullname: "Full name",
      document: "CPF",
      contact: "Contact",
      address: "Address",
      addressNumber: "Number",
      neighborhood: "Neighborhood",
      placeholder: "Enter here...",
    },
    step2: {
      title: "Registration confirmation",
      subtitle:
        "Please copy and paste the code sent to your e-mail into the field below.",
      codePlaceholder: "Enter the code here",
      resendCode: "Resend code",
      password: "Password",
      confirmPassword: "Confirm password",
      confirmPasswordPlaceholder: "Confirm password",
    },
    step4: {
      title: "Choose a payment method",
      creditCard: "Credit Card",
      bankSlip: "Bank Slip",
      differentHolderData: "Cardholder data different from registration",
      holderName: "Cardholder name",
      cardNumber: "Card Number",
      cardExpiration: "Expiration date",
      cardCVV: "Security code",
      dueDateTitle: "Choose the invoice due date",
      dueDatePlaceholder: "Select a date",
      form: {
        dayPrefix: "Day",
      },
    },
    messages: {
      emailAlreadyRegistered: "E-mail already registered in our database",
      emailInvalid: "Invalid e-mail.",
      emailInvalidUrl: "The e-mail in the URL is in an invalid format",
      emailRequired: "Please provide an e-mail.",
      nameRequired: "A name is required.",
      cpfInvalid: "The CPF provided is invalid, please enter another.",
      phoneInvalid:
        "The phone number provided is invalid, please enter another.",
      validationCodeSent: "Validation code sent to e-mail.",
      internalError: "Internal error. Please contact support.",
      registrationErrorCpf:
        "Registration error. CPF already registered in our system.",
      registrationError: "Registration error",
      notRobot: "Prove you are not a robot",
      codeInvalid: "Invalid code",
      dueDateInvalid: "Invalid invoice due date.",
      holderNameRequired: "Cardholder name is required.",
      cpfInvalidPayment: "Invalid CPF.",
      cardNumberInvalid: "Invalid card number.",
      cardExpirationInvalid: "Invalid expiration date.",
      cardCvvInvalid: "Invalid security code.",
      trialEnvironmentReady:
        "Your demo environment is ready and you can now log in.",
      trialEnvironmentCreating:
        "Your demo environment is being created, we will send you an e-mail when it is ready.",
      registerGroupFarm: "Now register a group and a farm",
      codeVerified: "Code verified successfully",
    },
    drawer: {
      title: "Complete data",
      codeInstructions:
        "A code was sent to the provided e-mail, copy and paste it in the field below",
      codeInputPlaceholder: "ENTER THE CODE HERE",
      resendCode: "RESEND CODE",
      verified: " Verified",
      validate: "Validate",
      definePassword: "Set your access password",
      newPassword: "New password",
      confirmNewPassword: "Confirm new password",
      address: "Address",
      processing: "Processing",
    },
  },
  changePassword: {
    title: "Recover my password",
    subtitle: "Enter your registration e-mail below",
    back: "Back",
    registrationEmail: "Registration e-mail",
    placeholder: "Enter here...",
    submitButton: "Recover password",
    emailNotRegistered: "E-mail not registered, please enter a valid e-mail",
    messages: {
      codeSent: "The verification code was sent to the provided e-mail",
      somethingWentWrong: "Something went wrong, please try again later",
    },
    drawer: {
      title: "Change password",
      codeInstructions:
        "A code was sent to the provided e-mail, copy and paste it in the field below",
      codeInputPlaceholder: "ENTER THE CODE HERE",
      resendCode: "RESEND CODE",
      verified: " Verified",
      validate: "Validate",
      definePassword: "Set your access password",
      newPassword: "New password",
      confirmNewPassword: "Confirm new password",
      messages: {
        codeSent: "Validation code sent to e-mail.",
        emailAlreadyRegistered: "E-mail already registered in our database",
        internalError: "Internal error. Please contact support.",
        codeVerified: "Code verified successfully",
        codeInvalid: "Invalid code",
        passwordChanged: "Password successfully reset!",
        notRobot: "Prove you are not a robot",
        passwordUsedBefore: "Password already used previously.",
        errorResettingPassword: "Error resetting password.",
      },
    },
    logged: {
      title: "Reset password",
      definePassword: "Set your access password",
      newPassword: "New password",
      confirmNewPassword: "Confirm new password",
      passwordMismatch: "Values do not match",
      messages: {
        passwordChanged: "Password successfully reset!",
        passwordUsedBefore: "Password already used previously.",
        errorResettingPassword: "Error resetting password.",
      },
    },
  },
  login: {
    title: "Login",
    subtitle: "Log in to the platform and manage your farm",
    loginLabel: "LOGIN",
    passwordLabel: "password",
    usernamePlaceholder: "Enter your registration e-mail",
    passwordPlaceholder: "Enter your registration password",
    showPassword: "Show password",
    submitButton: "Log in",
    forgotPassword: "Forgot your password?",
    forgotPasswordLink: "Click here!",
    messages: {
      notRobot: "Prove you are not a robot",
    },
  },
  accessConfirmation: {
    title: "It seems you do not have a registration yet",
    subtitle: "Fill in the fields below to register your user",
    passwordMismatch: "Password and password confirmation do not match",
    emailLabel: "Email",
    fullnameLabel: "Full name*",
    documentLabel: "CPF*",
    birthdayLabel: "Date of Birth*",
    contactLabel: "Contact*",
    newPasswordLabel: "New password",
    confirmNewPasswordLabel: "Confirm new password",
    termText: "By checking the box you agree to the",
    termLink: "terms and conditions of use",
    termTextEnd: "of the Bovexo system",
    placeholder: "Enter here...",
    messages: {
      registerError: "Could not register user",
      documentAlreadyExists: "A user is already registered with this document",
    },
    justConfirm: {
      title: "Invitation confirmed!",
      subtitle: "Click the button below and log in.",
      button: "OK, GOT IT",
    },
    alreadyConfirm: {
      title: "Invitation already confirmed",
      subtitle: "Click the button below and log in.",
      button: "OK, GOT IT",
    },
    expirated: {
      title: "Invitation expired!",
      subtitle:
        "Please wait or contact the responsible person to resend the invitation",
      button: "OK, GOT IT",
    },
  },
  accessInvitations: {
    inviteButton: "Invite",
    resendInvite: "Resend invitation",
    statusSended: "Invitation sent",
    statusExpirated: "Invitation expired",
    statusAccepted: "Invitation accepted",
    statusCanceled: "Invitation canceled",
    columnEmail: "E-mail",
    columnSentAt: "Sent at",
    columnExpiresAt: "Expires at",
    messages: {
      fetchError: "Could not retrieve invitations",
      resubmitSuccess: "Invitation resent",
      resubmitError: "An error occurred while resending the invitation",
    },
  },
  supplierManagement: {
    buttons: {
      invite: "Invite",
    },
    table: {
      columns: {
        businessName: "Business Name",
        fantasyName: "Trade Name",
        documentNumber: "CNPJ",
      },
      menu: {
        edit: "Edit",
        resendInvite: "Resend invitation",
      },
    },
    messages: {
      fetchError: "Could not retrieve invitations",
      resendSuccess: "Email resent successfully!",
      resendError: "An error occurred while trying to resend the emails!",
      saveSuccess: "Contract successfully completed!",
      saveError:
        "An error occurred while trying to save the group information!",
      loadError: "An error occurred while accessing the information.",
    },
    form: {
      back: "Back",
      title: "Supplier groups and companies",
      subtitle: "Fill in the form below to invite a new supplier user",
      groupNameLabel: "Business Name*",
      groupFantasyNameLabel: "Trade Name*",
      documentLabel: "CNPJ*",
      managerSectionTitle: "Manager",
      nameLabel: "Name*",
      emailLabel: "E-mail*",
      phoneLabel: "Phone*",
      companiesSectionTitle: "Companies",
      companyNameLabel: "Business Name*",
      fantasyNameLabel: "Trade Name*",
      placeholder: "Enter here...",
      save: "Save",
    },
    validation: {
      groupNameRequired: "Group Business Name is required.",
      groupFantasyNameRequired: "Group Trade Name is required.",
      documentNumberRequired: "Group CNPJ is required.",
      documentNumberInvalid: "Invalid Group CNPJ.",
      managerRequired: "At least 1 Manager is required.",
      companyRequired: "At least 1 Company is required.",
      managerNameRequired: "Manager Name is required.",
      managerEmailRequired: "Manager Email is required.",
      managerEmailInvalid: "Invalid Manager Email.",
      managerPhoneRequired: "Manager Phone is required.",
      managerPhoneInvalid: "Invalid Manager Phone.",
      companyNameRequired: "Company Business Name is required.",
      companyFantasyNameRequired: "Company Trade Name is required.",
      companyDocumentRequired: "Company CNPJ is required.",
      companyDocumentInvalid: "Invalid Company CNPJ.",
    },
  },
  supplierGroup: {
    invites: {
      title: "Invitations",
      buttons: {
        invite: "Invite",
      },
      table: {
        columns: {
          name: "Name",
          email: "Email",
        },
        menu: {
          resendInvite: "Resend invite",
        },
      },
      status: {
        sent: "Sent",
        confirmed: "Confirmed",
        cancelled: "Cancelled",
      },
      messages: {
        fetchError: "Could not retrieve invitations",
        resendSuccess: "Email resent successfully!",
        resendError: "An error occurred while trying to resend the emails!",
        saveSuccess: "Invitation registered successfully",
        saveError: "An error occurred while registering the invitation",
      },
      drawer: {
        title: "Invite",
        subtitle: "Fill in the fields below to invite a collaborator",
        labels: {
          name: "Name*",
          email: "E-mail*",
          accessProfile: "Access Profile*",
          companies: "Company(ies)*",
          selectCompanyMessage: "Select the company to be managed by this user",
        },
        roles: {
          manager: "Manager",
          collaborator: "Collaborator",
        },
      },
    },
    collaborators: {
      title: "Collaborators",
      table: {
        columns: {
          name: "Name",
          email: "Email",
          profile: "Profile",
          company: "Company",
        },
      },
      messages: {
        fetchError: "Could not retrieve invitations",
      },
      roles: {
        collaborator: "Collaborator",
        admin: "Manager",
      },
    },
  },
  inviteUser: {
    drawerTitle: "Invite user",
    subtitle: "Fill in the fields below to invite a collaborator",
    labels: {
      email: "E-mail*",
      accessProfile: "Access Profile*",
      group: "Group*",
      farms: "Farm(s)*",
      selectFarmMessage: "Select the farm to be managed by this user",
    },
    roles: {
      farmAdmin: "Farm Administrator",
      technician: "Technician",
    },
    messages: {
      saveSuccess: "Invitation registered successfully",
      saveError: "An error occurred while registering the invitation",
    },
  },
  registerSupplierGroup: {
    pageTitle: "User Registration",
    pageSubtitle: "Fill in the form below to access bovexo",
    labels: {
      fullName: "Full Name*",
      contact: "Contact*",
      cpf: "CPF*",
      password: "Password*",
      confirmPassword: "Confirm Password*",
    },
    placeholders: {
      password: "Password",
      confirmPassword: "Confirm password",
    },
    term: {
      checkboxText: "By checking the box you agree with the",
      linkText: "terms and conditions of use",
      suffix: "of the Bovexo system",
    },
    buttons: {
      save: "Save",
    },
    messages: {
      fetchError: "Could not retrieve invitation information",
      saveSuccess: "Registration completed successfully!",
      cpfAlreadyExists:
        "Registration error. CPF already registered in our system.",
      emailAlreadyExists:
        "Registration error. E-mail already registered in our system.",
      saveError: "An error occurred while trying to save the information!",
    },
    validation: {
      fullNameRequired: "Name is required.",
      phoneRequired: "Phone is required.",
      phoneInvalid: "Invalid Phone.",
      cpfInvalid: "The provided CPF is invalid, please enter another.",
      passwordRequired: "Password is required.",
      confirmPasswordRequired: "Password confirmation is required.",
      passwordMismatch: "Password and Password Confirmation must match.",
      termRequired: "You must accept the terms of service.",
    },
  },
  changeEmail: {
    drawer: {
      title: "Change e-mail",
      codeFromInstructions:
        "A code was sent to your e-mail, copy and paste it in the field below",
      codeFromPlaceholder: "Enter the code here",
      codeToInstructions:
        "A code was sent to your new e-mail, copy and paste it in the field below",
      codeToPlaceholder: "Enter the code here",
      newEmailInstructions: "Enter your new e-mail in the field below",
      newEmailPlaceholder: "Enter the e-mail",
      resendCode: "Resend code",
      updateButton: "Update",
      verified: " Verified",
      validate: "Validate",
      messages: {
        codeSentFrom: "Validation code sent to e-mail.",
        codeSentTo: "Validation code sent to new e-mail.",
        userNotFound: "User not found.",
        internalError: "Internal error. Please contact support.",
        emailAlreadyExists: "The provided e-mail already exists.",
        codeInvalid: "Invalid code.",
        emailInvalid: "Invalid e-mail",
      },
    },
  },
  common: {
    marketingTagline: "Decisions that fatten your wallet",
    nav: {
      contactUs: "contact us",
      aboutUs: "about us",
      support: "support",
    },
    address: {
      zipCode: "ZIP Code",
      sectionTitle: "ADDRESS",
      numberAddon: "No.",
      complementAddon: "Apt.",
    },
    cpf: "Tax ID (CPF)",
    time: {
      days: "days",
      months: "months",
      dayPrefix: "Day",
    },
  },
  weightGainProjection: {
    title: "Weight Gain Projections",
    buttonNew: "New Projection",
    table: {
      status: "Status",
      name: "Name",
      informType: "Inform Type",
    },
    form: {
      title: "Weight Gain Projection",
      name: "Name",
      namePlaceholder: "Enter name",
      informType: "Inform Type",
      timeUnitReference: "Time Unit",
      fixedGmdWeight: "Fixed GMD (kg)",
      supplement: "Supplement",
      supplementPlaceholder: "Select a supplement (optional)",
      addPeriod: "Add Period",
      period: "Period",
      gmdWeight: "GMD (kg)",
      deleteLastOnly: "Only the last period can be deleted",
      periodMustBeGreaterError:
        "The entered period ({period}) must be greater than the last added period ({lastPeriod})",
      chart: {
        title: "GMD (kg)",
        fixed90days: "90-day fixed projection",
      },
      radiogroup: {
        farm: "Farm",
        group: "Group",
      },
    },
    informType: {
      period: "Period",
      fixed: "Fixed",
    },
    timeUnit: {
      day: "Day",
      week: "Week",
    },
    status: {
      active: "Active",
      inactive: "Inactive",
    },
    notification: {
      success: {
        create: { message: "Projection created successfully" },
        update: { message: "Projection updated successfully" },
        activate: { message: "Projection activated" },
        inactivate: { message: "Projection inactivated" },
      },
      error: {
        save: { message: "Failed to save projection" },
        activate: { message: "Failed to activate projection" },
      },
    },
  },
  groupItem: {
    title: "Group",
    buttonNew: "New Item Group",
    table: {
      columns: {
        status: "Status",
        name: "Name",
      },
      inactivateSuccess: "Item Group inactivated successfully!",
      inactivateError: "Error inactivating Item Group. Contact support.",
      activateSuccess: "Item Group activated successfully!",
      activateError: "Error activating Item Group. Contact support.",
    },
    form: {
      titleCreateNew: "New Item Group",
      titleEdit: "Edit Item Group",
      groupFarmVisibility: "Visibility",
      name: "Name",
      description: "Description",
      externalIntegrationCode: "Integration Code",
      status: "Status",
      successMessage: "Item Group saved/updated successfully.",
      errorMessage: "Error saving/editing Item Group.",
    },
  },
  itemsGroup: {
    title: "Subgroup",
    buttonNew: "New Group Item",
    table: {
      columns: {
        status: "Status",
        name: "Name",
        groupItemName: "Item Group",
      },
      inactivateSuccess: "Group Item inactivated successfully!",
      inactivateError: "Error inactivating Group Item. Contact support.",
      activateSuccess: "Group Item activated successfully!",
      activateError: "Error activating Group Item. Contact support.",
    },
    form: {
      titleCreateNew: "New Group Item",
      titleEdit: "Edit Group Item",
      groupFarmVisibility: "Visibility",
      name: "Name",
      description: "Description",
      externalIntegrationCode: "Integration Code",
      status: "Status",
      groupItemId: "Item Group",
      successMessage: "Group Item saved/updated successfully.",
      errorMessage: "Error saving/editing Group Item.",
    },
    select: {
      selectGroupItemFirst: "Select an Item Group first",
    },
    classify: {
      title: "Classify Group Item",
      classification: "Classification",
      classificationPlaceholder: "Select a classification",
      supplement: "Supplement",
      veterinarySupplement: "Veterinary Supplement",
      successMessage: "Group Item classified successfully!",
      errorMessage: "Error classifying Group Item. Contact support.",
      name: "Name",
      description: "Description",
      externalIntegrationCode: "Integration Code",
      groupItemName: "Item Group",
      status: "Status",
    },
  },
  wagon: {
    table: {
      title: "Mixers",
      columns: {
        name: "Name",
        integrationCode: "Integration Code",
        capacityKg: "Capacity (Kg)",
        observations: "Observations",
        status: "Status",
      },
    },
    buttonNew: "New Mixer",
    drawer: {
      titleNew: "New Mixer",
      titleEdit: "Edit Mixer",
      subTitle: "Fill in the fields below to register a new mixer",
      form: {
        name: "Name",
        integrationCode: "Integration Code",
        capacityKg: "Capacity (Kg)",
        observations: "Observations",
      },
    },
    messages: {
      saveSuccess: "Mixer registered successfully",
      saveError: "Error registering mixer",
      updateSuccess: "Mixer updated successfully",
      updateError: "Error updating mixer",
      activateError: "Failed to activate mixer. Contact support",
      inactivateError: "Failed to inactivate mixer. Contact support",
      nameAlreadyExists: "A mixer with this name already exists",
      integrationCodeAlreadyExists:
        "A mixer with this integration code already exists",
    },
  },
};
